const Library_mobile_arSA = {
  "processor": [
    {
      "contentType": "OTHER_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "مشغل بواسطة معالج [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_PROCESSORS_A",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "مشغل بواسطة معالج [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "FALLBACK_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "وهو يتحكم، مثلما يفعل الدماغ، بما يفعله الكمبيوتر. بعبارة أخرى، إن مقاطع الفيديو التي تشاهدها والألعاب التي تشغلها ومواقع الويب التي تزورها كلها تبدأ من المعالج.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "إن المعالج هو دماغ الكمبيوتر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_OLD_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_title": "الأداء والقيمة.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "معالج Intel®‎ Pentium®‎ Silver",
                    "tr_subtitle": "واكب أحدث تطوّرات العالم الرقمي من خلال أداء فائق يضمن الوصول إلى الملفات من الويب. تعدد المهام بطريقة بسيطة عن طريق التبديل بسهولة بين البرامج وإنجاز المزيد في وقت أقل.",
                    "tr_gen_core_title": "معالج Intel®‎ Pentium®‎ Silver"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "معالج Intel®‎ Pentium®‎ Gold",
                    "tr_subtitle": "إنتاجية مُحسَّنة - نسبة أداء مرتفع مقارنةً باستهلاك الطاقة خلال أيامك الأكثر تطلبًا. تصفح انسيابي للويب - حمّل صفحات الويب الغنية بالوسائط بسرعة لمزيد من الاستكشاف وتقليل الانتظار.",
                    "tr_gen_core_title": "معالج Intel®‎ Pentium®‎ Gold"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "معالج Intel®‎ Celeron®‎",
                    "tr_subtitle": "أداء يزيد نسبة عملك وترفيهك. استمتع بالأفلام ومقاطع الفيديو على الويب بتفاصيل مذهلة. استفد من وقتك في العمل بدلًا من الانتظار.",
                    "tr_gen_core_title": "معالج Intel®‎ Celeron®‎"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "معالج Intel®‎ Pentium®‎",
                    "tr_subtitle": "مصممة من أجل الحصول على إمكانيات رائعة للترفيه ومشاهدة الفيديو مباشرة عبر الإنترنت والإنتاجية.  استمتع بالأفلام ومقاطع الفيديو على الويب بتفاصيل مذهلة. استفد من وقتك في العمل بدلًا من الانتظار.",
                    "tr_gen_core_title": "معالج Intel®‎ Pentium®‎"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CELERON_2.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_2.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_INSIDE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/intel_inside/intel_inside_processor_badge.svg",
                "tileBG": "assets/images/intel_inside/intel_inside_home_tile.svg",
                "detailBGUrl": "assets/images/intel_inside/panel1_bg.svg",
                "tr_subtitle": "الأداء الذي تحتاج إليه. التكلفة المعقولة التي تريدها.",
                "tr_title": "معالج Intel®‎",
                "panelType1": "header-IconTop",
                "panelType2": "intel-inside-image-panel",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "قيمته في فئة لا مثيل لها",
                    "tr_subtitle": "يمكن لمعالج Intel®‎ التعامل مع أي مهمة تحتاج بسعرٍ في متناولك. انتقل من برنامجٍ للتالي بسهولةٍ. أو تمتع برسوميات عالية الجودة مع الأداء الثابت.",
                    "imageUrl": "assets/images/intel_inside/panel2_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "اتصال وتواصل أقوى",
                    "tr_subtitle": "تمكنك جودة الفيديو الأزهى ووضوح الصوت الثري واتصال بالإنترنت أسرع بمعدل 3 مرات تقريبًا بالمشاركة بثقة أينما احتجت لذلك.<sup>26</sup>",
                    "imageUrl": "assets/images/intel_inside/panel3_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "الفرق واضح كما الليل والنهار",
                    "tr_subtitle": "من تتابع مشاهدة الأفلام صباحًا وصولًا إلى تحسينات اللحظات الأخيرة، يطوّل معالج Intel®‎ عمر بطارية جهازك لتتمتع بخبرات غامرة حقًا وغير منقطعة.",
                    "imageUrl": "assets/images/intel_inside/panel4_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "جميع البيئات بيئات تعلّم",
                    "tr_subtitle": "شغّل عدة أدوات تعلم عبر الإنترنت بسهولة من جميع أركان منزلك."
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "تعلّم أينما أردت",
                    "tr_subtitle": "أنهِ الدروس أينما احتجت بينما تشغل عدة أداوت تعلم إلكتروني في ذات الوقت."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CELERON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "استمتع بقوة الترفيه والإنتاجية بما يناسب ميزانيتك ونمط حياتك.",
                "tr_title": "أداء Intel لكل الميزانيات.",
                "tr_gen_core_title": "معالج Intel®‎ Celeron®‎",
                "processorCompare": {
                  "tr_title": "ابحث عن المستوى المناسب من الأداء والقيمة",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                      "tr_imgCaption": "معالج Intel®‎ Celeron®‎"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "معالج Intel®‎ Pentium®‎ Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "استعراض ويب سريع وغني بالوسائط",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تبديل سهل بين البرامج",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل الألعاب العادية",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "مشاهدة مقاطع فيديو مباشرة عبر الإنترنت بدقة 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تحرير خفيف للصور ومقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنتاجية سريعة مع الأداء الذكي",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "7GEN_BELOW_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/[cup_badge].svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "genType": "7Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل السابع"
                  },
                  {
                    "genType": "6Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل السادس"
                  },
                  {
                    "genType": "5Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل الخامس"
                  },
                  {
                    "genType": "4Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل الرابع"
                  },
                  {
                    "genType": "3Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل الثالث"
                  },
                  {
                    "genType": "2Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل الثاني"
                  },
                  {
                    "genType": "1Gen",
                    "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ [cpu_fam] من الجيل الأول"
                  }
                ],
                "processorCompare": {
                  "tr_title": "",
                  "background": "",
                  "tr_tableHead": [
                    "ينصح به للآتي:",
                    "<span><img src=></span>",
                    "<span><img src=></span>"
                  ],
                  "tabletr": [
                    {
                      "tr_row": "",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "مُشغّل بواسطة معالج Intel®‎ Core™‎ i3 من الجيل الثامن",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل الثامن"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تم ابتكار معالجات Intel® Core™&lrm; من الجيل التاسع لمواكبة تطور العالم الرقمي من حولك. وبما أن هذه المعالجات تجمع بين السرعة والأداء، سوف تتمكن من إنجاز المزيد من الأمور التي تحب القيام بها باستخدام الكمبيوتر دون الشعور بالإحباط.",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i3 من الجيل التاسع",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل التاسع"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "يجتمع الأداء المتعدد الجوانب مع عمر البطارية الطويل لتتمكن من الاستمرار في العمل أينما كان.",
                "tr_title": "طاقة تدوم طوال اليوم",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل العاشر",
                "processorCompare": {
                  "tr_title": "العثور على مستوى الأداء المناسب من الجيل العاشر",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "مشاهدة أفلام من الإنترنت بدقة 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إمكانية اتصال سريع وموثوق به",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إخفاء أجزاء من الصور وتصفية مقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب بدقة 1080p ومعدل إطارات سلس",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "الأفضل للعمل على مستندات كبيرة وبرامج إبداعية",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "انتقل بسهولة وبسرعة من مشاهدة الأفلام عبر الإنترنت إلى إنشاء عروض تقديمية.",
                "tr_title": "طاقة تدوم طوال اليوم",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل العاشر"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "للذين يتنقلون باستمرار، صممنا جهاز كمبيوتر محمولاً خصيصاً لكم.",
                "tr_title": "تعرّف على فئة جديدة من أجهزة الكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل العاشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "تسمح لك معالجات Intel®‎ Core™‎ i3 من الجيل الحادي عشر، المصممة خصيصًا لأجهزة الكمبيوتر المحمولة بأداء مهام أكثر من أي وقت مضى، أينما كنت.",
                "tr_title": "استفد أكثر من كمبيوترك المحمول الجديد",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i3 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "عندما تعتمد أسرتك كلها على كمبيوتر مكتبي واحد لكل المهام، فأنت بحاجة إلى قوة معالج Intel®‎ Core™‎ i3 من الجيل الحادي عشر وتنوع أوجه استخدامه.",
                "tr_title": "كُن مستعدًا لكل شيء مع أداء يكسر الحواجز.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i3 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i5 الجيل الثامن",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الثامن"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تم ابتكار معالجات Intel® Core™&lrm; من الجيل التاسع لمواكبة تطور العالم الرقمي من حولك. وبما أن هذه المعالجات تجمع بين السرعة والأداء، سوف تتمكن من إنجاز المزيد من الأمور التي تحب القيام بها باستخدام الكمبيوتر دون الشعور بالإحباط.",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i5 من الجيل التاسع",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل التاسع"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "تشغيل الألعاب الأكثر تطلبًا والواقع الافتراضي بسلاسة تامة",
                "tr_title": "تشغيل الألعاب الاحترافية يبدأ هنا",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "تعامل بسهولة مع برامج متعددة لتكون جاهزاً لأي مهمة أينما ذهبت خلال اليوم.",
                "tr_title": "تعددية مهام أثناء التنقل",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر",
                "processorCompare": {
                  "tr_title": "العثور على مستوى الأداء المناسب من الجيل العاشر",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "مشاهدة أفلام من الإنترنت بدقة 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إمكانية اتصال سريع وموثوق به",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إخفاء أجزاء من الصور وتصفية مقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب بدقة 1080p ومعدل إطارات سلس",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "الأفضل للعمل على مستندات كبيرة وبرامج إبداعية",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ارتقِ في كل ما تقوم به بدءًا من الترفيه مرورًا بمهام الإنتاجية ووصولاً إلى إنشاء المحتوى.",
                "tr_title": "ارتقِ إلى كمبيوتر أقوى",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "للذين يتنقلون باستمرار، صممنا جهاز كمبيوتر محمولاً خصيصاً لكم.",
                "tr_title": "تعرّف على فئة جديدة من أجهزة الكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "مصممة لتوفير سلاسة عند البث وتشغيل ألعاب AAA",
                "tr_title": "العب بشروطك الخاصة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "مصممة لتوفير سلاسة عند البث وتشغيل ألعاب AAA",
                "tr_title": "العب بشروطك الخاصة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.8 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 10<br/>خيوط المعالجة: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تعامل بسهولة مع برامج متعددة لتكون جاهزاً لأي مهمة أينما ذهبت خلال اليوم.",
                "tr_title": "تعددية مهام أثناء التنقل",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل العاشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل العاشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "يضفي معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر على أجهزة الكمبيوتر الأخف والأرفع تجربة مرئية تنبض بالحياة وإنتاجية عالية في باقة كبيرة من المهام.",
                "tr_title": "قوة مبهرة للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "عندما تعتمد أسرتك كلها على كمبيوتر مكتبي واحد لكل المهام، فأنت بحاجة إلى قوة معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر وتنوع أوجه استخدامه.",
                "tr_title": "كُن مستعدًا لكل شيء مع أداء يكسر الحواجز.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "يضفي معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر على أجهزة الكمبيوتر الرفيعة خفيفة الوزن تجربة مرئية تنبض بالحياة وإنتاجية عالية في باقة كبيرة من المهام.",
                "tr_title": "قوة مبهرة للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل الحادي عشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_6.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i7 الجيل الثامن",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثامن"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "تم ابتكار معالجات Intel® Core™&lrm; من الجيل التاسع لمواكبة تطور العالم الرقمي من حولك. وبما أن هذه المعالجات تجمع بين السرعة والأداء، سوف تتمكن من إنجاز المزيد من الأمور التي تحب القيام بها باستخدام الكمبيوتر دون الشعور بالإحباط.",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i7 من الجيل التاسع",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل التاسع"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "عدد إطارات في الثانية أكثر بنسبة تصل إلى 32% أثناء اللعب والمشاهدة مباشرة عبر الإنترنت والتسجيل مقارنة بكمبيوتر عمره 3 سنوات<sup>3</sup>",
                "tr_title": "القوة اللازمة لمشاركة أروع لحظاتك في اللعبة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "قد يؤثر هذا الجهاز المتميّز كثيرا على أسلوبك في الابتكار والاتصال والبث، كونه مصمماً ليكون فعالاً.",
                "tr_title": "أداء متقدم أينما كان",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر",
                "processorCompare": {
                  "tr_title": "العثور على مستوى الأداء المناسب من الجيل العاشر",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "مشاهدة أفلام من الإنترنت بدقة 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إمكانية اتصال سريع وموثوق به",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إخفاء أجزاء من الصور وتصفية مقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب بدقة 1080p ومعدل إطارات سلس",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "الأفضل للعمل على مستندات كبيرة وبرامج إبداعية",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "أداء متطور للارتقاء بكل ما تقوم به إلى المستوى التالي.",
                "tr_title": "قوة لكل المهام",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "للذين يتنقلون باستمرار، صممنا جهاز كمبيوتر محمولاً خصيصاً لكم.",
                "tr_title": "تعرّف على فئة جديدة من أجهزة الكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "تميّز أمام منافسيك في تشغيل الألعاب وبثها وتسجيلها",
                "tr_title": "امنح عالم ألعابك القوة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "تميّز أمام منافسيك في تشغيل الألعاب وبثها وتسجيلها",
                "tr_title": "امنح عالم ألعابك القوة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.8 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 10<br/>خيوط المعالجة: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "ستختبر إنشاء المحتوى والاتصال والبث التدفقي عبر الإنترنت بطريقة جديدة بالكامل بفضل هذا الجهاز الأنيق المُصمم للفعالية.",
                "tr_title": "أداء متميز في أي مكان",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل العاشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "مع معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر، باتت أجهزة الكمبيوتر السهلة الحمل للغاية تزهو بإمكانات متقدمة لإنشاء المحتوى وبتشغيل ألعاب سلس وبإمكانات ترفيه من المستوى التالي.",
                "tr_title": "أداء ثوري للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "اجعل الكمبيوتر المكتبي الوجهة التي تقصدها لكل ما قد يحتاج إليه منزلك مع أداء يكسر الحواجز الذي يقدمه معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر.",
                "tr_title": "اعمل. تعلم. العب. بدون أي قيود.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "مع معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر، باتت أجهزة الكمبيوتر المحمولة الرفيعة الخفيفة الوزن تزهو بإمكانات متقدمة لإنشاء المحتوى وبتشغيل ألعاب سلس وبإمكانات ترفيه من المستوى التالي.",
                "tr_title": "أداء ثوري للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "اجعل الكمبيوتر المكتبي الوجهة التي تقصدها لكل ما قد يحتاج إليه منزلك مع أداء يكسر الحواجز الذي يقدمه معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر.",
                "tr_title": "استمتع بالإنشاء بدون قيود",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_1195G7",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "شهد معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر ترقية للتو مع إضافة إمكانات متقدمة لإنشاء المحتوى وإمكانات لتشغيل ألعاب بسلاسة فضلًا عن إمكانات ترفيه من المستوى التالي.",
                "tr_title": "أداء ثوري للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i9 الجيل الثامن",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثامن"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تم ابتكار معالجات Intel® Core™&lrm; من الجيل التاسع لمواكبة تطور العالم الرقمي من حولك. وبما أن هذه المعالجات تجمع بين السرعة والأداء، سوف تتمكن من إنجاز المزيد من الأمور التي تحب القيام بها باستخدام الكمبيوتر دون الشعور بالإحباط.",
                "tr_title": "مشغّل بواسطة معالج Intel®‎ Core™‎ i9 من الجيل التاسع",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل التاسع"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "عدد إطارات في الثانية أكثر بنسبة تصل إلى 41% أثناء تشغيل الألعاب والمشاهدة مباشرة عبر الإنترنت والتسجيل مقارنة بكمبيوتر عمره 3 سنوات<sup>4</sup>",
                "tr_title": "ما يطلبه مشغلو الألعاب تؤمّنه معالجات Intel®‎ Core™‎ i9.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_8",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ارفع سقف إمكاناتك مع التجربة الأمثل لتشغيل الألعاب",
                "tr_title": "أعلى مستويات المنافسة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ارفع سقف إمكاناتك مع التجربة الأمثل لتشغيل الألعاب",
                "tr_title": "أعلى مستويات المنافسة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.8 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 10<br/>خيوط المعالجة: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "ارفع سقف إمكاناتك مع التجربة الأمثل لمنشئي المحتوى",
                "tr_title": "أعلى مستويات الإبداع",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i9 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I5_5.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تمنحك أجهزة الكمبيوتر المحمولة Intel® Evo™‎ المشغلة بواسطة معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر ورسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎ سرعة مذهلة وأداء متميزًا، وذلك كله في تصميم رفيع خفيف الوزن.",
                "tr_title": "ارتقاء في القوة لكمبيوتر محمول أكثر تطورًا",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I7.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i7-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تمنحك أجهزة الكمبيوتر المحمولة Intel® Evo™‎ المشغلة بواسطة معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر ورسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎ الزيادة في السرعة والأداء لتحظى بتجربة متميزة على الأجهزة المحمولة.",
                "tr_title": "زيادة في القوة لكمبيوتر محمول أكثر تطورًا",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_SILVER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "استمتع بتوازن رائع بين الأداء والوسائط والاتصال بقيمة رائعة.",
                "tr_title": "الأداء وإمكانية الاتصال بقيمة مذهلة.",
                "tr_gen_core_title": "معالج Intel®‎ Pentium®‎ Silver",
                "processorCompare": {
                  "tr_title": "ابحث عن المستوى المناسب من الأداء والقيمة",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "معالج Intel®‎ Pentium®‎ Silver"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "معالج Intel®‎ Pentium®‎ Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "استعراض ويب سريع وغني بالوسائط",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تبديل سهل بين البرامج",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل الألعاب العادية",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "مشاهدة مقاطع فيديو مباشرة عبر الإنترنت بدقة 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تحرير خفيف للصور ومقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنتاجية سريعة مع الأداء الذكي",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_GOLD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "استمتع بسلاسة تعددية المهام وبساطة تحرير الصور ومقاطع الفيديو ومقاطع فيديو بدقة 4K والرسوميات النابضة بالحياة بقيمة مذهلة.",
                "tr_title": "أداء مبهر عند العمل واللعب.",
                "tr_gen_core_title": "معالج Intel®‎ Pentium®‎ Gold",
                "processorCompare": {
                  "tr_title": "ابحث عن المستوى المناسب من الأداء والقيمة",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "معالج Intel®‎ Pentium®‎ Silver"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "معالج Intel®‎ Pentium®‎ Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "استعراض ويب سريع وغني بالوسائط",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تبديل سهل بين البرامج",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل الألعاب العادية",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "مشاهدة مقاطع فيديو مباشرة عبر الإنترنت بدقة 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تحرير خفيف للصور ومقاطع الفيديو",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنتاجية سريعة مع الأداء الذكي",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "تشغيل ألعاب AAA وعمر بطارية طويل في كمبيوتر سهل الحمل للغاية. لا داعٍ للمساومة على طريقتك في اللعب.",
                "tr_title": "لا داعٍ للمساومة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "اعثر على معالج تشغيل الألعاب السهل الحمل للغاية INTEL®‎ CORE™‎ المناسب لك.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i5-11300H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11370H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11375H Special edition من الجيل الحادي&nbsp;عشر"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.4 غيغاهرتز</span>",
                      "tr_td2_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.8 غيغاهرتز</span>",
                      "tr_td3_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>5.0 غيغاهرتز</span>"
                    },
                    {
                      "tr_td1_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td2_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td3_title": "4 أساسات/ 8&nbsp;خيوط معالجة"
                    },
                    {
                      "tr_td1_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td2_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td3_title": "تقنية Intel®‎ Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 8 ميغابايت",
                      "tr_td2_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت",
                      "tr_td3_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت"
                    },
                    {
                      "tr_td1_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td2_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td3_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "تشغيل ألعاب AAA بدقة 1080p‎ وعدد إطارات في الثانية مرتفع بالإعدادات المتقدمة وأداء ممتاز عند عدم التوصيل بالكهرباء في كمبيوتر سهل الحمل للغاية.",
                "tr_title": "تفضل. احصل عليها كلها.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "اعثر على معالج تشغيل الألعاب السهل الحمل للغاية INTEL®‎ CORE™‎ المناسب لك.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i5-11300H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11370H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11375H Special edition من الجيل الحادي&nbsp;عشر"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.4 غيغاهرتز</span>",
                      "tr_td2_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.8 غيغاهرتز</span>",
                      "tr_td3_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>5.0 غيغاهرتز</span>"
                    },
                    {
                      "tr_td1_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td2_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td3_title": "4 أساسات/ 8&nbsp;خيوط معالجة"
                    },
                    {
                      "tr_td1_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td2_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td3_title": "تقنية Intel®‎ Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 8 ميغابايت",
                      "tr_td2_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت",
                      "tr_td3_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت"
                    },
                    {
                      "tr_td1_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td2_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td3_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_SPECIAL_EDITION_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "سرعة ساعة قصوى تصل إلى 5.0 غيغاهرتز لتساعدك بالارتقاء في ألعابك وكمبيوتر سهل الحمل للغاية يتيح لك أخذه معك أينما ذهبت.",
                "tr_title": "المزيد من القوة في عامل شكلي نحيف للغاية.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 Special Edition من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "معالج Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "اعثر على معالج تشغيل الألعاب السهل الحمل للغاية INTEL®‎ CORE™‎ المناسب لك.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i5-11300H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11370H من الجيل الحادي عشر"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "معالج Intel®‎&nbsp;Core™‎ i7-11375H Special edition من الجيل الحادي&nbsp;عشر"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.4 غيغاهرتز</span>",
                      "tr_td2_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>4.8 غيغاهرتز</span>",
                      "tr_td3_title": "سرعة ساعة قصوى تصل إلى <span class='style_badge'>5.0 غيغاهرتز</span>"
                    },
                    {
                      "tr_td1_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td2_title": "4 أساسات/ 8&nbsp;خيوط معالجة",
                      "tr_td3_title": "4 أساسات/ 8&nbsp;خيوط معالجة"
                    },
                    {
                      "tr_td1_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td2_title": "تقنية Intel®‎ Turbo Boost Technology",
                      "tr_td3_title": "تقنية Intel®‎ Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 8 ميغابايت",
                      "tr_td2_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت",
                      "tr_td3_title": "الذاكرة الحاجبة الذكية Intel®‎ بسعة 12 ميغابايت"
                    },
                    {
                      "tr_td1_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td2_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                      "tr_td3_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "يوفر معالج Intel® Core™ i7 Special Edition من الجيل الحادي عشر في أجهزة الكمبيوتر سهلة الحمل للغاية إنشاء محتوى متقدمًا وتشغيل ألعاب سلسًا مع المستوى التالي من الترفيه.",
                "tr_title": "أداء ثوري للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 Special Edition من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج Intel® Core™ i7 Special Edition من الجيل الحادي عشر"
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "يوفر معالج Intel® Core™ i7 Special Edition من الجيل الحادي عشر في أجهزة الكمبيوتر سهلة الحمل للغاية إنشاء محتوى متقدمًا وتشغيل ألعاب سلسًا مع المستوى التالي من الترفيه.",
                "tr_title": "أداء ثوري للكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 Special Edition من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج Intel® Core™ i7 Special Edition من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "معالج Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "التوازن الصحيح بين سرعة الساعة وأداء الأساسات يحصل على المزيد من ألعابك، سواء أكنت تتنافس بعدد إطارات في الثانية عالٍ أم تنغمس في تجارب ألعاب AAA.",
                "tr_title": "قوة هادفة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "استمتع بتشغيل الألعاب الشاقة وتسجيلها وبثها بعدد إطارات في الثانية مرتفع وبالتبديل بمنتهى السهولة إلى أعباء عمل تعددية المهام الكثيفة.",
                "tr_title": "القوة لكسر القيود.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "انتقل بسهولة وبسرعة من مشاهدة الأفلام عبر الإنترنت إلى إنشاء عروض تقديمية.",
                "tr_title": "طاقة تدوم طوال اليوم",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 مزود بتقنية Intel®‎&nbsp;Hybrid Technology",
                "tr_subTitle2": "معالج Intel®‎ Core™‎ i3 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "يجتمع الأداء المتعدد الجوانب مع عمر البطارية الطويل لتتمكن من الاستمرار في العمل أينما كان.",
                "tr_title": "طاقة تدوم طوال اليوم",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 مزود بتقنية Intel®‎&nbsp;Hybrid Technology",
                "tr_subTitle2": "معالج Intel®‎ Core™‎ i3 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "تعامل بسهولة مع برامج متعددة لتكون جاهزاً لأي مهمة أينما ذهبت خلال اليوم.",
                "tr_title": "تعددية مهام أثناء التنقل",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 مزود بتقنية Intel®‎&nbsp;Hybrid Technology",
                "tr_subTitle2": "معالج Intel®‎ Core™‎ i5 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "ارتقِ في كل ما تقوم به بدءًا من الترفيه مرورًا بمهام الإنتاجية ووصولاً إلى إنشاء المحتوى.",
                "tr_title": "ارتقِ إلى كمبيوتر أقوى",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 مزود بتقنية Intel®‎&nbsp;Hybrid Technology",
                "tr_subTitle2": "معالج Intel®‎ Core™‎ i5 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "يجتمع مستوى أداء الأجهزة المكتبية في تشغيل الألعاب مع سهولة التنقل، سواء من أجل اللعب التنافسي مع معدل إطارات عالٍ في الثانية أو تجارب ألعاب AAA الغامرة.",
                "tr_title": "قوة هادفة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "يجتمع مستوى أداء الأجهزة المكتبية في تشغيل الألعاب مع سهولة التنقل، سواء من أجل اللعب التنافسي مع معدل إطارات عالٍ في الثانية أو تجارب ألعاب AAA الغامرة.",
                "tr_title": "قوة هادفة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "كمبيوتر محمول يمكنه تشغيل الألعاب والتسجيل والبث مباشرة عبر الإنترنت في وقت واحد مع معدل إطارات عالٍ في الثانية ينتقل بسهولة إلى أعباء العمل الكثيفة التي تتطلب تعددية مهام.",
                "tr_title": "القوة لكسر القيود.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "كمبيوتر محمول يمكنه تشغيل الألعاب والتسجيل والبث مباشرة عبر الإنترنت في وقت واحد مع معدل إطارات عالٍ في الثانية ينتقل بسهولة إلى أعباء العمل الكثيفة التي تتطلب تعددية مهام.",
                "tr_title": "القوة لكسر القيود.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i7 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_PERFORMANCE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد، أينما أخذت كمبيوترك.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد، أينما أخذت كمبيوترك.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_ENTHUSIAST",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر والأداء غير محدد السرعة بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد، أينما أخذت كمبيوترك.",
                "tr_title": "قوة غير محددة السرعة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر والأداء غير محدد السرعة بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد، أينما أخذت كمبيوترك.",
                "tr_title": "قوة غير محددة السرعة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات المرتفع بسلاسة معًا لجعلك تستفيد أكثر من إنشاء المحتوى المعقد، أينما أخذت الكمبيوتر الخاص بك.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من إنشاء المحتوى المعقد.",
                "tr_title": "قوة هائلة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_10",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ارفع سقف إمكاناتك مع التجربة الأمثل لتشغيل الألعاب",
                "tr_title": "أعلى مستويات المنافسة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ارفع سقف إمكاناتك مع التجربة الأمثل لتشغيل الألعاب",
                "tr_title": "أعلى مستويات المنافسة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ من الجيل العاشر الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA بسلاسة",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "البث",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "بث وتسجيل",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "إنشاء محتوى متقدم",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "ذروة الأداء عند تشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "غير محددة السرعة وقابلة لزيادة السرعة<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.8 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.1 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 10<br/>خيوط المعالجة: 20</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "للذين يتنقلون باستمرار، صممنا جهاز كمبيوتر محمولاً خصيصاً لكم.",
                "tr_title": "تعرّف على فئة جديدة من أجهزة الكمبيوتر المحمول",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل العاشر"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11_UNLOCKED",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من تشغيل الألعاب التنافسية وإنشاء المحتوى المعقد.",
                "tr_title": "قوة غير محددة السرعة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات المرتفع والأداء غير المحدد السرعة بسلاسة معًا لجعلك تستفيد أكثر من إنشاء المحتوى المعقد، أينما أخذت الكمبيوتر الخاص بك.",
                "tr_title": "قوة غير محددة السرعة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "تعمل سرعات الساعة العالية وعدد الأساسات الأكبر بسلاسة معًا لجعلك تستفيد أكثر من إنشاء المحتوى المعقد.",
                "tr_title": "قوة غير محددة السرعة. متوازن بشكل كامل.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الحادي عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الحادي عشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] ميغابايت <br/></span><span class='subtitle_font'>الذاكرة الحاجبة الذكية Intel®‎</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "سلاسة في تشغيل الألعاب والواقع الافتراضي في الألعاب الأكثر صعوبةً",
                "tr_title": "تشغيل الألعاب الاحترافية يبدأ هنا",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.9 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "عدد إطارات في الثانية أكبر بنسبة تصل إلى 32% <br/><span class='tr_subtitle_font'>أثناء تشغيل الألعاب والمشاهدة مباشرة عبر الإنترنت والتسجيل مقارنة بكمبيوتر عمره 3 سنوات<sup>3</sup></span>",
                "tr_title": "القوة اللازمة لمشاركة أروع لحظاتك في اللعبة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.9 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "عدد إطارات في الثانية أكبر بنسبة تصل إلى 41% <br/><span class='tr_subtitle_font'>أثناء تشغيل الألعاب والمشاهدة مباشرة عبر الإنترنت والتسجيل مقارنة بكمبيوتر عمره 3 سنوات<sup>4</sup></span>",
                "tr_title": "ما يطلبه مشغلو الألعاب تؤمّنه معالجات Intel®‎ Core™‎ i9.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل التاسع",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>خيوط معالجة</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>أساسات</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>تصل إلى <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>غيغاهرتز</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>ذاكرة تخزين مؤقت <br/></span><span class='badgetitle_font'>سعة [XX] ميغابايت</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "غير محدد السرعة",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "اعثر على معالج INTEL®‎ CORE™‎ الذي يناسب طريقتك في اللعب.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i7"
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "معالج Intel®‎ Core™‎ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "تشغيل ألعاب AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "تشغيل ألعاب تنافسي",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "اللعب والبث والتسجيل من دون مساومة",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "أفضل معالج Intel®‎ Core™‎ من الجيل التاسع لتشغيل الألعاب",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.3 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 4<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.6 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 6<br/>خيوط المعالجة: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 4.9 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>سرعة الساعة<sup>2</sup>: تصل إلى 5 غيغاهرتز</span>",
                      "tr_subTitle": "<span class='small_font'>الأساسات: 8<br/>خيوط المعالجة: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_K_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "مصمم للجيل التالي من تشغيل الألعاب",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثاني عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثاني عشر"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثاني عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثاني عشر"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_HX_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "ساحة المعركة تلتقي بساحة العمل",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثاني عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثاني عشر"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء موثوق به عند أمس الحاجة إليه",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i3 من الجيل الثاني عشر",
                "bannerImgUrl": "assets/images/12th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء معزز عند أمس الحاجة إليه",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثاني عشر",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء معزز عند أمس الحاجة إليه",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثاني عشر",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء متفوق عند أمس الحاجة إليه",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء متفوق عند أمس الحاجة إليه",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "مع أجهزة الكمبيوتر المحمولة Intel® Evo™‎، تحصل على الأداء والذكاء المدمج لتجري محادثات فيديو بثقة وتتمتع بإنترنت أسرع وبطارية تدوم أكثر والمزيد غير ذلك.",
                "tr_title": "أداء معزز عند أمس الحاجة إليه.",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i7_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "مع أجهزة الكمبيوتر المحمولة Intel® Evo™‎، تحصل على الأداء والذكاء المدمج لتجري محادثات فيديو بثقة وتتمتع بإنترنت أسرع وبطارية تدوم أكثر والمزيد غير ذلك.",
                "tr_title": "أداء متفوق عند أمس الحاجة إليه",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i9_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "مع أجهزة الكمبيوتر المحمولة Intel® Evo™‎، تحصل على الأداء والذكاء المدمج لتجري محادثات فيديو بثقة وتتمتع بإنترنت أسرع وبطارية تدوم أكثر والمزيد غير ذلك.",
                "tr_title": "أداء فائق على أجهزة الكمبيوتر المحمولة الممتازة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "مع تقنية Intel®‎ Turbo Boost Technology 2.0 تردد يصل إلى [max_turbo_frequency] غيغاهرتز",
                "tr_title": "مصمم للشركات",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الاستمتاع بأمان جاهز مستند إلى الأجهزة",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "توفير قدرات إدارة الجهاز عن بُعد",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "تحسين أداء Wi-Fi تلقائيًا<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الدعم عبر التطبيقات المستندة إلى البيانات",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الإنتاجية الأكبر مع تعزيز الأداء",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "مع تقنية Intel®‎ Turbo Boost Technology 2.0 تردد يصل إلى [max_turbo_frequency] غيغاهرتز",
                "tr_title": "يعمل بكل طاقته لتركز على عملك.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الاستمتاع بأمان جاهز مستند إلى الأجهزة",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "توفير قدرات إدارة الجهاز عن بُعد",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "تحسين أداء Wi-Fi تلقائيًا<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الدعم عبر التطبيقات المستندة إلى البيانات",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الإنتاجية الأكبر مع تعزيز الأداء",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "مع تقنية Intel®‎ Turbo Boost Technology 2.0 تردد يصل إلى [max_turbo_frequency] غيغاهرتز",
                "tr_title": "سرّع نمط شركتك",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثاني عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثاني عشر",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الاستمتاع بأمان جاهز مستند إلى الأجهزة",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "توفير قدرات إدارة الجهاز عن بُعد",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "تحسين أداء Wi-Fi تلقائيًا<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الدعم عبر التطبيقات المستندة إلى البيانات",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "الإنتاجية الأكبر مع تعزيز الأداء",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء موثوق به مخصص لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 من الجيل الثالث عشر",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء فعلي يمكّنك من إنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثالث عشر",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء فعلي يمكّنك من إنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثالث عشر",
                "bannerImgUrl": "assets/images/creator/13thgeni5processor.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء قوي مصمم خصيصًا لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثالث عشر",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء قوي مصمم خصيصًا لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثالث عشر",
                "bannerImgUrl": "assets/images/creator/13thgeni7processor.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء يتجاوز التوقعات",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثالث عشر",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "اتصِل بهاتفك الحالي بسلاسة<sup>24</sup>، واحرص على الاتصال بأفضل شبكة Wi-Fi، واستمتع بعملية شحن سريعة مع بطارية تدوم طويلًا.",
                "tr_title": "لا تشغل بالك بعامل الأداء وركّز فقط على إنجاز المزيد من المهام في أي مكان",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "اتصِل بهاتفك الحالي بسلاسة<sup>24</sup>، واحرص على الاتصال بأفضل شبكة Wi-Fi، واستمتع بعملية شحن سريعة مع بطارية تدوم طويلًا.",
                "tr_title": "لا تشغل بالك بعامل الأداء واترك جهاز الكمبيوتر الشخصي الخاص بك يتولى إنجاز أكثر من مهمة في آن واحد",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "اتصِل بهاتفك الحالي بسلاسة<sup>24</sup>، واحرص على الاتصال بأفضل شبكة Wi-Fi، واستمتع بعملية شحن سريعة مع بطارية تدوم طويلًا.",
                "tr_title": "لا تشغل بالك بعامل الأداء وركّز على إنجاز المهام الصعبة بسرعة",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء يتجاوز التوقعات",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثالث عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثالث عشر",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثالث عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثالث عشر",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثالث عشر",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثالث عشر",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_ABOVE13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء يتجاوز التوقعات",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5",
                    "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء موثوق به مخصص لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء فعلي يمكّنك من إنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5",
                "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء قوي مصمم خصيصًا لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_14TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء يتجاوز التوقعات",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5",
                    "tr_gen_core_title_uppercase": "معالج INTEL®‎ CORE™‎ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "معالج Intel®‎ Core™‎ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء موثوق به مخصص لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™&nbsp;3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/14th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء فعلي يمكّنك من إنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™&nbsp;5",
                "tr_gen_core_title_uppercase": "معالج INTEL®&nbsp;CORE™&nbsp;5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء قوي مصمم خصيصًا لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™&nbsp;7",
                "tr_gen_core_title_uppercase": "معالج INTEL®&nbsp;CORE™&nbsp;7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "أداء قوي مصمم خصيصًا لإنجاز المزيد من المهام",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™&nbsp;9",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/intel_core_9_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                      "tr_badgeIconTile": "معالج Intel®&nbsp;Core™&nbsp;9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_1ST_GEN_ULTRA_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_5_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_7_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_9_h_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] في LPE-cores"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                      "tr_badgeIconTile": "معالج Intel® Core™ Ultra 5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                      "tr_badgeIconTile": "معالج Intel® Core™ Ultra 7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                      "tr_badgeIconTile": "معالج Intel® Core™ Ultra 9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "ألعابك المفضّلة بأداء فائق",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "الشركات الصغيرة تستحق حلولًا تجارية كبيرة.",
                "tr_gen_core_title": "معالج Intel® Core™ i5 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i5 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "الحصول على وسائل حماية أمنية فورية مستندة إلى الأجهزة",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "المساعدة على حماية الأجهزة والبيانات من هجمات التخريب المادية",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "الشركات الصغيرة تستحق حلولًا تجارية كبيرة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i7 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i7 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "الحصول على وسائل حماية أمنية فورية مستندة إلى الأجهزة",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "المساعدة على حماية الأجهزة والبيانات من هجمات التخريب المادية",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "الشركات الصغيرة تستحق حلولًا تجارية كبيرة.",
                "tr_gen_core_title": "معالج Intel®‎ Core™‎ i9 من الجيل الثالث عشر",
                "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ i9 من الجيل الثالث عشر",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ما أداء المعالج مقارنة بغيره؟",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "الجهاز الحالي",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "قمع الضجيج وتمويه الخلفية",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "أداء مخصص تلقائيًا ليعطي الأولوية للمهام الأكثر شيوعًا لديك",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "متعة مكالمات الويب عالية الجودة والسلسة",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "الحصول على وسائل حماية أمنية فورية مستندة إلى الأجهزة",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "المساعدة على حماية الأجهزة والبيانات من هجمات التخريب المادية",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_RPL_MTL_vPro",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/vPro_ultra_badge.png",
                "tileBG": "",
                "bannerImgUrl": "assets/images/INTEL_VPRO_ULTRA.png",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "أطلق إمكانات جديدة مع الذكاء الاصطناعي للأعمال",
                "tr_title": "استعد لما هو قادم باستخدام معالجات Intel® Core™ Ultra&nbsp;[XX] وأيضًا Intel vPro®‎",
                "tr_gen_core_title": "معالج Intel® Core™ Ultra [XX]",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_1.png",
                    "tr_badgeTitle": "امنح أعمالك دفعة قوية باستخدام أجهزة الكمبيوتر المدعومة بالذكاء الاصطناعي من INTEL",
                    "tr_badgeSubTitle": "أجهزة الكمبيوتر القوية التي توفر تجربة رائعة هي جوهر إنتاجية الأعمال. تعزز تقنية Intel vPro®‎ من فعالية الموظف وأدائه في الأعمال والتطبيقات، وذلك بفضل البنية الجديدة التي توفر أداءً فائقًا في توفير الطاقة لمختلف الأعمال المعقدة عن طريق إرسال المهمة المناسبة إلى المحرك المناسب في الوقت المناسب.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_2.png",
                    "tr_badgeTitle": "التمكين الفوري لميزات الأمان متعددة الطبقات",
                    "tr_badgeSubTitle": "تتطلب التهديدات الجديدة والناشئة اتباع نهج شامل للأمان. يوفر Intel vPro®‎ الحماية على مستوى الأجهزة وفي جميع أنحاء مجموعة الأعمال لكي تتمتع شركتك بحماية أفضل. هذه إجراءات أمنية فريدة وجاهزة، تشمل إمكانات الكشف عن التهديدات المدعومة بالذكاء الاصطناعي، وتساعد على حماية المستخدمين وبياناتك وأعمالك.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_3.png",
                    "tr_badgeTitle": "أدوات مدمجة للحفاظ على إنتاجية المستخدمين من أي مكان تقريبًا",
                    "tr_badgeSubTitle": "المكاتب موجودة في كل مكان، وكذلك أجهزة الكمبيوتر الشخصية. يوفر Intel vPro®‎ إمكانات إدارة حديثة معتمدة على الأجهزة لمساعدة الشركات على تخفيف عبء إدارة أسطول أجهزة الكمبيوتر، وتبسيط الدعم وتحسين تجارب المستخدم النهائي، كل ذلك مع تمكين ممارسات الحوسبة المستدامة.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إبداعًا</span> مع أدوات الذكاء الاصطناعي لإبداع أسرع"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إنتاجية</span> مع مساعد الذكاء الاصطناعي الموفر للوقت"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر أمانًا</span> مع الحماية المدمجة للبيانات"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إبداعًا</span> مع أدوات الذكاء الاصطناعي لإبداع أسرع"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إنتاجية</span> مع مساعد الذكاء الاصطناعي الموفر للوقت"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر أمانًا</span> مع الحماية المدمجة للبيانات"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel® Core™ Ultra 9 (السلسلة 2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إبداعًا</span> مع أدوات الذكاء الاصطناعي لإبداع أسرع"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر إنتاجية</span> مع مساعد الذكاء الاصطناعي الموفر للوقت"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>أكثر أمانًا</span> مع الحماية المدمجة للبيانات"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ليس مجرد كمبيوتر شخصي رائع، بل كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي",
                "tr_subtitle1": "مشغّل بمعالجات INTEL®&nbsp;CORE™ ULTRA (السلسلة&nbsp;2)",
                "tr_subtitle2": "كمبيوتر شخصي مزود بإمكانات الذكاء الاصطناعي من Intel يحوّل المستحيل إلى ممكن",
                "tr_subtitle": "أفضل معالجات Intel للأجهزة المحمولة من حيث الكفاءة والأمان والأداء<sup>39</sup>",
                "tr_gen_core_title": "معالج Intel® Core™ Ultra 9 (السلسلة 2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "صُممت لعالم الألعاب. مستعدة لأصعب التحديات.",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] في LPE-cores"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1.png",
                    "tr_title": "أطلق العنان لأداء الألعاب الفائق",
                    "tr_subtitle": "احصل على أداء أسطوري في تشغيل الألعاب باستخدام الأساسات المطورة حديثًا التي تقدم تجربة لعب سريعة الاستجابة وفائقة السلاسة. <br/><br/> احصل على سرعة تصل إلى <span class ='expandable_highlight'>[XX] غيغاهرتز</span> مع تقنية Intel® Thermal Velocity Boost.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel2.png",
                    "tr_title": "ارتقِ بالكفاءة والإنتاجية إلى أعلى المستويات",
                    "tr_subtitle": "احصل على كفاءة فائقة مع معالجات Intel® Core™ Ultra للأجهزة المكتبية التي تحسن الأداء والكفاءة بحيث يمكن للكمبيوتر الشخصي العمل بشكل أكثر برودة وهدوءًا وسرعة. <br><br/>أداء أفضل في المعالجة متعددة الخيوط بنسبة تزيد على <span class ='expandable_highlight'>10%</span> <br><br/>استهلاك طاقة أقل بنسبة تصل إلى <span class ='expandable_highlight'>30%</span>",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "كن مستعدًا للمستقبل مع نقل الألعاب والبث التدفقي",
                    "tr_subtitle": "استمتع بأداء محسّن في البث التدفقي وتشغيل الألعاب مع جهاز كمبيوتر مدعوم بالذكاء الاصطناعي ومزود بمعالج Intel® Core™ Ultra.<br><br/><strong>توزيع مهام الذكاء الاصطناعي على وحدة المعالجة العصبية:</strong><br><br/><span class ='expandable_highlight'>إزالة الخلفية</span><br><br/><span class ='expandable_highlight'>تحسين الصوت</span><br><br/><span class ='expandable_highlight'>التأطير التلقائي</span><br><br/><strong>ثلاث وحدات لتسريع مهام الذكاء الاصطناعي: وحدة المعالجة المركزية، ووحدة معالجة الرسوميات، ووحدة المعالجة العصبية</strong>​ مع وحدات تسريع مهام الذكاء الاصطناعي — وحدة المعالجة المركزية، ووحدة معالجة الرسوميات، ووحدة المعالجة العصبية — المدمجة في معالجات Intel® Core™ Ultra، يمكنك التعامل مع أعباء عمل الذكاء الاصطناعي بسرعة وكفاءة.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "سهِّل عمليات الاتصال لديك",
                    "tr_subtitle": "مع المزيد من مسارات PCIe 5.0 وتقنية Thunderbolt™ 5.0 المتوفرة وتقنية Wi-Fi 7 المتوفرة، يجعل معالج Intel® Core™ Ultra للأجهزة المكتبية الاتصال أسهل من أي وقت مضى. <br><br/><strong>دعم تقنية Thunderbolt™ 5</strong> <br><br/>تصل سرعة النقل إلى <span class ='expandable_highlight'>120 غيغابت في الثانية</span> في مهام التسجيل والتحرير ومشاركة الملفات مع عرض نطاق ترددي للبيانات <br><br/><span class ='expandable_highlight'>أكبر بمرتين</span> من تقنية ™Thunderbolt",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "إبداع أكثر.<br>إنتاجية أكبر.<br>أمان أفضل.",
                "tr_subtitle": "توفير مزيد من الوقت لممارسة ما تحب.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner_desktop.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "معالج Intel® Core™ Ultra 9 (السلسلة 2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (السلسلة&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1_desktop.png",
                    "tr_title": "أنجز المهام التي تستهلك الوقت. بسرعة.",
                    "tr_subtitle": "وفّر المزيد من الوقت مع مساعد الذكاء الاصطناعي. يمكنك تنظيم تقويمك، والتخطيط لرحلاتك، وتلخيص الاجتماعات في لحظات، وإنشاء العروض التقديمية بسهولة، وأكثر من ذلك.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2_desktop.png",
                    "tr_title": "مارس ألعابك المفضلة. ولا تقلق من نفاد البطارية.",
                    "tr_subtitle": "انسَ مشاكل التوافق والأداء في أثناء اللعب. شغّل ألعاب AAA بسلاسة، بحيث يمكنك اللعب والبث بكل ثقة.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3_desktop.png",
                    "tr_title": "أنشئ المحتوى الذي تحبه. بكل سهولة.",
                    "tr_subtitle": "مهما كانت المهام التي تعمل عليها، يمكنك إنجازها بسرعة وسهولة باستخدام الأدوات المبتكرة المدعومة بالذكاء الاصطناعي.<br><br>يمكنك قص الصور وتبديل الخلفيات وإضافة المؤثرات في لحظات. تحسين مقاطع الفيديو ببضع نقرات. بل يمكنك أيضًا إنشاء أعمال فنية مخصصة ببضع كلمات.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4_desktop.png",
                    "tr_title": "استمتع بقدر أكبر من راحة البال. طوال الوقت.",
                    "tr_subtitle": "كن واثقًا بأنك تتمتع بحماية مدمجة تعزز أمان بياناتك وخصوصيتها.<br><br>بالإضافة إلى ذلك، تساعد تطبيقات الأمان المدعومة بالذكاء الاصطناعي في اكتشاف الأصوات المزيفة في مقاطع الفيديو على الفور، وتوفير حماية للبيانات الحساسة المخزنة على جهاز الكمبيوتر.",
                    "align": "left"
                  }
                ]
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "إبداع أكثر.<br>إنتاجية أكبر.<br>أمان أفضل.",
                "tr_subtitle": "توفير مزيد من الوقت لممارسة ما تحب.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "معالج Intel® Core™ Ultra 9 (السلسلة 2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (السلسلة&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "أنجز المهام التي تستهلك الوقت. بسرعة.",
                    "tr_subtitle": "وفّر المزيد من الوقت مع مساعد الذكاء الاصطناعي. يمكنك تنظيم تقويمك، والتخطيط لرحلاتك، وتلخيص الاجتماعات في لحظات، وإنشاء العروض التقديمية بسهولة، وأكثر من ذلك.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "أنشئ المحتوى الذي تحبه. بكل سهولة.",
                    "tr_subtitle": "مهما كانت المهام التي تعمل عليها، يمكنك إنجازها بسرعة وسهولة باستخدام الأدوات المبتكرة المدعومة بالذكاء الاصطناعي.<br><br>يمكنك قص الصور وتبديل الخلفيات وإضافة المؤثرات في لحظات. تحسين مقاطع الفيديو ببضع نقرات. بل يمكنك أيضًا إنشاء أعمال فنية مخصصة ببضع كلمات.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "مارس ألعابك المفضلة. ولا تقلق من نفاد البطارية.",
                    "tr_subtitle": "انسَ مشاكل التوافق والأداء في أثناء اللعب. شغّل ألعاب AAA بسلاسة، بحيث يمكنك اللعب والبث بكل ثقة.<br/><br/>استمتع بتجربة ألعاب أكثر سلاسة في أثناء التنقل ووقت لعب أطول بشحنة واحدة بفضل رسوميات Intel®‎ Arc™‎ المضمنة.<sup>57</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4.png",
                    "tr_title": "انسَ أمر الشحن. طوال اليوم.<sup>55</sup>",
                    "tr_subtitle": "أنجز كل المهام التي تحبها في أثناء التنقل بفضل <strong>عمر البطارية الذي يصل إلى 20 ساعة.<sup>55، 56</sup></strong>",
                    "align": "centre"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "استمتع بقدر أكبر من راحة البال. طوال الوقت.",
                    "tr_subtitle": "كن واثقًا بأنك تتمتع بحماية مدمجة تعزز أمان بياناتك وخصوصيتها.<br><br>بالإضافة إلى ذلك، تساعد تطبيقات الأمان المدعومة بالذكاء الاصطناعي في اكتشاف الأصوات المزيفة في مقاطع الفيديو على الفور، وتوفير حماية للبيانات الحساسة المخزنة على جهاز الكمبيوتر.",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "إبداع أكثر.<br>إنتاجية أكبر.<br>أمان أفضل.",
                "tr_subtitle": "توفير مزيد من الوقت لممارسة ما تحب.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "evo-content-tile-panel",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (السلسلة&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "معالج Intel® Core™ Ultra 9 (السلسلة 2)",
                    "tr_badgeSubTitle1": "معالج INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (السلسلة&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "أنجز المهام التي تستهلك الوقت. بسرعة.",
                    "tr_subtitle": "وفّر المزيد من الوقت مع مساعد الذكاء الاصطناعي. يمكنك تنظيم تقويمك، والتخطيط لرحلاتك، وتلخيص الاجتماعات في لحظات، وإنشاء العروض التقديمية بسهولة، وأكثر من ذلك.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "أنشئ المحتوى الذي تحبه. بكل سهولة.",
                    "tr_subtitle": "مهما كانت المهام التي تعمل عليها، يمكنك إنجازها بسرعة وسهولة باستخدام الأدوات المبتكرة المدعومة بالذكاء الاصطناعي.<br><br>يمكنك قص الصور وتبديل الخلفيات وإضافة المؤثرات في لحظات. تحسين مقاطع الفيديو ببضع نقرات. بل يمكنك أيضًا إنشاء أعمال فنية مخصصة ببضع كلمات.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "مارس ألعابك المفضلة. ولا تقلق من نفاد البطارية.",
                    "tr_subtitle": "انسَ مشاكل التوافق والأداء في أثناء اللعب. شغّل ألعاب AAA بسلاسة، بحيث يمكنك اللعب والبث بكل ثقة.<br/><br/>استمتع بتجربة ألعاب أكثر سلاسة في أثناء التنقل ووقت لعب أطول بشحنة واحدة بفضل رسوميات Intel®‎ Arc™‎ المضمنة.<sup>57</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "استمتع بقدر أكبر من راحة البال. طوال الوقت.",
                    "tr_subtitle": "كن واثقًا بأنك تتمتع بحماية مدمجة تعزز أمان بياناتك وخصوصيتها.<br><br>بالإضافة إلى ذلك، تساعد تطبيقات الأمان المدعومة بالذكاء الاصطناعي في اكتشاف الأصوات المزيفة في مقاطع الفيديو على الفور، وتوفير حماية للبيانات الحساسة المخزنة على جهاز الكمبيوتر.",
                    "align": "left"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "أجهزة الكمبيوتر الشخصي ™Intel® Evo المدعومة بالذكاء الاصطناعي",
                    "tr_subtitle": "احصل على أفضل ما تقدمه معالجات Intel®&nbsp;Core™ Ultra"
                  },
                  {
                    "tr_title": "صُممت لتجارب الذكاء الاصطناعي الحالية والمستقبلية",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "يمكنك الاختيار من بين مجموعة من الألوان والأحجام، بالإضافة إلى تصميمات بشاشة تعمل باللمس أو بتصميم 2 في 1",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "محرك ذكاء اصطناعي مُخصص يسرّع من وتيرة كل المهام التي تنجزها",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "تخطَّ منحنى التعلم باستخدام جهاز وبرنامج تعرفهما بالفعل",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "تشغيل هادئ ورائع مع عمر بطارية يدوم طوال اليوم",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "حماية مدمجة تحافظ على أمان البيانات",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "مزامنة مع أي هاتف أو جهاز لوحي<sup>54</sup>",
                    "tr_subtitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE_LAPTOP",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "المعالج",
                "tr_title": "مصممة للجيل التالي من الألعاب",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 5",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 7",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "معالج Intel® Core™ Ultra 9",
                    "tr_gen_core_title_uppercase": "معالج INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge_laptop.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>أساسات</span></span>",
                    "tr_badgePreTitle": "[p_core] Performance-cores",
                    "tr_badgeSubTitle": "[e_core] Efficient-cores",
                    "tr_badgeSubTitle1": "[l_core] LPE-cores"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'>[XX] <span class='core-text'>خيوط معالجة</span></span>",
                    "tr_badgePreTitle": "[p_thread] في Performance-cores",
                    "tr_badgeSubTitle": "[e_thread] في Efficient-cores",
                    "tr_badgeSubTitle1": "[l_thread] في LPE-cores"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1_laptop.png",
                    "tr_title": "أطلق العنان لأداء الألعاب الفائق",
                    "tr_subtitle": "احصل على أداء أسطوري في تشغيل الألعاب باستخدام الأساسات المطورة حديثًا التي تقدم تجربة لعب سريعة الاستجابة وفائقة السلاسة. <br/><br/> تحسين الأداء في الألعاب الكلاسيكية بنقرة واحدة مع الحصول على التحديثات المستمرة من خلال تقنية Intel® Application Optimization.<sup>48</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "ارفع كفاءة استهلاك الطاقة لديك إلى الحد الأقصى",
                    "tr_subtitle": "أنجز كمًا هائلًا من المهام بقدر ضئيل من الموارد – واستمتع بأداء محسَّن للألعاب بفضل عمر البطارية الطويل. <br><br/>احصل على كفاءة فائقة مع معالجات Intel® Core™ Ultra التي تحسن الأداء والكفاءة بحيث يمكن للكمبيوتر المحمول العمل بشكل أكثر برودة وهدوءًا وسرعة.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "كُن مستعدًا للمستقبل مع الذكاء الاصطناعي",
                    "tr_subtitle": "استمتع بسرعة إنجاز مهام الذكاء الاصطناعي على الجهاز باستخدام كمبيوتر مدعوم بالذكاء الاصطناعي ومزود بمعالج <span class ='expandable_highlight'>Intel® Core™ Ultra</span>. بدايةً من تفريغ مهام تشغيل الألعاب والبث التدفقي وحتى إنشاء الصور ومقاطع الصوت، يمكنك الحصول على أقصى استفادة من الكمبيوتر المدعوم بالذكاء الاصطناعي لديك. تساعد وحدات التسريع المدعومة بالذكاء الاصطناعي والمدمجة في المعالج على الحفاظ على خصوصية بياناتك وإمكانية الوصول إليها.<sup>41</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4_laptop.png",
                    "tr_title": "أداء متعدد الخيوط للمهام الضخمة",
                    "tr_subtitle": "حقق مستويات جديدة من الإنتاجية مع الأساسات المحسَّنة والمُصممة خصيصًا لرفع مستوى الألعاب والبث التدفقي وإنشاء المحتوى لديك إلى آفاق جديدة. <br><br/>يسمح لك تحسين الأداء متعدد الخيوط بإتمام المهام المتعددة — أو حتى المهام الضخمة — مع أقل قدر من الانقطاعات.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel5_laptop.png",
                    "tr_title": "سهِّل عمليات الاتصال لديك",
                    "tr_subtitle": "تجنب الإحباط الناتج عن البطء، مع تقنية Intel® Wi-Fi 7 المتوفرة وتقنية Intel® Wi-Fi 6E المدمجة.<sup>49</sup> <br><br/>قم بتبسيط توصيلات الكابلات باستخدام أحدث إصدارات تقنية ™Thunderbolt، حيث إنها أسرع منفذ في أجهزة الكمبيوتر المحمولة<sup>50</sup> لتوصيل كل الأجهزة الطرفية، بما في ذلك الكاميرا والشاشات وأجهزة التخزين.<sup>51</sup>​",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "نسخة منك، أسرع وأقوى.",
                  "tr_pretitle": "Intel®‎ Core™‎ Ultra [XX] من السلسلة 3",
                  "tr_subtitle": "هذه هي قوة Intel Inside®‎.",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                  "badgeUrl1": "assets/images/badges/copilot_plus_ptl.svg"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ليس مجرد جهاز كمبيوتر آخر،<br/>إنه جهاز الكمبيوتر الخاص بك.",
                  "tr_subtitle": "عالمك كله بين يديك على الكمبيوتر المحمول. لهذا السبب توفر أجهزة الكمبيوتر المحمولة المزودة <span class='processor_bold'>بمعالجات Intel® Core™ Ultra من السلسلة 3</span> جميع الإمكانات التي تتطلبها مهامك اليومية:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "أبدع والعب وأنجز المهام، بشحنة واحدة"
                    },
                    {
                      "tr_title": "أداء يواكب تنقلاتك"
                    },
                    {
                      "tr_title": "ألعابك وتطبيقاتك المفضلة تعمل بسلاسة"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "أبدع والعب وأنجز المهام، بشحنة واحدة.",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "أداء يواكب سرعتك.",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "ألعاب فائقة الوضوح وأداء فائق السرعة",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "رسوميات تجسد رؤيتك على أرض الواقع.",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "تصميمات تعكس أسلوبك.",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "أفضل تجربة متكاملة<br/>لأجهزة الكمبيوتر المحمولة.<sup>1</sup>",
                  "tr_subtitle": "تم التحقق من كفاءة كل كمبيوتر محمول Intel® Evo™‎ Edition نحيف وخفيف لتقديم تجربة استثنائية تتميز بجاهزية تامة وسرعة فائقة في كل وقت ومصممة لتناسب المستقبل.",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel3.svg",
                  "badgeUrl": "assets/images/badges/evo_ultra_ptl.svg",
                  "titleArray": [
                    {
                      "tr_title": "أداء أثناء التنقل."
                    },
                    {
                      "tr_title": "عمر بطارية واقعي."
                    },
                    {
                      "tr_title": "شحن سريع."
                    },
                    {
                      "tr_title": "بدء تشغيل فوري من وضع السكون."
                    },
                    {
                      "tr_title": "وغيرها من المزايا"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "قد تختلف نتائج النظام الفردية اختلافًا كبيرًا بناءً على التكوينات والاستخدام وعوامل أخرى. تعرّف على المزيد عبر www.Intel.com/PerformanceIndex.<br/><br/>قد تتطلب ميزات الذكاء الاصطناعي شراء برامج أو الاشتراك فيها أو تمكينها بواسطة أحد موفّري البرامج أو الأنظمة الأساسية، أو قد تكون لها متطلبات محددة فيما يتعلق بالتكوين أو التوافق. تشير مزايا زمن استجابة البيانات وتكلفتها وخصوصيتها إلى تطبيقات الذكاء الاصطناعي غير المستندة إلى السحابة. تعرّف على المزيد عبر intel.com/AIPC.<br/><br/>لا يمكن أن يكون أي منتج أو مكون آمنًا تمامًا.<br/><br/>قد تختلف تكاليفك ونتائجك.<br/><br/>قد تتطلب تقنيات Intel تشغيل أجهزة أو برامج أو تفعيل خدمات.<br/><br/>© Intel Corporation. إن Intel وشعار Intel وعلامات Intel الأخرى هي علامات تجارية لشركة Intel أو الشركات التابعة لها. قد تكون الأسماء والعلامات التجارية الأخرى ملكًا لأصحابها المعنيين."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL_12XE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_pretitle": "<span class='processor_bold'>معالج Intel® Core™ Ultra [XX] </span>مع رسوميات <span class='processor_bold'>Intel® Arc™‎ مدمجة</span>",
                  "tr_title": "لم يعد حجم الكمبيوتر عائقًا أمام أفكارك الكبيرة.",
                  "tr_subtitle": "",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel1.png",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                  "badgeUrl1": "assets/images/arc-badge.svg",
                  "titleArray": [
                    {
                      "tr_title": "رسوميات تضاهي جودة الأستوديو في تصميمات فائقة الأناقة"
                    },
                    {
                      "tr_title": "سريع وهادئ وجاهز عندما يجيئك الإلهام"
                    },
                    {
                      "tr_title": "عمر بطارية بقوّة أفكارك وطموحاتك"
                    }
                  ],
                  "tr_subtitle2": "قد تختلف نتائج النظام الفردية اختلافًا كبيرًا بناءً على التكوينات والاستخدامات وعوامل أخرى. تعرّف على المزيد عبر www.Intel.com/PerformanceIndex. © Intel Corporation"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "ليس مجرد جهاز كمبيوتر آخر،<br/>إنه جهاز الكمبيوتر الخاص بك.",
                  "tr_subtitle": "عالمك كله بين يديك على الكمبيوتر المحمول. لهذا السبب توفر أجهزة الكمبيوتر المحمولة المزودة <span class='processor_bold'>بمعالجات Intel® Core™ Ultra من السلسلة 3</span> جميع الإمكانات التي تتطلبها مهامك اليومية:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "أبدع والعب وأنجز المهام، بشحنة واحدة"
                    },
                    {
                      "tr_title": "أداء يواكب تنقلاتك"
                    },
                    {
                      "tr_title": "ألعابك وتطبيقاتك المفضلة تعمل بسلاسة"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "أبدع والعب وأنجز المهام، بشحنة واحدة.",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "أخيرًا، بطارية لن<br/>تعوق إبداعك.",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "أنشئ المحتوى نهارًا<br/>والعب ليلًا.",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "رسومات مدمجة تقدّم أداءً يفوق التوقعات.",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "تصميمات تعكس أسلوبك.",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "قد تختلف نتائج النظام الفردية اختلافًا كبيرًا بناءً على التكوينات والاستخدامات وعوامل أخرى. تعرّف على المزيد عبر www.Intel.com/PerformanceIndex.<br/><br/> قد تتطلب ميزات الذكاء الاصطناعي شراء برامج أو الاشتراك فيها أو تمكينها بواسطة أحد موفّري البرامج أو الأنظمة الأساسية، أو قد تكون ذات متطلبات محددة فيما يتعلق بالتكوين أو التوافق. تشير مزايا زمن استجابة البيانات وتكلفتها وخصوصيتها إلى تطبيقات الذكاء الاصطناعي غير المستندة إلى السحابة. تعرّف على المزيد عبر intel.com/AIPC.<br/><br/> لا يمكن لأيّ منتج أو مكوّن أن يوفر الأمان المطلق.<br/><br/> قد تختلف التكاليف والنتائج.<br/><br/> قد تتطلب تقنيات Intel‎ تنشيط خدمة أو برامج أو أجهزة ممكَّنة.<br/><br/> © Intel Corporation. إن Intel وشعار Intel وعلامات Intel الأخرى هي علامات تجارية لشركة Intel أو الشركات التابعة لها. قد تكون الأسماء والعلامات التجارية الأخرى ملكًا لأصحابها المعنيين."
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "graphics": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_tileTitle1": "الرسوميات المخصصة",
                "tr_title": "ما المقصود بوحدة معالجة الرسوميات؟",
                "tr_pretitle": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "تنشئ وحدة معالجة الصور تلك الصور التي تراها على الشاشة.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "وحدة معالجة رسوميات مضمّنة",
                    "tr_badgeSubTitle": "تستخدم وحدة معالجة الرسوميات المضّمنة ذاكرة RAM نفسها كباقي أجزاء الكمبيوتر، ما يجعلها أكثر فعالية في استهلاك الطاقة.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "وحدة معالجة رسوميات منفصلة",
                    "tr_badgeSubTitle": "تُعدّ هذه الفئة الأقوى من بين كل فئات وحدات معالجة الرسوميات لأنها تتمتع بذاكرة RAM خاصة بها وبموارد أخرى مخصصة لتوفير رسوميات استثنائية.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-hybrid-GPU-badge.png",
                    "tr_badgeTitle": "وحدة معالجة رسوميات هجينة",
                    "tr_badgeSubTitle": "تُعدّ هذه الفئة الأقوى من بين كل فئات وحدات معالجة الرسوميات لأنها تتمتع بذاكرة RAM خاصة بها وبموارد أخرى مخصصة لتوفير رسوميات استثنائية.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/video-editing.png",
                    "tr_badgeTitle": "تحرير سلس للصور ومقاطع الفيديو",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/binge-4k.svg",
                    "tr_badgeTitle": "استمتع بمحتوى فيديو بدقة 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/games.svg",
                    "tr_badgeTitle": "تشغيل ألعاب شائعة بتفاصيل مذهلة",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics_dual_gpus.svg",
                    "tr_badgeTitle": "وحدات معالجة رسوميات مزدوجة",
                    "tr_badgeSubTitle": "يمكن أن تستفيد بعض الأنظمة، مثل تلك المزودة برسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎ من كل من وحدة معالجة الرسوميات في المعالج والمنفصلة لتوزيع عبء عمل الرسوميات.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "وحدة معالجة رسوميات مضمّنة",
                    "tr_badgeSubTitle": "وحدة معالجة الرسوميات المدمجة تضمّن في الشريحة نفسها كالمعالج الرئيسي أو وحدة المعالجة المركزية. ويستخدم هذا النوع من وحدات معالجة الرسوميات ذاكرة RAM والموارد الأخرى نفسها كمكونات الكمبيوتر الأخرى، ما يسمح بتعزيز الكفاءة في استهلاك الطاقة وبالحصول على جهاز أقل سمكًا وأخف وزنًا.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "وحدة معالجة رسوميات مخصصة",
                    "tr_badgeSubTitle": "تُعدّ هذه الفئة الأقوى من بين كل فئات وحدات معالجة الرسوميات لأنها تتمتع بذاكرة RAM خاصة بها وبموارد أخرى مخصصة لتوفير رسوميات استثنائية.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "",
                "panelType2": "gaming-graphics",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "قياسي",
                    "tr_badgeSubTitle": "ذاكرة VRAM بسعة تصل إلى 4 غيغابايت",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "تنافسي",
                    "tr_badgeSubTitle": "ذاكرة VRAM تصل إلى 8 غيغابايت",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "فائق",
                    "tr_badgeSubTitle": "ذاكرة VRAM بسعة تفوق 8 غيغابايت",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "قوة رسوميات مذهلة",
                "tr_pretitle": "[graphic_display]",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تتطلب أقوى عملية معالجة رسوميات بطاقة رسوميات يمكنها التركيز حصريًا على إنشاء صور جميلة وواضحة ورسوم متحركة سلسة.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PLUS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "رسوميات مدمجة غنية ونابضة بالحياة",
                "tr_pretitle": "رسوميات Intel®‎ Iris®‎ Plus",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تتيح لك رسوميات Intel®‎ Iris®‎ Plus الانغماس في عالم تشغيل الألعاب العالية الوضوح ومقاطع الفيديو بدقة 4K وبنطاق ديناميكي عالٍ من دون الحاجة إلى استخدام بطاقة رسوميات إضافية.",
                "badgeUrl": "assets/images/badges/intel-IRIS-plus.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "أنقى صورة، أداء بدون عناء",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "توفر رسوميات Intel® أداءً رسوميًا تحويليًا متكاملًا لدعم التصميم السلس للمبدعين وتجارب تشغيل الألعاب الغنية.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "رسوميات Intel®‎ Iris®‎ Pro",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "UHD_FEATURING_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "رسوميات Intel®‎ UHD مع هندسة X<sup class='small_text_sup_xe'>e</sup>‎",
                "tr_pretitle": "تجارب مرئية غامرة",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_text1": "اختبر تحرير الصور ومقاطع الفيديو السلسين واستمتع بمحتوى فيديو متميز بدقة 4K أو تشغيل الألعاب الشائعة بتفاصيل مذهلة.",
                "tr_photo_text": "تحرير سلس للصور ومقاطع الفيديو",
                "tr_video_text": "استمتع بمحتوى فيديو بدقة 4K",
                "tr_game_text": "تشغيل ألعاب شائعة بتفاصيل مذهلة",
                "badgeUrl": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "أكثر من مجرّد صور جميلة",
                "tr_subtitle": "يساعدك العمل عن كثب مع المعالج (أو وحدة المعالجة المركزية) وبطاقة الصور (أو وحدة معالجة الرسوميات) في تحديد طريقة تشغيل ألعابك وطريقة عرضها. تُعدّ ذاكرة VRAM، أو ذاكرة RAM للفيديو، المكرّسة لإنشاء الصور فقط، طريقةً سريعة لمعرفة قدرات وحدة معالجة الرسوميات لديك.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_630",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "لرسوميات الألعاب المكثّفة",
                "tr_subtitle": "تتطلب أقوى معالجة للرسوميات بطاقة رسوميات منفصلة يمكنها التركيز حصريًا على إنشاء صور جميلة ونقية ورسوم متحركة سلسة",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "Intel_UHD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "لرسوميات الألعاب المكثّفة",
                "tr_subtitle": "تتطلب أقوى معالجة للرسوميات بطاقة رسوميات منفصلة يمكنها التركيز حصريًا على إنشاء صور جميلة ونقية ورسوم متحركة سلسة",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "أكثر من مجرّد صور جميلة",
                "tr_subtitle": "يساعدك العمل عن كثب مع المعالج (أو وحدة المعالجة المركزية) وبطاقة الصور (أو وحدة معالجة الرسوميات) في تحديد طريقة تشغيل ألعابك وطريقة عرضها. تُعدّ ذاكرة VRAM، أو ذاكرة RAM للفيديو، المكرّسة لإنشاء الصور فقط، طريقةً سريعة لمعرفة قدرات وحدة معالجة الرسوميات لديك.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "قوة رسوميات مذهلة",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تتطلب أقوى عملية معالجة رسوميات بطاقة رسوميات يمكنها التركيز حصريًا على إنشاء صور جميلة وواضحة ورسوم متحركة سلسة.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "لرسوميات الألعاب المكثّفة",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_subtitle": "تتطلب أقوى عملية معالجة رسوميات بطاقة رسوميات يمكنها التركيز حصريًا على إنشاء صور جميلة وواضحة ورسوم متحركة سلسة.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "detailPageName": "LESS_THAN_0",
                    "tr_subtitle": "تتطلب أقوى معالجة للرسوميات بطاقة رسوميات منفصلة يمكنها التركيز حصريًا على إنشاء صور جميلة ونقية ورسوم متحركة سلسة",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "0_TO_4",
                    "tr_subtitle": "تقدم قوة رسوميات فائقة لتلبية أدنى متطلباتك على مستوى تشغيل الألعاب.",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "4_TO_8",
                    "tr_subtitle": "لمشغلي الألعاب الأكثر تطورًا الذين يسعون إلى تشغيل ألعاب على مستوى تنافسي",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "GREATER_THAN_8",
                    "tr_subtitle": "لمشغلي الألعاب المتقدمين الذين يستخدمون الكمبيوتر أيضًا لإنشاء محتوى معقد",
                    "tr_title": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_HD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "فيديو ينبض بالحياة وتشغيل ألعاب استثنائي",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "استفد إلى أقصى حد من الشاشة عالية الدقة بفضل صور Intel® HD واستمتع بتجربة وسائط غنية ومعالجة صور مدمجة.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_620",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "تشغيل صور ومقاطع فيديو نابضة بالحياة",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "استمتع بمزيد من التفاصيل وبألوان ساطعة عند مشاهدة مقاطع الفيديو و الصور مباشرةً عبر الإنترنت.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "إنشاء محتوى وتشغيل ألعاب مذهلان",
                "tr_pretitle": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "بدءًا من الترفيه الغامر وإنشاء المحتوى المتقدم ووصولًا إلى تشغيل الألعاب العادية، تضفي رسوميات Intel®‎ Iris® X<sup class='small_text_sup_xe'>e</sup>‎ أداءً ثوريًّا على مستوى الرسوميات على أجهزة الكمبيوتر الرفيعة الخفيفة الوزن.",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_pretitle": "لرسوميات الألعاب المكثّفة",
                "tr_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup>‎",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg",
                "tr_subtitle": "تتطلب أقوى معالجة للرسوميات بطاقة رسوميات منفصلة يمكنها التركيز حصريًا على إنشاء صور جميلة ونقية ورسوم متحركة سلسة",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [x] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE_MAX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "أطلق العنان للإبداع",
                "tr_pretitle": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup> MAX",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "استمتع بالانسياب التام في المشاريع الإبداعية وانغمس في شتى الألعاب بفضل القوة المجمعة للرسوميات داخل المعالج وأول محرك رسوميات منفصل من Intel®‎.",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "tr_title": "رسوميات Intel®‎ Iris®‎ X<sup class='small_text_sup_xe'>e</sup> MAX",
                "tr_pretitle": "لرسوميات الألعاب المكثّفة",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg",
                "tr_subtitle": "تتطلب أقوى معالجة للرسوميات بطاقة رسوميات منفصلة يمكنها التركيز حصريًا على إنشاء صور جميلة ونقية ورسوم متحركة سلسة",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>ذاكرة VRAM<br/></span><span class='subtitle-value'>سعة [x] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_tileTitle": "الرسوميات",
                "tr_title": "رسوميات جميلة مدمجة",
                "tr_subtitle": "استمتع بالألعاب والأفلام ومقاطع الفيديو على الويب بتفاصيل مدهشة ووضوح تام.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "ARC_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الرسوميات",
                "badgeUrl": "assets/images/arc-badge.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/arc_graphics/fallback_arc_graphics.svg",
                "tr_subtitle": "",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "",
                "tr_title": ""
              }
            }
          ],
          "factTagTypes": [
            {
              "factTagType": "Arc_Graphics_Panel_Content",
              "navText": [
                {
                  "specName": "Arc_Graphics_Badge_Icon",
                  "specDetails": {
                    "targetURL": "badgeIconUrl",
                    "tr_specTitle": "",
                    "tr_specText": ""
                  }
                },
                {
                  "specName": "Graphics_Boost_Workflow",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "دعم إضافي لأدائك في العمل"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "شغل الألعاب بالقوة الخارقة"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "شغل الألعاب بالقوة الخارقة"
                  }
                },
                {
                  "specName": "Graphics_Level_Up_Your_Game",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "ارتقِ بمستوى تشغيلك للألعاب"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel2.png",
                    "tr_specTitle": "أطلق العنان للإبداع",
                    "tr_specText": "سرّع إنتاجيتك أينما ذهبت بفضل قدرات الوسائط الأكثر شمولًا، مثل <strong>ترميز AV1 بالعتاد الأول من نوعه في المجال</strong> وكذلك إنشاء المحتوى المسرّع بالذكاء الاصطناعي.<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel2.png",
                    "tr_specTitle": "أطلق العنان للإبداع",
                    "tr_specText": "سرّع إنتاجيتك بفضل قدرات الوسائط الأكثر شمولًا، مثل <strong>ترميز AV1 بالعتاد الأول من نوعه في المجال</strong> وكذلك إنشاء المحتوى المسرّع بالذكاء الاصطناعي.<sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel3.png",
                    "tr_specTitle": "أطلق العنان للإبداع",
                    "tr_specText": "استمتع بتجربة إنشاء المحتوى المتطور المسرع بالذكاء الاصطناعي باستخدام <strong>ترميز AV1 بالعتاد الأول من نوعه في المجال</strong> ومحرك الوسائط <strong>X<sup>e</sup> المتقدم.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "أطلق العنان للإبداع",
                    "tr_specText": "استمتع بتجربة إنشاء المحتوى المتطور المسرع بالذكاء الاصطناعي باستخدام <strong>ترميز AV1 بالعتاد الأول من نوعه في المجال</strong> ومحرك الوسائط <strong>X<sup>e</sup> المتقدم.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_12",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "أطلق العنان للإبداع",
                    "tr_specText": "استمتع بتجربة إنشاء المحتوى المتطور المسرع بالذكاء الاصطناعي باستخدام <strong>ترميز AV1 بالعتاد الأول من نوعه في المجال</strong> ومحرك الوسائط <strong>X<sup>e</sup> المتقدم.</strong><sup>22</sup>"
                  }
                },
                {
                  "specName": "Portability_Meets_Performance",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel3.png",
                    "tr_specTitle": "سهولة تنقل ومستوى أداء مرتفع",
                    "tr_specText": "استمتع بلعب أحدث الألعاب أثناء التنقل واحصل على أداء معزز ودقة صورة لا مثيل لها بفضل قدرات تشغيل الألعاب الحديثة. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel4.png",
                    "tr_specTitle": "تحكم في ألعابك تحكمًا كاملًا",
                    "tr_specText": "تمكنك <strong>لوحة تحكم Intel®‎ Arc™‎</strong> من تحسين تجربتك عن طريق ما تتمتع به من تصميم بسيط وحديث. احصل على تحديثات سلسة لبرامج التشغيل وتحسين تجربة تشغيل ألعابك والمزيد غير ذلك."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_panel4.png",
                    "tr_specTitle": "تحكم في ألعابك تحكمًا كاملًا",
                    "tr_specText": "تمكنك <strong>لوحة تحكم Intel®‎ Arc™‎</strong> من تحسين تجربتك عن طريق ما تتمتع به من تصميم بسيط وحديث. احصل على تحديثات سلسة لبرامج التشغيل وتحسين تجربة تشغيل ألعابك والمزيد غير ذلك."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_1",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel4.png",
                    "tr_specTitle": "تحكم في ألعابك تحكمًا كاملًا",
                    "tr_specText": "احصل على تحديثات سلسة لبرامج التشغيل وتحسين تجربة تشغيل العديد من ألعابك المفضلة باستخدام برنامج <strong>لوحة تحكم Intel®‎ Arc™‎</strong>."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop2",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_newPanel5.png",
                    "tr_specTitle": "حسّن أداء منصة Intel®‎ لديك إلى أقصى حد",
                    "tr_specText": "اقرن جهازك مع معالجات Intel®‎ Core™‎ المتوافقة لإطلاق العنان لتقنية <strong>Intel®‎ Deep Link </strong>لتحسين تجربة إنشاء المحتوى وتشغيل الألعاب والبث التدفقي."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_A580",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_newPanel5.png",
                    "tr_specTitle": "حسّن أداء نظام Intel®‎ لديك إلى أقصى حد",
                    "tr_specText": "اقرن جهازك مع معالجات Intel®‎ Core™‎ المتوافقة لإطلاق العنان لتقنية <strong>Intel®‎ Deep Link </strong>لتحسين تجربة إنشاء المحتوى وتشغيل الألعاب والبث التدفقي."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel5.png",
                    "tr_specTitle": "حسّن أداء منصة Intel®‎ لديك إلى أقصى حد",
                    "tr_specText": "اقرن جهازك مع معالجات Intel®‎ Core™‎ المتوافقة لإطلاق العنان لتقنية <strong>Intel®‎ Deep Link </strong>لتحسين تجربة إنشاء المحتوى وتشغيل الألعاب والبث التدفقي."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "حسّن أداء منصة Intel®‎ لديك إلى أقصى حد",
                    "tr_specText": "اقرن جهازك مع معالجات Intel®‎ Core™‎ المتوافقة لإطلاق العنان لتقنية <strong>Intel®‎ Deep Link </strong>لتحسين تجربة إنشاء المحتوى وتشغيل الألعاب والبث التدفقي."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_System",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "حسّن أداء نظام Intel®‎ لديك إلى أقصى حد",
                    "tr_specText": "اقرن جهازك مع معالجات Intel®‎ Core™‎ المتوافقة لإطلاق العنان لتقنية <strong>Intel®‎ Deep Link </strong>لتحسين تجربة إنشاء المحتوى وتشغيل الألعاب والبث التدفقي."
                  }
                },
                {
                  "specName": "Take_Center_Stage",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel4.png",
                    "tr_specTitle": "كن في الصدارة",
                    "tr_specText": "استمتع بتجربة بث سلسة باستخدام تقنيات البث التدفقي المتقدمة التي يتم تمكينها بواسطة برنامج <strong>لوحة تحكم Intel®‎ Arc™‎</strong>."
                  }
                },
                {
                  "specName": "Take_Center_Stage_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel4.png",
                    "tr_specTitle": "كن في الصدارة",
                    "tr_specText": "استمتع بتجربة بث سلسة باستخدام تقنيات البث التدفقي المتقدمة التي يتم تمكينها بواسطة برنامج <strong>لوحة تحكم Intel®‎ Arc™‎</strong>."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "استمتع بتجربة شاملة في تشغيل ألعاب عالية الأداء ",
                    "tr_specText": "أعط الأولوية لأفضل أداء في أحدث ألعاب AAA بدقة عالية ومعدل مرتفع من عدد الإطارات في الثانية. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel2.png",
                    "tr_specTitle": "استمتع بتجربة شاملة في تشغيل ألعاب عالية الأداء ",
                    "tr_specText": "أعط الأولوية لأفضل أداء في أحدث ألعاب AAA بدقة عالية ومعدل مرتفع من عدد الإطارات في الثانية. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Give_Your_Games_A_Boost",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel3.png",
                    "tr_specTitle": "قم بتحسين تجربتك في تشغيل الألعاب",
                    "tr_specText": "قم بترقية مستوى تجربة تشغيل ألعابك إلى المستوى التالي باستخدام: <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Experience_Advanced_Fast_Paced_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel2.png",
                    "tr_specTitle": "استمتع بتجربة تشغيل ألعاب متقدم سريعة الوتيرة",
                    "tr_specText": "استمتع بتجربة تشغيل ألعاب سلسة في العديد من ألعاب AAA الشائعة، والألعاب ذات معدل التحديث المرتفع بدءًا من ألعاب الرياضة الإلكترونية في الرماية ذات الحس التحفيزي العالي وصولًا إلى ألعاب الاستراتيجية في الوقت الفعلي. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "استمتع بتجربة شاملة في تشغيل ألعاب عالية الأداء ",
                    "tr_specText": "أعط الأولوية لأفضل أداء في أحدث ألعاب AAA بدقة عالية ومعدل مرتفع من عدد الإطارات في الثانية. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):  </strong>تقنية ترقية صور معززة بالذكاء الاصطناعي من Intel®‎ لتحسين مستوى الأداء والاستمتاع بتجربة تشغيل ألعاب سلسة. <br/><br/>دعم <strong>DirectX*‎ 12 Ultimate:  </strong>قم بترقية مستوى تجربة تشغيل ألعابك إلى مستوى جديد من الواقعية باستخدام تقنيات رسوميات مثل: تقنية تتبع الأشعة وتقنية الرسم المتغير."
                  }
                },
                {
                  "specName": "Graphics_Universe",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "عالم رسوميات يشمل مساحة للجميع"
                  }
                },
                {
                  "specName": "Accelerate_Your_Frames",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel2.png",
                    "tr_specTitle": "صورة من دون تقطيع، وتجربة ألعاب سلسة وسريعة",
                    "tr_specText": "ترتقي تقنية Intel® X<sup class='small_text_sup_xe'>e</sup> Super Sampling (X<sup class='small_text_sup_xe'>e</sup>SS) بمستوى الألعاب لديك بفضل رفع مستوى تقنيات الذكاء الاصطناعي، ما يجعلك تستمتع بأعلى أداء وأفضل جودة للصورة. تم تحسين تقنية X<sup class='small_text_sup_xe'>e</sup>SS للمنتجات المزودة برسوميات Intel®‎ Arc™‎ بحيث تمنحك أقصى استفادة من سرعة الجهاز  Intel® X<sup class='small_text_sup_xe'>e</sup> Matrix Extensions (Intel® XMX)."
                  }
                },
                {
                  "specName": "Ultimate_Visuals_Are_Here",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel3.png",
                    "tr_specTitle": "استمتع بأنقى صورة",
                    "tr_specText": "بفضل الدعم الكامل لبرنامج DirectX* 12 Ultimate على كل رسوميات Intel®‎ Arc™‎، ستستمتع بتجربة ألعاب رائعة وغامرة بفضل أحدث تقنيات الرسوميات مثل تتبع الأشعة، والرسم المتغير، وتظليل الشبكة، وملاحظات العينات؛ وهذه التقنيات هي الجيل القادم من الألعاب."
                  }
                },
                {
                  "specName": "Seamless_Photos_And_Videos",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel4.png",
                    "tr_specTitle": "إنشاء محتوى الصور والفيديو والوسائط بكل سلاسة",
                    "tr_specText": "أطلق العنان لخيالك واجذب انتباه الجماهير من خلال إنشاء محتوى رقمي غني باستخدام محرك وسائط فائق التقدم معزز بالذكاء الاصطناعي ومُسرَّع بتقنية Intel®‎. يمكنك إنشاء محتوى لا مثيل له، مدعوم بالرسوميات بالإضافة إلى دعم جميع تنسيقات الوسائط الرائدة الحالية ومواكبة أحدث إمكانات ترميز الفيديو AV1."
                  }
                },
                {
                  "specName": "Experience_Cutting_Edge",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel5.png",
                    "tr_specTitle": "استمتع بتجربة إنشاء محتوى وتشغيل ألعاب رائدة معززة بالذكاء الاصطناعي",
                    "tr_specText": "تطلق رسوميات Intel®‎ Arc™‎ العنان لإمكانات الذكاء الاصطناعي القوية، بدايةً من تقنيات إنشاء المحتوى المتقدمة وحتى تشغيل الألعاب الغامرة. احصل على أقصى استفادة من برامج إنشاء المحتوى المتقدمة اليوم، بما في ذلك برامج تحويل النص إلى صورة وبرامج تحرير الفيديو المسرَّعة بالذكاء الاصطناعي. إضافة إلى ذلك، استمتع بتجربة ألعاب عالية الدقة من خلال تقنية X<sup class='small_text_sup_xe'>e</sup>SS المسرَّعة بالذكاء الاصطناعي."
                  }
                },
                {
                  "specName": "Professional_Graphics",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc_pro_badge.png",
                    "tr_specTitle": "الرسوميات",
                    "tr_specText": "الرسوميات الاحترافية منبعها من هنا"
                  }
                },
                {
                  "specName": "Designers_And_Engineers",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel2.png",
                    "tr_specTitle": "ممتاز للمبدعين والمصممين والمهندسين الذين يعملون في أثناء التنقل",
                    "tr_specText": "تتوفر رسوميات Intel® Arc™ Pro المدمجة في معالجات Intel® Core™ Ultra محددة من السلسلة H وتمنحك تحسينات مضاعفة في أداء الرسوميات بالإضافة إلى شهادات مورد البرامج المستقل (ISV)، ما يعطيك مزيدًا من الموثوقية ويمنحك سرعة فعالة لتقنيات الذكاء الاصطناعي وتتبع الأشعة، الأمر الذي يُفضي إلى تجربة إنشاء محتوى رائعة في أثناء التنقل.<br/><br/><span class='expandable_heading'>شهادات البرامج<br/></span><br/>تعاونت شركة Intel جنبًا إلى جنب مع مئات شركات البرامج على مدار سنوات، وقد أثمرت هذه التجربة التي لا تضاهى عن السلسلة A من بطاقات الرسوميات Intel® Arc™ Pro. الشهادات لا تقل أهمية عندنا كما هو عندكم."
                  }
                },
                {
                  "specName": "Making_Ai_Attainable",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "توفير تقنيات الذكاء الاصطناعي",
                    "tr_specText": "يتضمن نطاق وحدة معالجة الرسوميات مجموعة كبيرة من التقنيات الرائعة، بما في ذلك دعم الأدوات المتوافقة مع الذكاء الاصطناعي المدمج فيها ميزة تسريع مخصصة تعمل بالذكاء الاصطناعي بحيث تستخدمها وقت الحاجة."
                  }
                },
                {
                  "specName": "Ray_Tracing",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "تتبع الأشعة من دون الحاجة إلى حزمة متميزة",
                    "tr_specText": "ينبغي أن تفعل بطاقات الرسوميات أشياء أكبر من مجرد عرض وحدات البيكسل على الشاشات، ومنها تسريع إنشاء الصور الجميلة. تتيح تقنية أجهزة تتبع الأشعة المدمجة في رسوميات Intel® Arc™ Pro من السلسلة A لبرنامجك المتوافق أن يبدأ في استعراض تدفقات سير العمل الاحترافية الجديدة. عادةً ما يُعتقد أن تقنية تتبع الأشعة لا تتوافر إلا على الرسوميات غالية الثمن، ولكن مجموعة الرسوميات الاحترافية الأخيرة من Intel تكسر هذه التوقعات."
                  }
                },
                {
                  "specName": "Immersive_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel5.png",
                    "tr_specTitle": "تمكين منشئي المحتوى مع شاشات عرض غامرة",
                    "tr_specText": "بفضل الدعم الكامل لبرنامج DirectX* 12 Ultimate على كل رسوميات Intel®‎ Arc™‎، ستستمتع بتجربة ألعاب رائعة وغامرة بفضل أحدث تقنيات الرسوميات مثل تتبع الأشعة، والرسم المتغير، وتظليل الشبكة، وملاحظات العينات؛ وهذه التقنيات هي الجيل القادم من الألعاب."
                  }
                },
                {
                  "specName": "Dynamically_Optimised_Images",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel6.png",
                    "tr_specTitle": "صور محسنة ديناميكيًا",
                    "tr_specText": "بفضل فك ترميز الأجهزة المخصص على وحدات معالجة الرسوميات المتقدمة (Pro)، تساعد تقنية Dolby Vision* على إضافة عمق أكبر وتباين أكثر وضوحًا والمزيد من الألوان إلى شاشتك المتوافقة. تفتح تقنية Dolby Vision* كل الآفاق لإمكانات تقنية HDR من خلال تحسين جودة الصور ديناميكيًا بناءً على نوعية المحتوى ونوع الشاشة والمنصة من أجل إخراج محتوى مرئي رائع في كل مرة."
                  }
                },
                {
                  "specName": "Expertly_Verified_Software",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel2.png",
                    "tr_specTitle": "برامج تحقق منها الخبراء",
                    "tr_specText": "تعاونت شركة Intel جنبًا إلى جنب مع مئات شركات البرامج على مدار سنوات، وقد أثمرت هذه التجربة التي لا تضاهى عن مجموعة رسوميات Intel® Arc™ Pro الاحترافية من السلسلة A. الشهادات واعتمادات تدفق سير عمل البرامج لا تقل أهمية عندنا كما هو عندكم."
                  }
                },
                {
                  "specName": "Ray_Tracing_Mobile",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel3.png",
                    "tr_specTitle": "تتبع الأشعة من دون الحاجة إلى حزمة متميزة",
                    "tr_specText": "ينبغي أن تفعل بطاقات الرسوميات أشياء أكبر من مجرد عرض وحدات البيكسل على الشاشات، ومنها تسريع إنشاء الصور الجميلة. تتيح تقنية أجهزة تتبع الأشعة المدمجة في رسوميات Intel® Arc™ Pro من السلسلة A لبرنامجك المتوافق أن يبدأ في استعراض تدفقات سير العمل الاحترافية الجديدة. عادةً ما يُعتقد أن تقنية تتبع الأشعة لا تتوافر إلا على الرسوميات غالية الثمن، ولكن مجموعة الرسوميات الاحترافية الأخيرة من Intel تكسر هذه التوقعات."
                  }
                },
                {
                  "specName": "Multiple_Large_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel4.png",
                    "tr_specTitle": "توصيل عدة شاشات كبيرة الحجم بوحدة معالجة رسوميات صغيرة محمولة",
                    "tr_specText": "يمكن لرسوميات Intel® Arc™ Pro في أجهزة الكمبيوتر المحمولة دعم ما يصل إلى أربع شاشات كبيرة الحجم، ما يعزز من كفاءات تدفق سير العمل. أضف دعم النطاق الديناميكي العالي (HDR) وستحصل على كل ما تحتاج إليه كي تنشئ محتوى رائعًا على مواقع التواصل الاجتماعي بفضل إعداد الشاشات المتعددة سواءً في المنزل أو في المكتب."
                  }
                },
                {
                  "specName": "Full_Memory_Bandwidth",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel5.png",
                    "tr_specTitle": "إمكانية عرض النطاق الترددي الكامل للذاكرة",
                    "tr_specText": "يعد النطاق الترددي لبطاقة الرسوميات من الجوانب المهمة في محطة العمل. يؤدي عدم التوافق إلى إبطاء تدفقات سير العمل الاحترافية، ولهذا حرصنا في وحدة معالجة الرسوميات Intel® Arc™ Pro من السلسلة A أن تدعم واجهة PCIe* 4.0 الحديثة، من دون المساس بالتوافق مع الإصدارات السابقة. تم تحسين ذاكرة الرسوميات بشكل أكبر من خلال سرعة النطاق الترددي العالية، ما يتيح للبرنامج أن يصل إلى بيانات المشروع بشكل أسرع."
                  }
                },
                {
                  "specName": "Breathe_Life",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel2.png",
                    "tr_specTitle": "سينبض كل إطار في الصورة بالحياة",
                    "tr_specText": "<span class='expandable_heading'>معزز بالذكاء الاصطناعي. بدعم من شركة Intel. <br/></span><br/>تعد Intel® X<sup class='small_text_sup_xe'>e</sup>SS تقنية ذات مستوى عالٍ ومعززة بالذكاء الاصطناعي تدعم أداءك من دون التضحية بنقاء كل إطار في الصورة، ومن ثم يمكنك الاستمتاع بتجربة ألعاب بالطريقة المرجوة من اللعبة."
                  }
                },
                {
                  "specName": "Real_Immersive",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel3.png",
                    "tr_specTitle": "في الوقت الفعلي.<br/> صورة غامرة حقيقية.<br/> الواقعية في أنقى صورها.",
                    "tr_specText": "ثمة عوالم أكثر واقعية في انتظارك. بفضل تقنية تتبع الأشعة المدمجة، ستستمتع بكل شيء بدءًا من الظلال والانعكاسات الواقعية وحتى الإضاءة الرائعة. بعبارة أخرى، ستستمتع بصورة ألعاب لن ترغب في تفويتها."
                  }
                },
                {
                  "specName": "Your_Best_Gameplay",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel4.png",
                    "tr_specTitle": "أفضل تجربة ألعاب يمكن أن تشاركها",
                    "tr_specText": "قدّم لجمهورك تجربة الألعاب السلسة التي يستحقون رؤيتها. بفضل إمكانيات الترميز AV1 المسرَّعة بالأجهزة في رسوميات Intel®‎ Arc™‎، ستأسرهم كل خطوة تخطوها. جودة بصرية أعلى بنفس معدل البت الذي يعادل أفضل بث تدفقي لديك مع توفير النطاق الترددي."
                  }
                },
                {
                  "specName": "Welcome_All_Creators",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel5.png",
                    "tr_specTitle": "مرحبًا بكل منشئي المحتوى",
                    "tr_specText": "باتت تجارب الذكاء الاصطناعي الجديدة والمحسنة أقرب إليك. بفضل مسرِّعات الذكاء الاصطناعي المتقدمة المدمجة في رسوميات Intel® Arc™ A-series، يمكنك قضاء وقت أطول في الإنشاء ووقت أقل في الانتظار عبر العديد من التطبيقات.<br/><br/>ارتقِ بإنشاء مقاطع الفيديو إلى المستوى التالي، وتقدّم على الآخرين باستخدام فيديو AV1 عالي الجودة والفعال من حيث مساحة التخزين، وذلك بدعم إمكانات أجهزة AV1 المتقدمة المضمنة في رسوميات Intel® Arc™‎."
                  }
                },
                {
                  "specName": "Graphics_Universe_B",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "تقنيات متطورة، ورسوميات أفضل، وتجربة ألعاب محسنة.",
                    "tr_specText": "استمتع بالألعاب، وأنشئ المحتوى، وابتكر بحرية"
                  }
                },
                {
                  "specName": "Game_Ready",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel1.png",
                    "tr_specTitle": "تجهَّز لتجربة الألعاب مع حزمة ميزات متكاملة",
                    "tr_specText": "استمتع بأداء عالٍ في أحدث الألعاب بدقة <strong>1080 بكسل</strong> و<strong>1440 بكسل</strong> بفضل تحسين الذكاء الاصطناعي وتتبع الأشعة.<br><br/> استمتع بالأداء والمزايا التي تتوقعها بأسعار معقولة.",
                    "subSpecs": [
                      {
                        "tr_title": "دقة<strong><br>1440 بكسل</strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Game_Changing_Modern_Tech",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel2.png",
                    "tr_specTitle": "تقنيات حديثة ترتقي بتجارب الألعاب",
                    "tr_specText": "ارتقِ بمستوى الأداء والاستجابة وغيرها من الميزات بفضل التقنيات المتقدمة في الرسوميات ™Intel® Arc المخصصة لتشغيل الألعاب.<br><br/> استمتع بمستوى فائق من الأداء وجودة الصورة في أكثر من 150 لعبة بفضل تقنية Intel® X<sup>e</sup> Super Sampling (X<sup>e</sup>SS) المعززة بالذكاء الاصطناعي.<br><br/> ارتقِ بمستوى السلاسة والاستجابة عند تشغيل الألعاب بفضل تقنية Intel® X<sup>e</sup>SS Frame Generation وتقنية Intel® X<sup>e</sup> Low Latency من Intel.",
                    "subSpecs": [
                      {
                        "tr_title": "ذاكرة بسعة<br><strong>10 غيغابايت</strong>"
                      },
                      {
                        "tr_title": "<strong>أكثر من 150<br></strong>لعبة"
                      },
                      {
                        "tr_title": "<strong>Intel® X<sup>e</sup>SS<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Software_Releases",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel3.png",
                    "tr_specTitle": "أحدث إصدارات البرامج",
                    "tr_specText": "احصل على أحدث إصدارات البرامج التي تدعم أحدث الألعاب واستمتع بتجارب ألعاب محسَّنة على الدوام."
                  }
                },
                {
                  "specName": "Creator_Toolkit",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel4.png",
                    "tr_specTitle": "مجموعة أدوات متعددة الاستخدامات لمنشئي المحتوى",
                    "tr_specText": "وفّر الوقت واستمتع بسرعة تصدير مقاطع الفيديو باستخدام محولات ترميز الوسائط المزدوجة التي تدعم الترميز المزدوج. أنشئ المحتوى مع دعم معظم التنسيقات الشهيرة للوسائط، بما في ذلك تنسيق AV1 الحديث.<br><br/> يمكّنك محرك الوسائط القوي Intel® X<sup>e</sup> من إنشاء المحتوى وتحريره بسرعة ودقة عالية."
                  }
                },
                {
                  "specName": "Explore_AI",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel5.png",
                    "tr_specTitle": "مصممة لاستكشاف إمكانات الذكاء الاصطناعي",
                    "tr_specText": "استكشف أحدث تجارب الذكاء الاصطناعي مثل تحويل النص إلى صورة وروبوتات الدردشة المدعومة بالذكاء الاصطناعي على جهازك مباشرةً. يوفر لك تطبيق AI Playground، المجاني والخاص، جميع إمكانات الذكاء الاصطناعي في تجربة سهلة الاستخدام.<br><br/> استمتع بتجربة ألعاب محسَّنة، وسرعة في إنشاء المحتوى، وأكثر من ذلك، بفضل محركات الذكاء الاصطناعي المتخصصة المدمجة في الرسوميات ™Intel® Arc المعروفة باسم Intel® Xe Matrix Extensions (Intel® XMX).",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>144</strong> محرك ذكاء اصطناعي<br>Intel® XMX"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "os": [
    {
      "contentType": "WINDOWS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "كل ما تحتاجه لإنجاز أعمالك",
                "tr_pretitle": "Windows* 10",
                "tr_subtitle": "أداء قوي في جهاز رفيع وخفيف ومصمم بحيث تحصل على جميع ما تريد. بفضل عمر البطارية الطويل، وشاشات اللمس الجميلة،* وأحدث محركات الأقراص ذات الحالة الصلبة (SSD)، ستجد ما تبحث عنه في جهاز كمبيوتر يعمل بنظام Windows 10.",
                "tr_noteSection": "* يعتمد على العتاد",
                "titleArray": [
                  {
                    "tr_title": "استهلاك أقل وعمر أطول",
                    "tr_subtitle": "عادةً ما تستهلك أجهزة الكمبيوتر الحديثة مقدارًا أقل من الطاقة، حتى تدوم البطارية لمدة أطول. ويصل ذلك في المتوسط إلى ما يزيد عن ثمانِ ساعات من تشغيل الفيديو.**",
                    "tr_noteSection": "**يختلف عمر البطارية اختلافًا كبيرًا باختلاف الجهاز، والإعدادات، والاستخدام، وعوامل أخرى."
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "header-IconTopGaming",
                "tr_pretitle": "كل ما تحتاجه لإنجاز أعمالك",
                "tr_title": "Windows* 10",
                "tr_subtitle": "أداء قوي في جهاز رفيع وخفيف ومصمم بحيث تحصل على جميع ما تريد. بفضل عمر البطارية الطويل، وشاشات اللمس الجميلة،* وأحدث محركات الأقراص ذات الحالة الصلبة (SSD)، ستجد ما تبحث عنه في جهاز كمبيوتر يعمل بنظام Windows 10.",
                "tr_noteSection": "*يختلف حسب الأجهزة.",
                "titleArray": [
                  {
                    "tr_title": "استهلاك أقل وعمر أطول",
                    "tr_subtitle": "عادةً ما تستهلك أجهزة الكمبيوتر الحديثة مقدارًا أقل من الطاقة، حتى تدوم البطارية لمدة أطول. ويصل ذلك في المتوسط إلى ما يزيد عن ثمانِ ساعات من تشغيل الفيديو.**",
                    "tr_noteSection": "**يختلف عمر البطارية اختلافًا كبيرًا باختلاف الجهاز، والإعدادات، والاستخدام، وعوامل أخرى."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWSUWP",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "صُمّم خصيصًا لتعزيز الأمان وتحسين مستوى الأداء",
                "tr_pretitle": "Windows*‎ 10 في وضع S",
                "tr_subtitle": "حينما تشغّل Windows*‎ 10 في وضع S سوف تتمتّع بمستوى إضافي من الحماية يمكّنك من العمل واللعب والاستكشاف وأنت واثق تمام الثقة أن جهازك آمن."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "صُمّم خصيصًا لتعزيز الأمان وتحسين مستوى الأداء",
                "tr_title": "Windows*‎ 10 في وضع S",
                "tr_subtitle": "حينما تشغّل Windows*‎ 10 في وضع S سوف تتمتّع بمستوى إضافي من الحماية يمكّنك من العمل واللعب والاستكشاف وأنت واثق تمام الثقة أن جهازك آمن."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_GENERIC",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "حقق إنجازات هائلة",
                "tr_pretitle": "Windows*‎",
                "tr_subtitle": "الأداء والسعر والكثير للاختيار من بينها. من أجهزة 2 في 1 المبتكرة إلى أجهزة الكمبيوتر المحمولة الرفيعة الخفيفة الوزن وشاشات اللمس ولوحات المفاتيح القابلة للفصل... ستجد كمبيوتر بنظام Windows*‎ يناسب ميزانيتك أو أسلوبك أيًا كان."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "حقق إنجازات هائلة",
                "tr_title": "Windows*‎",
                "tr_subtitle": "الأداء والسعر والكثير للاختيار من بينها. من أجهزة 2 في 1 المبتكرة إلى أجهزة الكمبيوتر المحمولة الرفيعة الخفيفة الوزن وشاشات اللمس ولوحات المفاتيح القابلة للفصل... ستجد كمبيوتر بنظام Windows*‎ يناسب ميزانيتك أو أسلوبك أيًا كان."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "LINUX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "",
                "tr_pretitle": "LINUX*‎",
                "tr_subtitle": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "نظام التشغيل",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "image-only-panel",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "",
                "tr_pretitle": "",
                "badgeIcons": [
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/1.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/2.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/3.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/4.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/5.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/6.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/7.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/8.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/9.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/10.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/11.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/12.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/13.png"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "memory": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "ما قدر مساحة ذاكرة RAM التي تحتاج إليها؟",
                "tr_subtitle": "",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "أداء يومي - ذاكرة RAM سعة 2 غيغابايت تصل إلى 8 غيغابايت",
                    "tr_badgeSubTitle": "مثالية للأشخاص الذين يستخدمون الكمبيوتر بشكل أساسي لمعالجة النصوص واستعراض الويب ويميلون إلى التركيز على برنامج واحد في الوقت نفسه."
                  },
                  {
                    "tr_badgeTitle": "أداء قوي - ذاكرة RAM سعة 8 غيغابايت تصل إلى 16 غيغابايت",
                    "tr_badgeSubTitle": "بفضل مساحة ذاكرة RAM الإضافية، ستعمل تطبيقاتك بسرعة أكبر وستتمكن أيضًا من تشغيل مزيد من التطبيقات في الوقت نفسه."
                  },
                  {
                    "tr_badgeTitle": "أداء متقدم - ذاكرة RAM بسعة تتجاوز 16 غيغابايت",
                    "tr_badgeSubTitle": "إذا كنت تهوى بتشغيل الألعاب أو تحرير الصور أو مقاطع الفيديو أو تصميم نماذج 3D، فستحتاج إلى مساحة ذاكرة RAM إضافية لمعالجة هذه البرامج التي تتطلب الكثير من الموارد."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX] غيغابايت من ذاكرة الوصول العشوائي لأعمال تعدد المهام اليومية",
                "tr_subtitle": "ستسمح لك الذاكرة بتحميل التطبيقات الأساسية، كمعالجة النصوص واستعراض الويب، وتشغيلها بسلاسة.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>ذاكرة RAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX] غيغابايت من ذاكرة RAM للاستمتاع بوظيفة تعددية مهام قوية",
                "tr_subtitle": "إذا كنت تستخدم برامج متعددة في نفس الوقت، فستسمح لك ذاكرة بسعة [memory_total] غيغابايت بالتبديل بينها بسهولة تامة.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>ذاكرة RAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX] غيغابايت من ذاكرة RAM للاستمتاع بوظيفة تعددية المهام المتقدمة",
                "tr_subtitle": "سيصبح لديك مساحة كافية من الذاكرة لتتمكن من تشغيل عدة برامج ثقيلة في الوقت نفسه دون إبطاء الكمبيوتر.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>ذاكرة RAM<br/></span><span class='subtitle-value'>سعة [XX] غيغابايت</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "ذاكرة سعة [Value1] غيغابايت = ذاكرة Intel®‎ Optane™‎ سعة [Value2] غيغابايت + ذاكرة RAM سعة [Value3] غيغابايت",
                "tr_subtitle": "بفضل هذا المزيج من حلول الذاكرة، ستوفر ذاكرة Intel®‎ Optane™‎ أداء محرك أقراص صلبة أسرع، أما ذاكرة RAM فستقدم سرعة استجابة أكبر.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class ='value'>[XX] غيغابايت<br/></span><span class='subtitle-value'>سعة الذاكرة</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ذاكرة Intel®‎ Optane™‎",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "tr_title": "انتظار أقل. المزيد من الميزات التي تحبها.",
                "tr_subtitle": "عندما تعمل ذاكرة Intel®‎ Optane™‎ مع ذاكرة نظامك، ستوفر لك الوصول إلى برامجك الأكثر استخدامًا بسرعة أكبر، لتتمكن بالتالي من بدئها وتحميلها وقتما تريد.",
                "tr_pretitle": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "titleArray": [
                  {
                    "tr_title": "ما الذي تفعله الذاكرة في الكمبيوتر؟"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-optane-faster-content.png",
                    "tr_badgeTitle": "إنشاء أسرع للمحتوى",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-responsive-gaming.png",
                    "tr_badgeTitle": "تشغيل ألعاب يتميز بسرعة استجابة أكبر",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-easier-multitasking.png",
                    "tr_badgeTitle": "تعددية مهام أسهل",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-open-programs.png",
                    "tr_badgeTitle": "فتح البرامج بشكل أسرع",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ذاكرة Intel®‎ Optane™‎",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>زد سرعة تشغيل الألعاب</span>",
                "tr_pretitle": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت",
                "tr_pretitle1": "ذاكرة Intel® Optane™‎ سعة [XX] غيغابايت تمنحك سرعة عند تشغيل الألعاب",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "ابدأ بتشغيل الألعاب بسرعة أعلى<br/><span class=\"optane-game\">تصل إلى 98%</span><br/>خارج محرك أقراص البيانات بفضل معالج [optane_legal_processor_name] مع ذاكرة Intel®‎ Optane™‎<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "تحميل المستويات بسرعة أعلى<br/><span class=\"optane-game\">تصل إلى 4.1 مرة</span><br/>خارج محرك أقراص البيانات بفضل معالج [optane_legal_processor_name] مع ذاكرة Intel®‎ Optane™‎<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            },
            {
              "deviceType": "DEFAULT_A",
              "details": {
                "tr_tileTitle": "ذاكرة Intel®‎ Optane™‎",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>زد سرعة تشغيل الألعاب</span>",
                "tr_pretitle": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت",
                "tr_pretitle1": "ذاكرة Intel® Optane™‎ سعة [XX] غيغابايت تمنحك سرعة عند تشغيل الألعاب",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "ابدأ بتشغيل الألعاب بسرعة أعلى<br/><span class=\"optane-game\">تصل إلى 98%</span><br/>خارج محرك أقراص البيانات بفضل معالج [optane_legal_processor_name] مع ذاكرة Intel®‎ Optane™‎<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "تحميل المستويات بسرعة أعلى<br/><span class=\"optane-game\">تصل إلى 4.1 مرة</span><br/>خارج محرك أقراص البيانات بفضل معالج [optane_legal_processor_name] مع ذاكرة Intel®‎ Optane™‎<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "ذاكرة سعة [Value1] غيغابايت = ذاكرة Intel®‎ Optane™‎ سعة [Value2] غيغابايت + ذاكرة RAM سعة [Value3] غيغابايت",
                "tr_subtitle": "بفضل هذا المزيج من حلول الذاكرة، ستوفر ذاكرة Intel®‎ Optane™‎ أداء محرك أقراص صلبة أسرع، أما ذاكرة RAM فستقدم سرعة استجابة أكبر.",
                "titleArray": [
                  {
                    "tr_title": "ذاكرة RAM سعة [XX] غيغابايت لتعدد المهام",
                    "tr_subtitle": "إذا كنت تستخدم برامج متعددة في نفس الوقت، فستسمح لك ذاكرة بسعة [memory_total] غيغابايت بالتبديل بينها بسهولة تامة."
                  },
                  {
                    "tr_title": "للمهام اليومية",
                    "tr_subtitle": "ستسمح لك الذاكرة بتحميل التطبيقات الأساسية، كمعالجة النصوص واستعراض الويب، وتشغيلها بسلاسة."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DEFAULT",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "ذاكرة RAM سعة [XX] غيغابايت",
                "tr_pretitle": "لتأدية المزيد من المهام في الوقت نفسه",
                "tr_subtitle": "تتيح ذاكرة RAM لمعالجك الوصول إلى ملفات البرامج، مما يسمح لوحدة المعالجة المركزية بالوصول إليها بطريقة أسرع وإنجاز مهام متعددة في الوقت نفسه.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "الذاكرة القياسية",
                    "tr_badgeSubTitle": "ذاكرة RAM بسعة تصل إلى 8 جيجابايت"
                  },
                  {
                    "tr_badgeTitle": "الذاكرة المتقدمة",
                    "tr_badgeSubTitle": "أكثر من 8 غيغابايت وذاكرة RAM تصل إلى 16 غيغابايت"
                  },
                  {
                    "tr_badgeTitle": "ذاكرة المستوى الراقي",
                    "tr_badgeSubTitle": "ذاكرة RAM سعة تفوق 16 غيغابايت"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GAMING_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "[XX] غيغابايت لمزيد من تعدد المهام",
                "tr_pretitle": "لتأدية المزيد من المهام في الوقت نفسه",
                "tr_subtitle": "تتيح ذاكرة RAM لمعالجك الوصول إلى ملفات البرامج، مما يسمح لوحدة المعالجة المركزية بالوصول إليها بطريقة أسرع وإنجاز مهام متعددة في الوقت نفسه.",
                "gamingPanleType2": "gaming-panelType1",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "الذاكرة القياسية",
                    "tr_badgeSubTitle": "ذاكرة RAM بسعة تصل إلى 8 جيجابايت"
                  },
                  {
                    "tr_badgeTitle": "الذاكرة المتقدمة",
                    "tr_badgeSubTitle": "أكثر من 8 غيغابايت وذاكرة RAM تصل إلى 16 غيغابايت"
                  },
                  {
                    "tr_badgeTitle": "ذاكرة المستوى الراقي",
                    "tr_badgeSubTitle": "ذاكرة RAM سعة تفوق 16 غيغابايت"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ما أداء هذه الذاكرة مقارنة بغيرها؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "قياسي",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 8 غيغابايت</span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "متقدمة",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 16 غيغابايت</span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "متميزة",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 32 غيغابايت</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STANDARD_COMMON_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الذاكرة",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "ما أداء هذه الذاكرة مقارنة بغيرها؟",
                "tr_subtitle": "",
                "gamingPanleType2": "gaming-panelType1",
                "enhancementCompare": {
                  "tr_title": "ما أداء هذه الذاكرة مقارنة بغيرها؟",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "الجهاز الحالي",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "كل يوم",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 8 غيغابايت</span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "قوية",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 16 غيغابايت</span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "متقدمة",
                      "tr_badgeSubTitle": "<span class='memory-value'>ذاكرة <span class='ram_value'>RAM</span> سعة 32 غيغابايت</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "storage": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "tr_title": "ما هي سعة كمبيوترك؟",
                "tr_subtitle": "لا داعي للتخمين. سنريك بالتحديد ما يمكنك تخزينه في هذا الكمبيوتر.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/storage-songs-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>إنشاء مكتبة مكونة من</span> <br/><span class=\"storage-standard\">[num_songs] أغنية<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>استنادًا إلى معدل 5 ميغابايت لكل أغنية",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-game-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>إنشاء مكتبة تحتوي على</span><br/><span class=\"storage-standard\">[num_games] من الألعاب<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>استناداً إلى معدل 40 غيغابايت لكل لعبة",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-videos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>تخزين</span><br/><span class=\"storage-standard\">[num_videos] مقطع فيديو<sup>§</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>§</sup>استنادًا إلى معدل 5 غيغابايت لكل فيديو",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-photos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>التقط وخزّن</span><br/><span class=\"storage-standard\">[num_photos] صورة<sup>^</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>^</sup>استنادًا إلى معدل 4 ميغابايت لكل صورة",
                    "imgUrl": ""
                  }
                ],
                "titleArray": [
                  {
                    "storageType": "HDD",
                    "tr_pretitle": "محرك أقراص صلبة سعة [capacity] غيغابايت"
                  },
                  {
                    "storageType": "SSD",
                    "tr_pretitle": "محرك أقراص ذات حالة صلبة سعة [capacity] غيغابايت"
                  },
                  {
                    "storageType": "SSD_AND_HDD",
                    "tr_pretitle": ""
                  },
                  {
                    "storageType": "OPTANE",
                    "tr_pretitle": "ذاكرة Intel®‎ Optane™‎ سعة [total_optane_memory] غيغابايت + محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_preTitle": "محرك أقراص ذات حالة صلبة سعة [capacity] غيغابايت",
                "tr_preTitle1": "محرك أقراص ذات حالة صلبة سعة [capacity] تيرابايت",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "يضم هذا الكمبيوتر محرك أقراص ذات حالة صلبة بسعة تخزينية تبلغ [capacity] غيغابايت. يعني ذلك أنك ستتمكن من حفظ عدد مبهر من الصور ومقاطع الفيديو والبرامج والوصول إليها بسرعة أكبر، مقارنةً بمحرك أقراص صلبة.",
                    "tr_title": "ثمة مساحة متوفرة لكل شيء على كمبيوترك"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "يضم هذا الكمبيوتر محرك أقراص ذات حالة صلبة بسعة تخزينية تبلغ [capacity] تيرابايت. يعني ذلك أنك ستتمكن من حفظ عدد مبهر من الصور ومقاطع الفيديو والبرامج والوصول إليها بسرعة أكبر، مقارنةً بمحرك أقراص صلبة.",
                    "tr_title": "يتمتع هذا الجهاز بتخزين استثنائي"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] غيغابايت</span>",
                    "tr_badgeTitle1": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] تيرابايت</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "SSD",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "badgeUrl": "assets/images/std12storage.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgeAndHeadings",
                "tr_preTitle": "محرك أقراص صلبة سعة [capacity] غيغابايت",
                "tr_preTitle1": "محرك أقراص صلبة سعة [capacity] تيرابايت",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "تُعدّ محركات الأقراص الصلبة خياراً جيداً للأشخاص الذين يرغبون في سعة تخزين كبيرة مباشرةً على الكمبيوتر الخاص بهم.",
                    "tr_title": "ثمة مساحة متوفرة لكل شيء على كمبيوترك"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "تُعدّ محركات الأقراص الصلبة خياراً جيداً للأشخاص الذين يرغبون في سعة تخزين كبيرة مباشرةً على الكمبيوتر الخاص بهم.",
                    "tr_title": "يتمتع هذا الجهاز بتخزين استثنائي"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>سعة تخزين<br/></span><span class='subtitle-value'>[capacity]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "محرك الأقراص الصلبة",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "tr_title": "",
                "tr_pretitle": "ما هي سعة كمبيوترك؟",
                "tr_subtitle": "لا داعي للتخمين. سنريك بالتحديد ما يمكنك تخزينه في هذا الكمبيوتر.",
                "titleArray": [
                  {
                    "tr_title": "محرك أقراص صلبة سعة [XX] غيغابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة سعة [XX] غيغابايت"
                  },
                  {
                    "tr_title": "محرك الأقراص ذات الحالة الصلبة Intel®‎ سعة [total_capacity] غيغابايت مسرع بذاكرة Intel®‎ Optane™‎ سعة [optane_memory_size] غيغابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة Intel®‎ سعة [total_capacity] تيرابايت يسرعه ذاكرة Intel®‎ Optane™‎ سعة [optane_memory_size] غيغابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت"
                  },
                  {
                    "tr_title": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت"
                  }
                ],
                "badgeIcons": [
                  {
                    "storageType": "GB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] غيغابايت</span>",
                        "tr_badgeSubTitle": "SSD"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] غيغابايت</span>",
                        "tr_badgeSubTitle": "محرك الأقراص الصلبة"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] غيغابايت</span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>محرك أقراص ذات حالة صلبة<br/><span class='storage-seperator'> +  </span><br/>محرك أقراص صلبة</span>"
                      }
                    ]
                  },
                  {
                    "storageType": "TB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] تيرابايت</span>",
                        "tr_badgeSubTitle": "SSD"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] تيرابايت</span>",
                        "tr_badgeSubTitle": "محرك الأقراص الصلبة"
                      },
                      {
                        "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] تيرابايت</span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>محرك أقراص ذات حالة صلبة<br/><span class='storage-seperator'> +  </span><br/>محرك أقراص صلبة</span>"
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD_AND_HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "tr_preTitle": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت",
                "tr_preTitle1": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت",
                "tr_preTitle2": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت",
                "tr_preTitle3": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت",
                "titleArray": [
                  {
                    "tr_title": "ثمة مساحة متوفرة لكل شيء على كمبيوترك",
                    "tr_title1": "يتمتع هذا الجهاز بتخزين استثنائي",
                    "tr_subtitle": "يتميّز هذا الكمبيوتر بمحرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت ومحرك أقراص صلبة سعة [convertedHDD] غيغابايت. سيوفر لك ذلك سعات تخزينية هائلة إلى جانب أداء تخزين سريع.",
                    "tr_subtitle1": "يتميّز هذا الكمبيوتر بمحرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت ومحرك أقراص صلبة سعة [convertedHDD] غيغابايت. سيوفر لك ذلك سعات تخزينية هائلة إلى جانب أداء تخزين سريع.",
                    "tr_subtitle2": "يتميّز هذا الكمبيوتر بمحرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت ومحرك أقراص صلبة سعة [convertedHDD] تيرابايت. سيوفر لك ذلك سعات تخزينية هائلة إلى جانب أداء تخزين سريع.",
                    "tr_subtitle3": "يتميّز هذا الكمبيوتر بمحرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت ومحرك أقراص صلبة سعة [convertedHDD] تيرابايت. سيوفر لك ذلك سعات تخزينية هائلة إلى جانب أداء تخزين سريع."
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] غيغابايت</span>",
                    "tr_badgeTitle1": "<span class='value'>وحدة تخزين سعة <br/></span><span class='subtitle-value'>[capacity] تيرابايت</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>محرك أقراص ذات حالة صلبة<br/><span class='storage-seperator'> +  </span><br/>محرك أقراص صلبة</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_storage.svg",
                "badgeUrl2": "assets/images/std12storage.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "استمتع بإمكانية الوصول السريع إلى سعة تخزينية عالية باستخدام ذاكرة ™Intel® Optane مع محرك الأقراص ذي الحالة الصلبة.",
                "tr_title": "أهلاً بالملفات كبيرة الحجم",
                "tr_pretitle": "محرك الأقراص ذات الحالة الصلبة Intel®‎ سعة [total_capacity] غيغابايت مسرع بذاكرة Intel®‎ Optane™‎ سعة [optane_memory_size] غيغابايت",
                "tr_pretitle1": "محرك أقراص ذات حالة صلبة Intel®‎ سعة [total_capacity] تيرابايت يسرعه ذاكرة Intel®‎ Optane™‎ سعة [optane_memory_size] غيغابايت",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "SSD",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "tr_subtitle": "إن حل التخزين الجذري هذا رائد في الجمع بين ذاكرة ™Intel® Optane ومحرك الأقراص ذي الحالة الصلبة على شريحة واحدة. إليك ما يُقدِّمه لك هذا الحل:",
                    "tr_title": "ما هي ذاكرة INTEL®‎ OPTANE™‎ المزودة بمحرك الأقراص ذات الحالة الصلبة؟"
                  }
                ],
                "panel2BadgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-frequency-badge.png",
                    "tr_badgeTitle": "فتح ما تحتاج إلى فتحه سريعًا",
                    "tr_badgeSubTitle": "عن طريق التحميل المسبق للملفات والبرامج الأكثر استخدامًا، يمكنك قضاء المزيد من الوقت في الإنشاء ووقت أقل في الانتظار.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/optane-memory-storage-badge.svg",
                    "tr_badgeTitle": "سعة تخزينية وسرعة في الوقت عينه",
                    "tr_badgeSubTitle": "ستحظى بالمساحة التي تلزمك لاستيعاب ملفات الوسائط إلى جانب الأداء السريع لمحرك الأقراص ذي الحالة الصلبة.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-time-badge.png",
                    "tr_badgeTitle": "سرعة استجابة أكبر مع مرور الوقت",
                    "tr_badgeSubTitle": "تتعلم ذاكرة Intel®‎ Optane™‎ مع محرك الأقراص ذو الحالة الصلبة الطريقة التي تنجز بها عملك، مما يزيد من كفاءة الكمبيوتر الذي تستخدمه.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "التخزين",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "احتفظ بكل الوسائط في متناول يديك بفضل التخزين الوفير الموثوق به.",
                "tr_title": "مساحة لجميع الصور ومقاطع الفيديو والأغاني الخاصة بك"
              }
            }
          ]
        }
      ]
    }
  ],
  "display": [
    {
      "contentType": "TOUCH_SCREEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "شاشة العرض",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "[screenResolution] مليون بكسل للتمرير والتصغير وإثارة الدهشة والذهول",
                "tr_subtitle": "تفاعل مع الكمبيوتر كما تفعل مع الهاتف الذكي بأدوات تحكم سهلة وتفاصيل أوضح وأدق.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal] بوصة<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "الدقة: [screenResolutionX] X ‏[screenResolutionY]",
                    "tr_badgePreTitle": "بكسلات: [screenResolution] مليون"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "شاشة قياس [screenDiagonal] بوصة",
                    "tr_badgeSubTitle": "ارتفاع الشاشة: [screenHeight] بوصات",
                    "tr_badgePreTitle": "عرض الشاشة: [YY] بوصة"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "شاشة باللمس",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DISPLAY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "شاشة العرض",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "انغمس في [screenResolution] مليون بكسل",
                "tr_subtitle": "إنّ الأمر كله يتوقف على وحدات البكسل. كلما ازداد عدد وحدات البكسل، كانت الصور أكثر وضوحًا وحيوية.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal] بوصة<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "الدقة: [screenResolutionX] X ‏[screenResolutionY]",
                    "tr_badgePreTitle": "بكسلات: [screenResolution] مليون"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "شاشة قياس [screenDiagonal] بوصة",
                    "tr_badgeSubTitle": "ارتفاع الشاشة: [screenHeight] بوصات",
                    "tr_badgePreTitle": "عرض الشاشة: [YY] بوصة"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "شاشة العرض",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/display-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_title": "[screenDiagonal] بوصة <br/>[screenResolutionX]‏ × ‏[screenResolutionY]",
                "tr_pretitle": "نافذتك إلى عالم الألعاب",
                "tr_subtitle": "تماماً كمخاوفك بشأن التلفزيون، ستتعلق مخاوفك على مستوى شاشة تشغيل الألعاب بالحجم والدقة.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "الدقة: [screenResolutionX] X ‏[screenResolutionY]",
                    "tr_badgePreTitle": "بكسلات: [screenResolution] مليون"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "شاشة قياس [screenDiagonal] بوصة",
                    "tr_badgeSubTitle": "ارتفاع الشاشة: [screenHeight] بوصات",
                    "tr_badgePreTitle": "عرض الشاشة: [screenWidth] بوصة"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "شاشة باللمس"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "4K",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "شاشة العرض",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "4K",
                "tr_title": "يتمتع هذا الجهاز بشاشة استثنائية",
                "tr_subtitle": "مع عدد بكسلات يتجاوز ثمانية أضعاف بكسلات الوضوح العالي، سترتقي إلى مستوى جديد بالكامل من الوضوح والألوان عند مشاهدة مقاطع الفيديو وتشغيل الألعاب.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "4K",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "الدقة: [screenResolutionX] X ‏[screenResolutionY]",
                    "tr_badgePreTitle": "بكسلات: [screenResolution] مليون"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "شاشة قياس [screenDiagonal] بوصة",
                    "tr_badgeSubTitle": "ارتفاع الشاشة: [screenHeight] بوصات",
                    "tr_badgePreTitle": "عرض الشاشة: [YY] بوصة"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "شاشة العرض",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "[screenResolution] مليون بيكسل للضغط والدفع واللمس",
                    "tr_subTitle": "اعرض الأشياء التي تحبها وتفاعل معها بتفاصيل أدق وحيوية أكبر."
                  },
                  {
                    "tr_title": "[screenResolution] ملايين من وحدات البكسل لتوسيع آفاق عالمك الرقمي",
                    "tr_subTitle": "إنّ الأمر كله يتوقف على وحدات البكسل. كلما ازداد عدد وحدات البكسل، كانت الصور أكثر وضوحًا وحيوية."
                  },
                  {
                    "tr_title": "يتمتع هذا الجهاز بشاشة استثنائية",
                    "tr_subTitle": "ومع ما يقارب أربعة أضعاف وحدات بكسل الموجودة في الصور العالية الوضوح، ستنتقل مقاطع الفيديو والألعاب الخاصة بك إلى مستوى جديد تماماً من الوضوح والألوان."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "connectivity": [
    {
      "contentType": "VERSION_3",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "توفر تقنية Thunderbolt™‎ 3 الاتصالات الأسرع والأكثر تنوعًا لأي قاعدة إرساء أو شاشة عرض أو جهاز بيانات.",
                "tr_title": "منفذ واحد لتأدية كل المهام",
                "tr_title1": "منفذ واحد لتأدية كل المهام",
                "titleArray": [
                  {
                    "tr_title": "كيف يمكنني استخدام تقنية THUNDERBOLT™‎ 3؟",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "تقنية Thunderbolt™‎ 3"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-4k.png",
                    "tr_badgeTitle": "شاشات بدقة 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "اتصل بشاشات تتميز بدقة وتباين وألوان مذهلة"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-graphic.png",
                    "tr_badgeTitle": "بطاقة رسوميات خارجية",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "اعمد إلى ترقية مهمة على مستوى الصور لأي كمبيوتر على الفور"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-networking.png",
                    "tr_badgeTitle": "اتصال سريع بالشبكات",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "توفير اتصالات نظير إلى نظير سريعة"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "tr_subtitle": "تعمل تقنية Thunderbolt™‎ 3 على نقل البيانات بسرعة أعلى من أجهزة USB التقليدية، مما يتيح لك نقل الملفات بسرعة إلى جانب سهولة دمج الأجهزة الطرفية مثل الشاشات المتعددة أو بطاقات الرسوميات الخارجية.",
                "tr_title": "تقنية Thunderbolt™‎ 3",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_pretitle": "بيانات فائقة السرعة",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB*‎ 2.0",
                    "tr_badgeSubTitle": "480 ميغابت في الثانية",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 3.0",
                    "tr_badgeSubTitle": "5 غيغابت في الثانية",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "تقنية Thunderbolt™‎&nbsp;3",
                    "tr_badgeSubTitle": "40 غيغابت في الثانية",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_4",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>منفذ وكابل عام واحد يدعمان كل ملحقاتك المفضلة</li> <li>شحن موثوق به للكمبيوتر المحمول من نوع notebook</li> <li>شهادة قوية لتوفير راحة البال</li></ul>",
                "tr_title": "إمكانية اتصال بكابل عام فعلًا",
                "tr_title1": "إمكانية اتصال بكابل عام فعلًا",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى أدنى متطلبات المواصفات",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "كيف يمكنني استخدام تقنية Thunderbolt™‎ 4؟",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "تقنية Thunderbolt™‎ 4"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "الإنشاء",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "قم بالتوصيل بشاشة خارجية وبوحدة تخزين سريع لعرض الصور ومقاطع الفيديو وتحريرها."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "وحدة إرساء",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "اجعل مكتبك يتسم بالبساطة وقلة الأسلاك عبر توصيل الكمبيوتر المحمول بكل ملحقاتك باستخدام كابل واحد."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "تشغيل الألعاب",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "زد سعة تخزين محرك الأقراص ذات الحالة الصلبة ومحرك الأقراص الصلبة مع سرعات تصل إلى 3,000 ميغابايت في الثانية كي تخزن مكتبات الألعاب وملفات الوسائط."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ذروة الأداء<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "أسرع 4 مرات من USB*‎ 3.2 <br/>أسرع مرتين من HDMI*‎ 2"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "تمتع بنفس الأداء المذهل لتقنية Thunderbolt™‎ 3 مع المزيد من الإمكانات التي تتيح لك الاتصال بسهولة واستخدام أحدث قواعد إرساء Thunderbolt™‎ أو الشاشات أو التخزين السريع أو أي ملحق USB*‎.",
                "tr_title": "تقنية Thunderbolt™‎ 4",
                "tr_pretitle": "إمكانية اتصال بكابل عام فعلًا",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى أدنى متطلبات المواصفات",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-icon.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "يمكن لكابل Thunderbolt™‎ 4 عام واحد استبدال كل كابلات USB-C*‎ لديك، بما يجعل اختيار الكابل عملية سريعة وسهلة."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "تقدم قواعد إرساء تقنية Thunderbolt™‎ 4 ما يصل إلى أربعة منافذ Thunderbolt™‎ لتوفير مزيد من المرونة عند الاتصال بأي من الملحقات."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ذروة الأداء<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "أسرع 4 مرات من USB*‎ 3.2 <br/>أسرع مرتين من HDMI*‎ 2"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>منفذ وكابل عام واحد يدعمان كل ملحقاتك المفضلة</li> <li>شحن موثوق به للكمبيوتر المحمول من نوع notebook</li> <li>شهادة قوية لتوفير راحة البال</li></ul>",
                "tr_title": "عزز تجربتك مع ملحقات Thunderbolt™‎",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى أدنى متطلبات المواصفات",
                "badgeUrl": "assets/images/evo_thunderbolt4.png",
                "tileBG": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "كيف يمكنني استخدام تقنية Thunderbolt™‎ 4؟",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "الإنشاء",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "قم بالتوصيل بشاشة خارجية وبوحدة تخزين سريع لعرض الصور ومقاطع الفيديو وتحريرها."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "وحدة إرساء",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "اجعل مكتبك يتسم بالبساطة وقلة الأسلاك عبر توصيل الكمبيوتر المحمول بكل ملحقاتك باستخدام كابل واحد."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "تشغيل الألعاب",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "زد سعة تخزين محرك الأقراص ذات الحالة الصلبة ومحرك الأقراص الصلبة مع سرعات تصل إلى 3,000 ميغابايت في الثانية كي تخزن مكتبات الألعاب وملفات الوسائط."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "ذروة الأداء<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "أسرع 4 مرات من USB*‎ 3.2 <br/>أسرع مرتين من HDMI*‎ 2"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "الاتصال",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "gaming-panelType1",
                "tr_subtitle": "جرّب مزايا تقنية Thunderbolt™ 5",
                "tr_title": "اتصال واحد يجمع بين البساطة والموثوقية والسرعة الفائقة، ويتيح لك إنجاز كل المهام بكفاءة!",
                "tr_title1": "اتصال واحد يجمع بين البساطة والموثوقية والسرعة الفائقة، ويتيح لك إنجاز كل المهام بكفاءة!",
                "tr_noteSection": "",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "imgUrl": "assets/images/unrivaled_icon.svg",
                    "tr_title": "بساطة لا نظير لها",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/reliable_icon.svg",
                    "tr_title": "اتصال موثوق",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/performance_icon.svg",
                    "tr_title": "أقصى أداء",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/compatibility_icon.svg",
                    "tr_title": "توافق شامل",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "تمتاز أجهزة الكمبيوتر التي تدعم تقنية THUNDERBOLT™ 5 بسرعتها الفائقة في نقل البيانات",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "تمتاز أجهزة الكمبيوتر التي تدعم تقنية THUNDERBOLT™ 5 بسرعتها الفائقة في نقل البيانات",
                  "panelType2": "enhancement-compare",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "تقنية Thunderbolt™ 5‎",
                      "tr_badgeSubTitle": "6,000 ميغابت في الثانية"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "تقنية Thunderbolt™‎ 4",
                      "tr_badgeSubTitle": "3,000 ميغابت في الثانية"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "*USB4‏",
                      "tr_badgeSubTitle": "1,500 ميغابت في الثانية"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB 3.2",
                      "tr_badgeSubTitle": "450 ميغابت في الثانية"
                    }
                  ]
                },
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/thunderbolt_panel1.png",
                    "tr_title": "",
                    "tr_subtitle": "استخدم تقنية <strong>Thunderbolt™ Share</strong><br>لتسهيل نقل الملفات ومشاركة الشاشات وأجهزة التخزين والموارد الأخرى بسرعة فائقة<sup>53</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/thunderbolt_panel2.png",
                    "tr_title": "",
                    "tr_subtitle": "<strong>مساحة عمل أكثر ذكاءً من خلال استخدام كابل واحد يربط وحدة الإرساء بالملحقات</strong><br><br/>أجهزة الكمبيوتر والكابلات والملحقات معتمدة، ما يضمن <span class ='expandable_bold_text'>حلًا متكاملًا وموثوقًا</span>",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "wifi": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "",
                "tr_subtitle": "إن أنواع Wi‑Fi الأكثر شيوعًا هي:",
                "tr_title": "فهم معايير WI‑FI القياسية",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "يتيح Wi-Fi 6 تصفح الإنترنت بسرعات أعلى حتى وإن استخدم كثير من المستخدمين الإشارة ذاتها.<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-badge.png",
                    "tr_badgeTitle": "Intel®‎ Wi‑Fi 6 (Gig+)‎",
                    "tr_badgeSubTitle": "بفضل أحدث ابتكارات Intel في مجال Wi-Fi، يمكنك الوصول إلى سرعات تفوق سرعات gigabit Wi-Fi حتى مع وجود مستخدمين متعددين يستخدمون الإشارة نفسها.<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel®‎ Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "يُعدّ Wi‑Fi 6E أهم تطور في مجال اتصالات Wi‑Fi في 20 عامًا حيث يفتح قنوات جديدة عالية السرعة لتحسين الأداء والموثوقية وتقليل التداخل."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "يتيح Wi-Fi 6 تصفح الإنترنت بسرعات أعلى حتى وإن استخدم كثير من المستخدمين الإشارة ذاتها.<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "كل فوائد Wi-Fi 6E مقترنة بمحرك ترتيب الأولوية Intel®‎ Killer™‎ الذي يبدّل النطاق الترددي إلى مواقع الويب والتطبيقات التي هي بأمس الحاجة إليه."
                  },
                  {
                    "badgeUrl": "assets/images/Wi-fi-6E-badge.svg",
                    "tr_badgeTitle": "Wi‑Fi 6E",
                    "tr_badgeSubTitle": "عندما تقل المنافسة في قنواتك عالية السرعة، ستستمتع بأداء معزز وموثوقية أكبر."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6",
                    "tr_badgeSubTitle": "يتيح Wi-Fi 6 تصفح الإنترنت بسرعات أعلى حتى وإن استخدم كثير من المستخدمين الإشارة ذاتها.<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "بفضل التداخل الأقل الذي يوفره اتصال Wi-Fi 6 والأداء الذكي لمحرك ترتيب الأولوية Intel® Killer™‎، ستشهد تجربتك عبر الإنترنت المزيد من السرعة والاستجابة.⁶"
                  },
                  {
                    "badgeUrl": "assets/images/standard_generic_wifi.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "عندما تقل المنافسة في قنواتك عالية السرعة، ستستمتع بأداء معزز وموثوقية أكبر."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 7 (بسرعة 5 غيغابت)",
                    "tr_badgeSubTitle": "سرعات Wi-Fi للكمبيوتر الشخصي أعلى من 5 غيغابت في الثانية مع زمن انتقال متسق ومنخفض للغاية لتتمكن من مشاركة الملفات في ثوانٍ بدلًا من دقائق."
                  },
                  {
                    "badgeUrl": "assets/images/killerwifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 7",
                    "tr_badgeSubTitle": "Intel® Killer™ Wi-Fi 7 (5 Gig) هي أحدث تقنية تمكّن \"أقصى حد\" من الموثوقية وزمن الانتقال والسرعات من خلال تحسين الشبكات القائم على الذكاء الاصطناعي."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "يتيح Wi-Fi 6 تصفح الإنترنت بسرعات أعلى حتى وإن استخدم كثير من المستخدمين الإشارة ذاتها.<sup>9</sup>"
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel®‎ Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "تصل Intel® Wi-Fi 6E (Gig+) إلى سرعات أعلى من 1 غيغابت في الثانية مع موثوقية وزمن انتقال أقل باستخدام قنوات 6 غيغاهرتز."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "كفاءة البطارية والقدرة والسرعة مقابل Wi-Fi 5 على شبكات مزدحمة."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "ابق على اتصال أفضل بشبكة Wi‑Fi [XX] واستمتع بالإنترنت بسرعات أعلى<sup>†</sup> وموثوقية أكبر.",
                "tr_title": "احصل على نطاق وسرعة محسنين",
                "tr_noteSection": "<sup>†</sup>يختلف معدل النقل و/أو النطاق اللاسلكي الفعلي.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi [XX]"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "في عصر تعدد اللاعبين وتشغيل الألعاب عبر الإنترنت، بات البقاء متصلاً بالإنترنت أهم من أي وقت مضى. بالإضافة إلى&nbsp;السرعة،&nbsp;أنت بحاجة إلى إشارة لاسلكية لتحافظ على هذه السرعات عن بُعد.",
                "tr_title": "[XX]",
                "tr_pretitle": "الاتصال هو المفتاح",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6E-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "استخدم تقنية Intel®‎ Wi‑Fi 6 (Gig+) للاتصال بموجهات Wi‑Fi 6 مع دعم قنوات بتردد 160 ميغاهرتز لتمكين اتصالات أسرع وموثوقية أكبر لعدد أكبر من المستخدمين النشطين.",
                "tr_title": "سرعات أكبر 3 مرات تقريبًا بفضل تقنية Intel®‎ <span class='no-warp'>Wi-Fi 6  </span>(Gig+)<sup>†</sup>",
                "tr_noteSection": "<sup>†</sup>بالمقارنة مع AC Wi‑Fi القياسي. تتوفر ميزات مختارة مع وحدات SKU معينة دون غيرها. راجع الشركة المصنّعة للحصول على التفاصيل. لمزيد من المعلومات عن Wi‑Fi، يرجى زيارة intel.com/wifi6disclaimers"
              }
            },
            {
              "deviceType": "MODEL_AX101",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "يدعم Intel®‎ Wi-Fi 6 ثنائي الموجة المناسب للمبتدئين مستوى أداء محسّن يلائم احتياجات الاتصال الأساسية، مثل البريد الإلكتروني وتصفح الإنترنت على الشبكات المزدحمة.<sup>9</sup>",
                "tr_title": "Wi‑ Fi لا غنى عنه",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "في عصر تعدد اللاعبين وتشغيل الألعاب عبر الإنترنت، بات البقاء متصلاً بالإنترنت أهم من أي وقت مضى. بالإضافة إلى&nbsp;السرعة،&nbsp;أنت بحاجة إلى إشارة لاسلكية لتحافظ على هذه السرعات عن بُعد.",
                "tr_title": "[XX]",
                "tr_pretitle": "الاتصال هو المفتاح",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "يعني وجود قنوات Wi‑Fi الجديدة هذه أنك لست مضطرًا إلى مشاركة النطاق الترددي مع الأجهزة القديمة في منطقتك، مما يمنحك سلاسة في مشاهدة مقاطع الفيديو مباشرة عبر الإنترنت واستعراضًا سريعًا وسلاسة في العمل وفي التعلم عن بُعد.",
                "tr_title": "اتصال بدون المنافسة",
                "tr_noteSection": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "ابق على اتصال أفضل بشبكة [XX] واستمتع بالإنترنت بسرعات أعلى<sup>†</sup> وموثوقية أكبر.",
                "tr_title": "احصل على نطاق وسرعة محسنين",
                "tr_noteSection": "<sup>†</sup>يختلف معدل النقل و/أو النطاق اللاسلكي الفعلي.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "في عصر تعدد اللاعبين وتشغيل الألعاب عبر الإنترنت، بات البقاء متصلاً بالإنترنت أهم من أي وقت مضى. بالإضافة إلى&nbsp;السرعة،&nbsp;أنت بحاجة إلى إشارة لاسلكية لتحافظ على هذه السرعات عن بُعد.",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "الاتصال هو المفتاح",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "تقنية Wi‑Fi المدمجة وفائقة السرعة",
                "tr_subtitle": "افصل سلك الجهاز وابقَ على اتصال بعالمك عبر الإنترنت."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                "tr_subtitle": "مع المسارات العالية السرعة التي تقلل التداخل ومحرك ترتيب الأولوية Intel®‎ Killer™‎ الذي يعطي الأولوية لتشغيل الألعاب، يمكنك الارتقاء بتشغيل الألعاب عبر الإنترنت إلى مستويات فائقة.",
                "tr_title": "اترك المنافسة وراء ظهرك",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "مع المسارات العالية السرعة التي تقلل التداخل ومحرك ترتيب الأولوية Intel®‎ Killer™‎ الذي يعطي الأولوية لتشغيل الألعاب، يمكنك الارتقاء بتشغيل الألعاب عبر الإنترنت إلى مستويات فائقة.",
                "tr_title": "[XX]",
                "tr_pretitle": "اترك المنافسة وراء ظهرك",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "بفضل المسارات المخصصة للسرعة العالية لتقليل التداخل والتي تعطي الأولوية لتشغيل الألعاب، يكون تشغيل الألعاب على الإنترنت قد ارتقى إلى مستوى عالٍ بالفعل.",
                "tr_title": "[XX]",
                "tr_pretitle": "اترك المنافسة وراء ظهرك",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "tr_subtitle": "تسرّع Intel® Killer™ Wi-Fi تلقائيًا حركة نقل البيانات عبر الشبكة للتطبيقات التي هي بأمسّ الحاجة للسرعة لتستمتع بتفاصيل حادة وأوقات تخزين أقل عند بث مقاطع الفيديو بشكل تدفقي.",
                "tr_title": "طريقة أسرع وأذكى للاتصال.⁶",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "في عصر تعدد اللاعبين وتشغيل الألعاب عبر الإنترنت، بات البقاء متصلاً بالإنترنت أهم من أي وقت مضى. بالإضافة إلى&nbsp;السرعة،&nbsp;أنت بحاجة إلى إشارة لاسلكية لتحافظ على هذه السرعات عن بُعد.",
                "tr_title": "[XX]",
                "tr_pretitle": "الاتصال هو المفتاح",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "ابقَ على اتصال أفضل بشبكة Wi-Fi 5 واستمتع بالإنترنت بسرعات أعلى<sup>†</sup> وموثوقية أكبر.",
                "tr_title": "احصل على نطاق وسرعة محسنين",
                "tr_noteSection": "<sup>†</sup>يختلف معدل النقل و/أو النطاق اللاسلكي الفعلي.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "THIRDPARTY_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "في عصر تعدد اللاعبين وتشغيل الألعاب عبر الإنترنت، بات البقاء متصلاً بالإنترنت أهم من أي وقت مضى. بالإضافة إلى&nbsp;السرعة،&nbsp;أنت بحاجة إلى إشارة لاسلكية لتحافظ على هذه السرعات عن بُعد.",
                "tr_title": "[XX]",
                "tr_pretitle": "اترك المنافسة وراء ظهرك",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "تبدأ ميزات Wi-Fi 7 من حيث انتهت أجيال Wi-Fi السابقة، وترتقي بأدائها. وهذا لا يعني سرعات أعلى فحسب، بل يعني أيضًا تحسنًا هائلًا في الاستجابة والموثوقية لضمان تمتع المستهلك بتجارب غامرة وتقنيات مستقبلية متطورة.",
                "tr_title": "شبكة كمبيوتر شخصي تضاهي الشبكات السلكية",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "تبدأ ميزات Wi-Fi 7 من حيث انتهت أجيال Wi-Fi السابقة، وترتقي بأدائها. وهذا لا يعني سرعات أعلى فحسب، بل يعني أيضًا تحسنًا هائلًا في الاستجابة والموثوقية لضمان تمتع المستهلك بتجارب غامرة وتقنيات مستقبلية متطورة.",
                "tr_title": "[XX]",
                "tr_pretitle": "تحويل تجارب المستخدم",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_title": "سرعة وزمن انتقال وموثوقية معززين من خلال تحسين الشبكات القائم على الذكاء الاصطناعي",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "سرعة وزمن انتقال وموثوقية معززين من خلال تحسين الشبكات القائم على الذكاء الاصطناعي.",
                "tr_title": "[XX]",
                "tr_pretitle": "استجابة تضاهي استجابة الاتصال السلكي",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "battery": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-power-icon.png",
                    "tr_badgeTitle": "كيف يتم القياس؟",
                    "tr_badgeSubTitle": "يستخدم معظم المصنعين الساعة للتعبير عن عمر البطارية. على الرغم من أن هذه الحسابات غير دقيقة 100%، هي تساعد في مقارنة عمر البطارية بين كمبيوتر وآخر."
                  }
                ],
                "tr_subtitle": "",
                "tr_title": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "تلبّي احتياجاتك وأنت تلعب أثناء التنقل",
                "tr_subtitle": "بفضل القوة التي تتميز بها أجهزة الكمبيوتر المحمولة المجهزة للألعاب حاليًا، لم تعد مضطرًا للتقيّد بالمكتب. فبإمكان ألعابك أن ترافقك أينما ذهبت.",
                "tr_title": "عمر بطارية يدوم لـ [Dynamic.battery.values.hours] من الساعات"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BATTERYLIFE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Intel® Core™ Ultra: المعيار الجديد لعمر بطارية أجهزة الكمبيوتر الشخصي",
                "detailBGUrl": "assets/images/battery_life_bg.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "bannerImgUrl": "assets/images/battery_life_banner_img.svg",
                "tr_subtitle": "المعيار الجديد لعمر بطارية أجهزة الكمبيوتر الشخصي",
                "tr_title": "معالج Intel® Core™ Ultra السلسلة 200V",
                "tr_noteSection": "تشير إلى معالجات Intel® Core™ Ultra السلسلة 200V اعتبارًا من أغسطس 2025، استنادًا إلى بنيتها الفريدة وعمر البطارية المذهل الذي تحظى به وفقًا لما تم قياسه في التصميمات الرائدة.<br/>راجع www.Intel.com/PerformanceIndex للاطلاع على التفاصيل.<br/>لا يمكن لأي منتج أن يكون آمنًا تمامًا. © Intel Corporation.",
                "tileBG": "assets/images/batteryLifeTile_img.svg",
                "titleArray": [
                  {
                    "tr_title": "أنجز المزيد بعملية شحن واحدة",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "احصل على أداء ممتاز من دون الحاجة إلى التوصيل بالكهرباء",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "أنشئ المحتوى الذي يُلهمك. بكل سهولة.",
                    "tr_subTitle": ""
                  }
                ],
                "badgeUrl": "assets/images/badges/battery_life_badge.svg",
                "tr_badgeTitle": "هذه هي قوة <span class='battery_highlight'>Intel&nbsp;Inside®‎.</span>"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "افصل الجهاز عن الكهرباء وابقَ متصلاً بالتطبيقات والألعاب والموسيقى لساعات.",
                "tr_title": "[XX] ساعات مشاهدة مباشرة عبر الإنترنت من شحنة واحدة<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى عمر البطارية المعلن من الشركة المصنعة للكمبيوتر.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] من الساعات",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "افصل الجهاز عن الكهرباء وابقَ متصلاً بالتطبيقات والألعاب والموسيقى لساعات.",
                "tr_title": "[Dynamic.battery.values.hours] من ساعات الطاقة أثناء التنقل<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى عمر البطارية المعلن من الشركة المصنعة للكمبيوتر.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] من الساعات",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "افصل الجهاز عن الكهرباء وابقَ متصلاً بالتطبيقات والألعاب والموسيقى لساعات.",
                "tr_title": "[Dynamic.battery.values.hours] من الساعات لطاقة تشغيل تدوم طوال اليوم بعملية شحن واحدة<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى عمر البطارية المعلن من الشركة المصنعة للكمبيوتر.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] من الساعات",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "البطارية",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "يطيل هذا الكمبيوتر عمر البطارية ويمنحك بطارية تدوم 4 ساعات على الأقل بعملية شحن لمدة 30 دقيقة.<sup>4</sup>",
                "tr_title": "افصل عن الكهرباء لفترة أطول مع [Dynamic.battery.values.hours] من ساعات عمر البطارية<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>استنادًا إلى عمر البطارية المعلن من الشركة المصنعة للكمبيوتر.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX] من الساعات",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "headerTabs": [
    {
      "tabName": "homepage",
      "headerDetails": {
        "tr_specTitle": "الصفحة الرئيسية",
        "targetURL": "Home",
        "iconURL": "assets/images/home.svg"
      }
    },
    {
      "tabName": "why_this_pc",
      "headerDetails": {
        "tr_specTitle": "سبب اختيار هذا الكمبيوتر",
        "targetURL": "WhyThisPC",
        "iconURL": "assets/images/whythispc.svg"
      }
    },
    {
      "tabName": "pc_specs",
      "headerDetails": {
        "tr_specTitle": "عرض كل المواصفات",
        "targetURL": "PcSpec",
        "iconURL": "assets/images/pcspecs.svg"
      }
    },
    {
      "tabName": "remote",
      "headerDetails": {
        "tr_specTitle": "عن بُعد",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "mobile",
      "headerDetails": {
        "tr_specTitle": "الأجهزة المحمولة",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "legal",
      "headerDetails": {
        "tr_specTitle": "المعلومات القانونية",
        "tr_paragraph_array": [
          "من الممكن أن يكون قد تم تحسين أداء البرامج وأعباء العمل في اختبارات الأداء على معالجات Intel®‎ المصغرة فقط. يتم قياس اختبارات الأداء مثل SYSmark*‎ وMobileMark*‎ باستخدام أنظمة ومكونات ووظائف معينة في الكمبيوتر. وقد يؤدي أي تغيير في أيّ من هذه العوامل إلى اختلاف في النتائج. عليك الرجوع إلى اختبارات الأداء والمعلومات الأخرى التي من شأنها مساعدتك في إجراء تقييم كامل لمشترياتك المتوقعة، بما في ذلك أداء المنتج عند استخدامه مع منتجات أخرى. لمزيد من المعلومات الكاملة عن الأداء ونتائج الاختبار المعياري، يرجى زيارة www.intel.com/benchmarks.",
          "¹تدعم منتجات Intel®‎ Wi-Fi 6 (Gig+) قنوات 160 ميغاهرتز اختيارية، مما يتيح أعلى سرعات نظرية قصوى ممكنة (2402 ميغابت في الثانية) لمنتجات Wi-Fi للكمبيوتر لاتصالات 2x2 802.11ax النمطية. تتيح منتجات Intel®‎ Wi-Fi 6 (Gig+) المتميزة سرعات نظرية قصوى أسرع بمقدار مرتين إلى 4 مرات مقارنة بمنتجات Wi-Fi القياسية 2x2 (1201 ميغابت في الثانية) أو 1x1 (600 ميغابت في الثانية) ، والتي تدعم فقط المتطلبات الإلزامية لقنوات 80 ميغاهرتز.",
          "²توصية لأغراض توفير المعلومات فقط. يُرجى مراجعة مصادر أخرى قبل أن تتخذ قرار الشراء.",
          "³تعتمد ميزات تقنيات Intel وفوائدها على تكوين النظام، وقد تتطلب أجهزة وبرامج مفعلة وتنشيطًا للخدمة. يختلف الأداء وفقًا لتكوين النظام. لا يستطيع أي نظام كمبيوتر توفير الأمان المطلق. تحقق من الشركة المصنعة للنظام أو البائع بالتجزئة أو اعرف المزيد على موقع intel.com.",
          "⁴للأنظمة المزودة بشاشات عرض عالية الوضوح بالكامل FHD، عند استخدامها لاستعراض الويب اللاسلكي. عند إيقاف تشغيلها، من مستوى إيقاف التشغيل الافتراضي للشركة المصنعة للمعدات الأصلية.",
          "⁵بالمقارنة مع تقنيات الاتصال الأخرى الخاصة بمنافذ الإدخال/الإخراج في الكمبيوتر، بما في ذلك eSATA و USB و IEEE 1394*‎ FireWire. سيختلف الأداء حسب الأجهزة والبرامج المحددة المستخدمة لديك. يجب استخدام جهاز ممكن لتقنية Thunderbolt™‎.",
          "⁶أسرع 3 مرات تقريبًا: 802.11ax 2x2 160 ميغاهرتز تفعّل معدلات بيانات نظرية قصوى قدرها 2402 ميغابت في الثانية. أسرع حوالي 3 مرات من شبكة Wi‑Fi القياسية 802.11ac 2x2 80 ميغاهرتز (867 ميغابت في الثانية) كما هو موثق في المواصفات القياسية اللاسلكية IEEE 802.11*‎ وتتطلب استخدام أجهزة توجيه شبكة لاسلكية 802.11ax تم تكوينها بطريقة مشابهة.",
          "⁷زمن وصول أقل بنسبة 75%: يستند إلى بيانات المحاكاة من إنتل (79%) لمعيار 802.11ax مع النفاد المتعدّد باستخدام الحوامل التردّدية المتعامدة ودونه باستخدام تسعة أجهزة عميلة. يساوي معدّل زمن الوصول من دون الاقتسام المتعدد للترددات المتعامدة 36 ميللي ثانية فيما يقل معدّل زمن الوصول إلى 7.6 ميللي ثانية مع النفاد المتعدّد باستخدام الحوامل التردّدية المتعامدة. يتطلب تحسين زمن الوصول أن يدعم كل العملاء والموجّه معيار 802.11ax (تقنية Wi-Fi 6) النفاد المتعدّد باستخدام الحوامل التردّدية المتعامدة.",
          "⁸استنادًا إلى مقارنة معدل البيانات الأقصى النظري في مواصفات 802.11، يمكن لشبكة 2x2 Wi‑Fi 6/6E (802.11ax) بتردد 160 ميغاهرتز توفير سرعة 2402 ميغابت في الثانية مقارنة بشبكة 2x2 Wi‑Fi 5 (802.11ac) بتردد 80 ميغاهرتز التي يمكنها توفير سرعة 867 ميغابت في الثانية أي ما يعادل 2.8 مرة ضعف السرعة.",
          "⁹الأفضل في فئتها Wi‑Fi 6: تدعم منتجات Intel®‎ Wi‑Fi 6 (Gig+) قنوات 160 ميغاهرتز الاختيارية، مما يتيح أقصى سرعات نظرية ممكنة (2402 ميغابت في الثانية) لمنتجات Wi‑Fi للكمبيوتر 2x2 802.11ax المعتادة. تتيح منتجات Intel®‎ Wi‑Fi 6 (Gig+)‎ المميزة سرعات نظرية قصوى أكبر مرتين إلى 4 مرات بالمقارنة مع منتجات Wi‑Fi الخاصة بالكمبيوتر من المعيار 802.11ax ‏2x2 ‏(1201 ميغابت في الثانية) أو 1x1 ‏(600 ميغابت في الثانية)، التي تدعم المتطلبات الإلزامية لقنوات تردد 80 ميغاهرتز فقط.",
          "وحدات إدارة مخزون محددة فقط، تختلف الوظيفة حسب تصميم جهة التصنيع الأصلية للجهاز. راجع المصنّع الأصلي أو البائع بالتجزئة للحصول على التفاصيل. لمزيد من معلومات Wi‑Fi، يرجى زيارة intel.com/wifi6disclaimers.",
          "¹⁰تقدم تقنية Thunderbolt™‎ 4، بسرعة 40 غيغابت في الثانية، حل الكابل الأسرع والأكثر بساطة وموثوقية لأي قاعدة إرساء أو شاشة أو جهاز بيانات مقارنة بتقنيات الاتصال الأخرى الخاصة بالإدخال/الإخراج في الكمبيوتر بما في ذلك eSATA*‎ وUSB*‎ وIEEE 1394* FireWire.",
          "¹¹يتطلب موجهًا مستندًا إلى 802.11ax ويدعم النفاد المتعدّد باستخدام الحوامل التردّدية المتعامدة وعدة أجهزة عميلة على الشبكة مع دعم AX. يمكن تحقيق الأفضل في البيئات الكثيفة من خلال ميزات OFDMA المدعومة من قبل عملاء ونقاط وصول 802.11ax. 2 غيغابت في الثانية على أساس افتراضات ما يقرب من 70% من الحد الأقصى لمواصفات IEEE 802.11*‎ لمعدلات البيانات النظرية القصوى 802.11ax 160 ميغاهرتز 2402 ميغابت في الثانية.",
          "¹²كما تم قياسه من خلال بدء تشغيل مستند مع عبء عمل إجراء نشاط في الخلفية مقارنة بمعالج Intel® Core™ i7-8565U من الجيل الثامن (محرك أقراص ذات حالة صلبة ثلاثي المستوى سعة 512 غيغابايت) مقابل معالج Intel® Core™ i7-8565U من الجيل الثامن (ذاكرة Intel® Optane™ H10 سعة 32 غيغابايت مع وحدة تخزين من الحالة الصلبة سعة 512 غيغابايت).",
          "¹³صُمم Intel®‎ Thread Director في معالجات Intel®‎ Core™‎‎ من الجيل الثاني عشر وهو يساعد في دعم أنظمة التشغيل عبر توجيه أعباء العمل بشكل أكثر ذكاء إلى الأساس المناسب. لا يتطلب الأمر من المستخدم اتخاذ أي إجراء. راجع intel.com للحصول على التفاصيل.",
          "¹⁴لا يتوفر على بعض معالجات Intel® Core™‎ من الجيل الثاني عشر. تجمع الهندسة الهجينة المخصصة للأداء العالي هندستين مصغرتين جديدتين للأساسات، إضافة إلى Performance-cores‏ (P-cores) وEfficient-cores‏ (E-cores)، في قالب معالج واحد. إن بعض معالجات Intel® Core™‎ من الجيل الثاني عشر (وبعض معالجات Intel® Core™ i5 من الجيل الثاني عشر والإصدارات الأقدم) لا تدعم الهندسة الهجينة المخصصة للأداء العالي، بل تدعم P-cores فقط.",
          "¹⁵حسبما تم القياس بواسطة عبء عمل تشغيل الألعاب عند مقارنة معالج Intel® Core™ i7- 8750H من الجيل الثامن (مزوّد بوحدة ذاكرة Intel®‎ Optane™‎ سعة 32 غيغابايت ومحرك الأقراص ذو الحالة الصلبة Intel® PCIe*‎ سعة 256 غيغابايت ومحرك أقراص ثابت سعة 1 تيرابايت) بمعالج Intel® Core™ i7 8750H من الجيل الثامن (مزوّد بمحرك الأقراص ذو الحالة الصلبة Intel® PCIe*‎ سعة 256 غيغابايت ومحرك أقراص ثابت سعة 1 تيرابايت). عبء عمل تشغيل الألعاب: عبء عمل طورته إنتل لقياس الوقت المنقضي لتشغيل لعبة Total War*: WARHAMMER* II الإصدار: 5577.0 والوصول إلى القائمة الرئيسية مع تعطيل مقاطع الفيديو التقديمية (بدء التشغيل). تكوينات ذاكرة Intel® Optane™‎ لتسريع محرك أقراص البيانات: معالج Intel® Core™ i7-8750H، حدود الطاقة PL1‏=45 واطاً لطاقة التصميم الحرارية، 6 أساسات و12 خيط معالجة، سرعة فائقة تصل إلى 4 غيغاهرتز على نظام مصنّعي المعدات الأصلية في مرحلة ما قبل الإنتاج، الصور: NVIDIA* GeForce* GTX 1070، الذاكرة: ذاكرتا DDR4 سعة 4 غيغابايت، وحدة التخزين: سلسلة محرك الأقراص ذو الحالة الصلبة Intel® 760p سعة 256 غيغابايت (PCle*‎) مع محرك أقراص ثابت سعة 1 تيرابايت وذاكرة Intel® Optane™‎ سعة 32 غيغابايت، نظام التشغيل: Windows* 10 RS3 الإصدار 1709، وحدة تحكم مصغّرة 0x84؛ معالج Intel® Core™ i7-8750H، حدود الطاقة PL1‏=45 واطاً لطاقة التصميم الحرارية، 6 أساسات و12 خيط معالجة، سرعة فائقة تصل إلى 4 غيغاهرتز على نظام مصنّعي المعدات الأصلية في مرحلة ما قبل الإنتاج، الصور: NVIDIA* GeForce* GTX 1070، الذاكرة: ذاكرتا DDR4 سعة 4 غيغابايت، وحدة التخزين: سلسلة محرك الأقراص ذو الحالة الصلبة Intel® 760p سعة 256 غيغابايت (PCle*‎) ومحرك أقراص ثابت سعة 1 تيرابايت، نظام التشغيل: Windows* 10 RS3 الإصدار 1709، وحدة تحكم مصغّرة 0x84.&rlm;",
          "¹⁶حسبما تم قياسه بواسطة عبء عمل تشغيل الألعاب عند مقارنة معالج Intel® Core™ i7-8750H من الجيل الثامن (المزوّد بوحدة ذاكرة Intel® Optane™‎ سعة 32 غيغابايت) بمعالج Intel® Core™ i7-8750H من الجيل الثامن (المزوّد بمحرك أقراص ثابت فحسب). عبء عمل تحميل مستويات الألعاب: عبء عمل طورته إنتل لقياس الوقت المنقضي من القائمة الرئيسية إلى إكمال تحميل المستوى على لعبة Total War* WARHAMMER* II الإصدار: 5577.0. تكوينات ذاكرة Intel® Optane™‎ لتسريع محرك أقراص البيانات: معالج Intel® Core™ i7-8750H، حدود الطاقة PL1‏=45 واطاً لطاقة التصميم الحرارية، 6 أساسات و12 خيط معالجة، سرعة فائقة تصل إلى 4 غيغاهرتز على نظام مصنّعي المعدات الأصلية في مرحلة ما قبل الإنتاج، الصور: NVIDIA* GeForce* GTX 1070، الذاكرة: ذاكرتا DDR4 سعة 4 غيغابايت، وحدة التخزين: سلسلة محرك الأقراص ذو الحالة الصلبة Intel® 760p سعة 256 غيغابايت (PCle*‎) مع محرك أقراص ثابت سعة 1 تيرابايت وذاكرة Intel® Optane™‎ سعة 32 غيغابايت، نظام التشغيل: Windows* 10 RS3 الإصدار 1709، وحدة تحكم مصغّرة 0x84؛ معالج Intel® Core™ i7-8750H، حدود الطاقة PL1‏=45 واطاً لطاقة التصميم الحرارية، 6 أساسات و12 خيط معالجة، سرعة فائقة تصل إلى 4 غيغاهرتز على نظام مصنّعي المعدات الأصلية في مرحلة ما قبل الإنتاج، الصور: NVIDIA* GeForce* GTX 1070، الذاكرة: ذاكرتا DDR4 سعة 4 غيغابايت، وحدة التخزين: سلسلة محرك الأقراص ذو الحالة الصلبة Intel® 760p سعة 256 غيغابايت (PCle*‎) ومحرك أقراص ثابت سعة 1 تيرابايت، نظام التشغيل: Windows* 10 RS3 الإصدار 1709، وحدة تحكم مصغّرة 0x84.",
          "¹⁷في Performance-cores. يختلف الأداء حسب الاستخدام والتكوين وعوامل أخرى. اطلع على المزيد عبر www.intel.com/PerformanceIndex.",
          "¹⁸قد يتسبب تغيير تردد الساعة أو الفولطية في إلحاق ضرر بالعمر المفيد للمعالج ومكونات النظام الأخرى أو تقليله، وقد يحد من ثبات النظام وأدائه. قد لا تنطبق ضمانات المنتج إن تم تشغيل المعالج في ظروف تتجاوز مواصفاته. راجع الشركة المصنعة للنظام والمكونات للحصول على مزيد من التفاصيل.",
          "¹⁹وفقًا لقياسات مجموعة من قدرات منصة Intel vPro®‎ الفريدة التي تتجاوز / لا تتجاوز قدرات أمان نظام التشغيل، وحماية التطبيقات والبيانات، والحماية المتقدمة من المخاطر للشركات من أي حجم، بالإضافة إلى نهج \"الأمان أولًا\" الذي تتبعه إنتل في تصميم المنتجات وتصنيعها وتوفير الدعم لها. تم التحقق من أن جميع أجهزة الكمبيوتر الشخصي الخاصة بالشركات التي تشغلها منصة Intel vPro®‎ تلبي المواصفات الصارمة، بما في ذلك ميزات الأمان الفريدة التي تستند إلى الأجهزة. لمزيد من التفاصيل، تفضل بزيارة www.intel.com/PerformanceIndex (platforms). ولا يمكن لأيّ منتج أو مكوّن أن يوفر الأمان المطلق.",
          "²⁰يتوفر Intel® Connectivity Performance Suite على الأنظمة القائمة على Windows*‎ فقط. اختبار \"البرمجة عن بُعد (Over The Air)\" لخاصية الـ Wi-Fi من إنتل على شبكة مزدحمة بالمقارنة مع عدم تحديد أولوية نقل البيانات اللاسلكية من تطبيق برنامج ICPS والتبديل الذكي لنقطة الوصول. لمزيد من التفاصيل، تفضل بزيارة www.intel.com/PerformanceIndex (connectivity). قد تختلف النتائج.",
          "²¹بالمقارنة مع الجيل السابق من المعالجات.",
          "²²إن رسوميات Intel® Arc™‎ هي الأولى من نوعها في السوق التي تدعم ترميز AV1 (اعتبارًا من الربع الأول من عام 2022). يمكنك الحصول على التفاصيل عبر intel.com/performanceindex.",
          "²³كما تم قياسه عن طريق الميزات الفريدة لتصميمات Intel® Evo™‎، التي تم التحقق منها أيضًا لتلبية الحدود الرئيسية لتجربة مستخدم الأجهزة المحمولة. يبدأ الاختبار اعتبارًا من فبراير 2022.",
          "²⁴حل Intel® Unison™‎ متوفر حاليًا فقط على تصاميم Intel® Evo™‎ المؤهلة على أجهزة الكمبيوتر التي تعمل بنظام التشغيل Windows* ويوفّر إمكانية الإقران فقط مع الهواتف التي تعمل بنظام التشغيل Android أو iOS؛ ويجب أن تعمل جميع الأجهزة بإصدار متوافق من نظام التشغيل.",
          "²⁵ترتبط سرعات الذاكرة القصوى بتكوينات DIMM واحدة لكل قناة (1DPC). قد يؤثر تحميل DIMM الإضافي على أي قناة على السرعة القصوى للذاكرة. ما يصل إلى DDR5-5600 مليون عملية نقل في الثانية 1DPC UDIMM 1Rx8 و1Rx16 وDDR5-5200 1Rx8 و1Rx16 و2Rx8 في وحدات SKU محددة. يمكن تحقيق أقصى سعة للذاكرة باستخدام تكوينات 2DPC.",
          "²⁶مقارنة بشبكة Wi-Fi القياسية. راجع intel.com/performance-wireless للاطلاع على التفاصيل. قد تختلف النتائج.",
          "²⁷تجمع هندسة الأداء الهجينة بين هندستين مصغرتين للأساسات هما أساسات الأداء (P-cores) وأساسات الكفاءة (E-cores) في قالب معالج واحد أُطلِق للمرة الأولى في معالجات Intel® Core™‎ من الجيل الثاني عشر. هناك معالجات Intel® Core™‎ محددة من الجيل الثاني عشر والأجيال الأحدث لا تحتوي على هندسة الأداء الهجينة، بل تحتوي على P-cores فقط، ولها حجم ذاكرة التخزين المؤقتة نفسه المتوفر في الجيل السابق؛ راجع ark.intel.com للاطلاع على تفاصيل وحدات SKU.",
          "²⁸لا يتوفر Intel® Thread Director المدمج في الأجهزة إلا في تكوينات هندسة الأداء الهجينة لمعالجات Intel® Core™‎ من الجيل الثاني عشر أو الأجيال الأحدث؛ لذا يلزم تمكين نظام التشغيل. تختلف الميزات والوظائف المتوفرة حسب نظام التشغيل.",
          "²⁹لا يتوفر Intel® Thread Director المدمج في الأجهزة إلا في تكوينات هندسة الأداء الهجينة لمعالجات Intel® Core™‎ من الجيلَين الثاني عشر والثالث عشر؛ لذا يلزم تمكين نظام التشغيل. تختلف الميزات والوظائف المتوفرة حسب نظام التشغيل.",
          "³⁰حسب القياس باستخدام منصة تحقق مرجعية لقياس أداء معالج Intel®&nbsp;Core™ Ultra للأجهزة المحمولة (السلسلة 2 – الاسم الرمزي: Lunar Lake) مقارنةً بمعالج Intel®&nbsp;Core™ Ultra للأجهزة المحمولة (السلسلة 1 – الاسم الرمزي: Meteor Lake) بناءً على معيار 3DMark Time Spy. راجع intel.com/performanceindex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "³¹يتوفر تمويه الخلفية وتتبع الوجه على الأنظمة التي تعمل بنظام التشغيل Windows*‎ فقط.",
          "³²يمكن لمنتجات Wi-Fi 7 الوصول إلى قنوات 320 ميغاهرتز بقدرة 6 غيغاهرتز ومجموعات قنوات 160 ميغاهرتز الجديدة بقدرة 5 غيغاهرتز مع قدرات اختراق الوحدات متعددة الموارد الجديدة.",
          "³³استنادًا إلى مواصفات IEEE اللاسلكية القياسية وأقصى معدلات بيانات نظرية للأجهزة التي بإمكانها تقديم بثين تدفقيين في الوقت ذاته.",
          "³⁴تشير محاكيات هندسة Intel لبيئات الشبكات المزدحمة إلى إمكانية الحد من زمن الانتقال مع قدرات تشغيل Wi-Fi 7 متعددة الارتباطات الجديدة.",
          "³⁵الحد الأدنى من نسبة الشحن المحققة من مستوى إيقاف التشغيل الافتراضي حسب إعدادات الشركة المصنعة للمعدات الأصلية. قد تختلف نتائج كل نظام على حدة. راجع intel.com/Performance-Evo للاطلاع على التفاصيل.",
          "³⁶نطاق Wi-Fi البالغ 6 غيغاهرتز غير متاح للاستخدام في جميع البلدان/المناطق.",
          "‏³⁷‏Windows* فقط",
          "³⁸نسبة الشحن المحققة من مستوى إيقاف التشغيل الافتراضي حسب إعدادات الشركة المصنعة للمعدات الأصلية. للاطلاع على المزيد من المعلومات الكاملة حول الأداء ونتائج الاختبار المعياري، يرجى زيارة intel.com/Evo.",
          "³⁹يشير إلى معالجات Intel®&nbsp;Core™ Ultra للأجهزة المحمولة (السلسلة&nbsp;2)، بناءً على ميزات الأمان الفريدة المدمجة في الأجهزة، ومزيج لا مثيل له من إمكانات الأمان في كل مستويات نظام التشغيل، والأداء المذهل حتى وقت انخفاض الطاقة مقارنةً بالجيل السابق (بدءًا من سبتمبر 2024). راجع intel.com/performanceindex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "⁴⁰تُعرض تطبيقات البرامج هنا لأغراض توضيحية فقط. قد تتطلب ميزات الذكاء الاصطناعي شراء برامج إضافية أو الاشتراك فيها أو تمكينها بمعرفة موفر برامج أو منصات، أو قد تكون لها متطلبات إعداد أو توافق محددة. التفاصيل متاحة عبر www.intel.com/PerformanceIndex. قد تختلف النتائج. ‎© Intel Corporation.",
          "⁴¹الصور المعروضة ربما قد تعرّضت للتعديل أو المحاكاة. قد تتطلب ميزات الذكاء الاصطناعي شراء برامج إضافية أو الاشتراك فيها أو تمكينها بمعرفة موفر برامج أو منصات، أو قد تكون لها متطلبات إعداد أو توافق محددة. يمكن الاطّلاع على التفاصيل عبر الرابط www.intel.com/AIPC.",
          "⁴²تُطرح الميزة تدريجيًا في معاينة ضمن آخر تحديث لنظام التشغيل Windows* 11 في أسواق عالمية محددة. يختلف توقيت الإتاحة حسب الجهاز والسوق. اعرف المزيد هنا: aka.ms/WindowsAIFeatures. ‎© Intel Corporation.",
          "⁴³يتوفر حل Intel® Unison™‎ في الوقت الحالي للتصميمات المؤهلة. راجع www.intel.com/PerformanceIndex للاطلاع على التفاصيل.",
          "⁴⁴تمت ترقية عدد الإطارات في الثانية عبر تقنية Intel® X<sup>e</sup>SS مقابل عدد الإطارات في الثانية الأصلي وفقًا لما تم قياسه بواسطة لعبة Dying Light 2 Stay Human التي تعمل على معالج Intel®‎ Core™‎ Ultra 7 165H. راجع www.intel.com/PerformanceIndex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "⁴⁵حسب قياس استهلاك الطاقة المنخفض للنظام على رقاقة (SoC) في المعالج Intel®&nbsp;Core™ Ultra للأجهزة المحمولة (السلسلة 2 – الاسم الرمزي: Lunar Lake) منصة التحقق المرجعية مقابل منصة التحقق المرجعية لمعالج Intel®&nbsp;Core™ Ultra للأجهزة المحمولة (السلسلة 1 – الاسم الرمزي: Meteor Lake) لتشغيل فيديو على YouTube* بدقة 4K ومعدل تحديث 30 إطارًا في الثانية وترميز AV1. راجع intel.com/performanceindex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "⁴⁶وفقًا لقياس أداء منصة التحقق المرجعية لمعالج Intel® Core™ Ultra للأجهزة المحمولة (السلسلة 2 - الاسم الرمزي: Lunar Lake) بالمقارنة مع Meteor Lake باستخدام اختبار 3DMark* Time Spy. راجع intel.com/performanceindex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "⁴⁷حسب قياس استهلاك الطاقة المنخفض لـ SoC في المعالج Intel® Core™ Ultra للأجهزة المحمولة (السلسلة 2 – الاسم الرمزي: Lunar Lake) باستخدام منصة التحقق المرجعية مقارنةً بمعالج Meteor Lake باستخدام منصة التحقق المرجعية لتشغيل فيديو على YouTube* بدقة 4K ومعدل تحديث 30 إطارًا في الثانية وترميز AV1. راجع intel.com/performanceindex للاطلاع على التفاصيل. قد تختلف النتائج.",
          "‏‏⁴⁸‏Intel® Application Optimization هي سياسة ضمن تقنية Intel® Dynamic Tuning تعمل على تحسين الأداء لألعاب محددة، بشرط توافر التكوينات المطلوبة على بعض معالجات Intel® Core™ من الجيل الرابع عشر. للحصول على معلومات إضافية حول Intel® Application Optimization‎، راجع <br/>www.intel.com/content/<br/>www/us/en/support/articles/<br/>000095419/processors.html.",
          "⁴⁹يخضع اتصال Wi-Fi إلى توافر النطاق، ودعم نظام التشغيل، وتوافق جهاز التوجيه. التفاصيل متاحة على intel.com/performance-wireless. قد تختلف النتائج.",
          "⁵⁰اعتبارًا من أبريل 2024، مقارنةً بتقنيات الاتصال الأخرى ثنائية الاتجاه (الإدخال/الإخراج) الخاصة بالعميل، مثل تقنية Thunderbolt™ 5 وتقنية eSATA وتقنية USB. يجب توصيله باستخدام ملحق يدعم تقنية Thunderbolt™ 5 لتمكين الأداء المزدوج. التفاصيل متاحة على intel.com/performance-wired. قد تختلف النتائج.",
          "⁵¹للحصول على تفاصيل تقنية Thunderbolt™ 5، يُرجى زيارة intel.com/thunderbolt.",
          "⁵²الأداء يعتمد على تلبية الحد الأدنى من متطلبات المواصفات.",
          "⁵³‏Thunderbolt™ Share هو برنامج مرخص اختياري توفره الجهة المصنعة، وقد لا يكون متوفرًا على جميع أجهزة الكمبيوتر أو الأجهزة الأخرى التي تدعم تقنية Thunderbolt™ 5.<br>يوفر اتصالًا سريعًا مقارنةً بتقنيات الاتصال الأخرى الخاصة بمنافذ الإدخال/الإخراج على الكمبيوتر مثل تقنية eSATA وتقنية USB وتقنية IEEE 1394 Firewire. سيختلف الأداء حسب الأجهزة والبرامج المحددة المستخدمة لديك. يجب استخدام جهاز يدعم تقنية Thunderbolt™‎.<br>توفّر تقنية Thunderbolt™ 4 وتقنية Thunderbolt™ 5 منفذ DisplayPort الذي يمكنه الاتصال مباشرةً بجميع الشاشات التي تدعم DisplayPort وأيضًا mini-DisplayPort، وباستخدام المحولات، يمكن الاتصال بجميع واجهات العرض الحديثة الأخرى مثل HDMI وDVI وVGA.<br>قد تتفاوت نتائج الأداء حسب الملحقات الفردية؛ ومن ثم تتفاوت القوة والأداء بناءً على الاستخدام والتكوين وعوامل أخرى، ولا تُضمن كفاءة الأداء لكل ملحق على حدة.",
          "⁵⁴استنادًا إلى التوافق الواسع وخيارات البرامج المتنوعة والهندسة الفريدة والأداء المذهل لمعالجات Intel® Core™ Ultra التي تتكامل لتوفير أفضل تجربة شاملة للذكاء الاصطناعي، بما في ذلك بالمقارنة مع المعالجات المنافسة (اعتبارًا من أغسطس 2024).",
          "⁵⁵يتفاوت عمر البطارية تفاوتًا هائلًا بناءً على التكوينات والاستخدام وعوامل أخرى.",
          "⁵⁶يشير إلى بعض أجهزة الكمبيوتر المحمولة من طراز Dell* XPS المزودة بمعالج Intel® Core™ Ultra 7 268V استنادًا إلى معيار UL Procyon* لقياس عمر البطارية – النتيجة الفرعية الخاصة بالإنتاجية المكتبية؛ حيث تكون دقة الشاشة 1920×1080، وحجم البطارية: 55 واط/الساعة.",
          "⁵⁷لا تتوافر وحدة معالجة الرسوميات ™Intel® Arc إلا على بعض الأنظمة المدعومة بمعالجات Intel® Core™ Ultra. تكوينات الأنظمة الأخرى التي تأتي مزودة برسوميات ®Intel. راجع الجهة المصنعة للمعدات الأصلية أو البائع بالتجزئة للاطلاع على تفاصيل تكوينات الأنظمة.",
          "⁵⁸© 2025 Take - Two Interactive Software, Inc. © 2025 Techland S.A. ©&nbsp;Intel Corporation. يمكن الاسترداد بحلول 15 سبتمبر 2025. تطبق الشروط.",
          "⁵⁹يجب أن يكون جهاز الكمبيوتر المُستقبِل مزودًا بمعالج Intel® Core™ Ultra، وأن يعمل بنظام التشغيل Windows* 11 Home أو Pro، وأن يكون متصلًا بالإنترنت. يجب عليك استخدام Laplink* PCmover* Express Free في موعد أقصاه 28 فبراير 2026.",
          "⁶⁰يشير إلى الأداء في سلسلة من الاختبارات المعيارية الشائعة على الأنظمة المُشغَّلة بمعالج Intel® Core™ Ultra 200V مقابل المعالجات المنافسة.",
          "⁶¹يشير إلى نتائج الأداء بناءً على الاختبارات اعتبارًا من أغسطس 2024 على مجموعة متنوعة من الألعاب الشائعة على الأنظمة المُشغَّلة بمعالج Intel® Core™ Ultra 200V مقابل المعالجات المنافسة.",
          "⁶²يشير إلى الأنظمة المُشغَّلة بمعالجات Intel®‎ Core™‎ Ultra 200V مع رسوميات Intel®‎ Arc™‎ مقارنةً مع اختيارات الأنظمة شديدة النحافة الأخرى اعتبارًا من أغسطس 2024، بناءً على الأداء الرائع في الاختبارات المعيارية للرسوميات وأداء تشغيل الألعاب والأداء في الاختبارات المعيارية للذكاء الاصطناعي للرسوميات، بما في ذلك بالمقارنة مع المعالجات المنافسة.",
          "⁶³يشير إلى الأنظمة المُشغَّلة بمعالجات Intel® Core™ Ultra 200V، بناءً على الأداء الرائد في مجموعة كبيرة من الاستخدامات والاختبارات المعيارية وأعباء العمل بالمقارنة مع المعالجات المنافسة (اعتبارًا من أغسطس 2024). يتطلب تحديثًا مجانيًا؛ يختلف التوقيت وفقًا للجهاز والمنطقة. راجع aka.ms/copilotpluspcs لمزيد من المعلومات.",
          "⁶⁴يشير إلى بعض أجهزة الكمبيوتر المحمولة من طراز Dell* XPS المُشغَّلة بمعالج Intel® Core™ Ultra 7 268V استنادًا إلى معيار UL Procyon* لقياس عمر البطارية – النتيجة الفرعية الخاصة بالإنتاجية المكتبية؛ حيث تكون دقة الشاشة 1920×1080، وحجم البطارية: 55 واط/الساعة. بالنسبة للحواشي السفلية 1-7، راجع intel.com/performanceindex للاطلاع على التفاصيل.",
          "⁶⁵اعتبارًا من يناير 2024، استنادًا إلى الميزات الفريدة لتصاميم Intel®‎ Evo™‎ مثل معالجات Intel®‎ Core™‎ عالية الأداء والمكونات الممتازة والتوافق الذي لا نظير له وأحدث حلول اتصال في تصاميم مبتكرة أنيقة. يجب أن تستوفي كل التصاميم التي تحمل علامة Intel®‎ Evo™‎ مستويات عالية للتجارب الأساسية لمستخدمي الأجهزة المحمولة، مثل سرعة الاستجابة وعمر البطارية؛ قد يختلف أداء الجهاز الفردي. التفاصيل متاحة عبر www.intel.com/performance-evo. لا يمكن لأيّ منتج أو مكوّن أن يوفر الأمان المطلق. تُعرض تطبيقات البرامج هنا لأغراض توضيحية فقط. قد تتطلب ميزات الذكاء الاصطناعي شراء برنامج أو الاشتراك فيه أو تمكينه، أو قد تتطلب متطلبات تكوين أو توافق. تشير مزايا خصوصية البيانات إلى تطبيقات الذكاء الاصطناعي غير المستندة إلى السحابة. للاطلاع على المزيد من التفاصيل، راجع intel.com/AIPC. قد تختلف النتائج. © Intel Corporation. قد تكون الأسماء والعلامات التجارية الأخرى ملكًا لأصحابها المعنيين.",
          "⁶⁶استنادًا إلى عمر البطارية الفعلي الذي تم التحقق منه في أثناء إنجاز مهام سير العمل الطبيعية في بيئة واقعية ضمن سيناريوهات الاستخدام اليومي العادية. قد تختلف النتائج. التفاصيل متاحة على intel.com/Performance-Evo. © Intel Corp.",
          "[ZhCn Only Legal Text General]",
          "[ZhCn Only Legal Text Point12]",
          "[ZhCn Only Legal Text Point13]",
          "لا تتحمل إنتل مسؤولية أي خطأ في الأسعار.",
          "*قد تكون الأسماء والعلامات التجارية الأخرى ملكاً لأصحابها المعنيين.",
          "حقوق النشر لعام 2022 محفوظة لـ INFLEXION GAMES. يمثل كل من NIGHTINGALE وINFLEXION GAMES وما يرتبط بهما من تصميم وعلامات مركبة علامات تجارية لشركة INFLEXION STUDIOS INC. جميع الحقوق محفوظة.",
          "قد تتطلب تقنيات Intel‎ تنشيط أجهزة ممكنة أو برامج محددة أو خدمات محددة. لا يمكن لأيّ منتج أو مكوّن أن يوفر الأمان المطلق. قد تختلف التكاليف والنتائج. راجع التفاصيل الإضافية على https://edc.intel.com/content/<br/>www/us/en/products/performance/<br/>benchmarks/wired/",
          "يتم توفير أي نتائج وبيانات بواسطة NERO*‎ لأغراض التسهيل والإعلام فقط. لا تتحمل شركة إنتل أيّ مسؤولية، على سبيل المثال، عن دقة تطبيق NERO*‎ أو نتائج الأداء والدرجات الخاصة به أو عن الاختلافات المحتملة عن الإصدارات الأخرى القابلة للتنزيل من التطبيق والمتوفرة من الموقع www.nero.com أو من مواقع جهات خارجية أخرى على الويب. يتم قياس درجات الاختبارات المعيارية لأجهزة الكمبيوتر NERO*‎ باستخدام أنظمة ومكونات وبرامج وعمليات ووظائف محددة في الكمبيوتر. وقد يؤدي أي تغيير في أيّ من هذه العوامل إلى اختلاف في النتائج. عليك الرجوع إلى اختبارات الأداء والمعلومات الأخرى التي من شأنها مساعدتك في إجراء تقييم كامل لمشترياتك المتوقعة، بما في ذلك أداء المنتج عند استخدامه مع منتجات أخرى.",
          "تتطلب كل إصدارات منصة Intel vPro®‎ معالج Intel®‎ Core™‎ مؤهل، ونظام تشغيل مدعوم، وشبكة محلية و/أو شبكة محلية لاسلكية من Intel®‎ من دوائر السيليكون، وتحسينات البرامج الثابتة، وغيرها من الأجهزة والبرامج اللازمة لتوفير حالات استخدام قابلية الإدارة، وميزات الأمان وأداء النظام والثبات الذي يميز المنصة.",
          "يختلف الأداء حسب الاستخدام والتكوين وعوامل أخرى. اطلع على المزيد عبر www.intel.com/PerformanceIndex.",
          "لا تتحكم إنتل بالبيانات الخاصة بجهات خارجية ولا تدقق فيها. يجب أن تراجع مصادر أخرى لتقييم الدقة.",
          "© 2024 Ubisoft Entertainment*. All Rights Reserved. © Intel Corporation. إن Intel وشعار Intel وعلامات Intel الأخرى هي علامات تجارية لشركة Intel أو الشركات التابعة لها. *قد تكون الأسماء والعلامات التجارية الأخرى ملكًا لأصحابها المعنيين.",
          "لا يستطيع أي منتج أو مكون توفير الأمان المطلق.",
          "قد تختلف التكاليف والنتائج.",
          "إن Intel وشعار Intel وIntel Core وIntel Optane وIntel Iris وThunderbolt وشعار Thunderbolt، علامات تجارية لشركة إنتل أو الشركات التابعة لها. قد تكون الأسماء والعلامات التجارية الأخرى ملكًا لأصحابها المعنيين.",
          "‎© Intel Corporation."
        ],
        "targetURL": "",
        "iconURL": ""
      }
    },
    {
      "tabName": "navigation",
      "navigationTabs": [
        {
          "tr_specTitle": "الصفحة الرئيسية",
          "targetURL": "mob-content",
          "iconURL": "assets/images/nav-home.svg"
        },
        {
          "tr_specTitle": "مسح للمقارنة",
          "targetURL": "compare",
          "iconURL": ""
        },
        {
          "tr_specTitle": "الأكثر شيوعًا",
          "targetURL": "trending",
          "iconURL": "assets/images/trending.svg"
        }
      ]
    }
  ],
  "trending": [
    {
      "tr_specTitle": "أطلق إمكانات جديدة مع الذكاء الاصطناعي في معالجات Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video"
    },
    {
      "tr_specTitle": "أطلق إمكانات جديدة مع الذكاء الاصطناعي في معالجات Intel® Core™ Ultra",
      "targetURL": "assets/videos/trending/IPOS_AI_Video.mp4",
      "iconURL": "",
      "videoName": "IPOS_AI_Video"
    },
    {
      "tr_specTitle": "أطلق إمكانات جديدة مع الذكاء الاصطناعي في معالجات Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video_Panel2.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video_Panel2"
    },
    {
      "tr_specTitle": "Stable Diffusion* (الانتشار المستقر): تحويل النص إلى صورة",
      "targetURL": "assets/lang/[XX]/trending/text_link.mp4",
      "iconURL": "",
      "videoName": "text_link"
    },
    {
      "tr_specTitle": "Adobe*: تحرير الصور",
      "targetURL": "assets/lang/[XX]/trending/photo_link.mp4",
      "iconURL": "",
      "videoName": "photo_link"
    },
    {
      "tr_specTitle": "Intel® X<sup>e</sup>SS : تحسين دقة الصور",
      "targetURL": "assets/lang/[XX]/trending/imgUpscaling_link.mp4",
      "iconURL": "",
      "videoName": "imgUpscaling_link"
    },
    {
      "tr_specTitle": "McAfee*: أداة Deepfake Detector",
      "targetURL": "assets/lang/[XX]/trending/Security_link.mp4",
      "iconURL": "",
      "videoName": "Security_link"
    },
    {
      "tr_specTitle": "Microsoft* Copilot",
      "targetURL": "assets/lang/[XX]/trending/copilot_link.mp4",
      "iconURL": "",
      "videoName": "copilot_link"
    },
    {
      "tr_specTitle": "(Teams) تأثيرات التعاون",
      "targetURL": "assets/lang/[XX]/trending/Collaboration_link.mp4",
      "iconURL": "",
      "videoName": "Collaboration_link"
    },
    {
      "tr_specTitle": "IQIYI: التحكم في الإيماءات",
      "targetURL": "assets/lang/[XX]/trending/Gesture_link.mp4",
      "iconURL": "",
      "videoName": "Gesture_link"
    },
    {
      "tr_specTitle": "مزامنة الكمبيوتر الشخصي الخاص بك مع هاتفك وعرض الإشعارات والمكالمات والرسائل النصية",
      "targetURL": "assets/videos/trending/unison_evo_mtl_ultra_processor_video.mp4",
      "iconURL": "",
      "videoName": "unison_evo_mtl_ultra_processor_video"
    },
    {
      "tr_specTitle": "رسوميات مدمجة غنية ونابضة بالحياة",
      "targetURL": "assets/videos/trending/intel_iris_plus_graphics.mp4",
      "iconURL": "",
      "videoName": "intel_iris_plus_graphics"
    },
    {
      "tr_specTitle": "Microsoft*: عِش حياتك كما تشاء",
      "targetURL": "assets/videos/trending/standard_home_detail_run_your_life_with_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_run_your_life_with_microsoft_365"
    },
    {
      "tr_specTitle": "Microsoft*: صُمم خصيصًا لك. كل المعلومات بين يديك، بلمسة بسيطة",
      "targetURL": "assets/videos/trending/standard_home_detail_onedrive_in_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_onedrive_in_microsoft_365"
    },
    {
      "tr_specTitle": "خدمة Xbox* Game Pass Ultimate",
      "targetURL": "assets/videos/trending/windows_10_home.mp4",
      "iconURL": "",
      "videoName": "windows_10_home"
    },
    {
      "tr_specTitle": "شغّل معالجك بسرعة أعلى وترددات أعلى من خلال ضبط نظامك بدقة",
      "targetURL": "assets/videos/trending/gaming_processor_detail_enthusiast _overclocking.mp4",
      "iconURL": "",
      "videoName": "gaming_processor_detail_enthusiast _overclocking"
    },
    {
      "tr_specTitle": "عزّز أداء نظام الكمبيوتر المكتبي أو المحمول دون التضحية بمساحة التخزين",
      "targetURL": "assets/videos/trending/optane_memory.mp4",
      "iconURL": "",
      "videoName": "optane_memory"
    },
    {
      "tr_specTitle": "عزّز أداء نظام الكمبيوتر المكتبي أو المحمول دون التضحية بمساحة التخزين",
      "targetURL": "assets/videos/trending/standard_detail_panel_memory_optanememory_optane-memory.mp4",
      "iconURL": "",
      "videoName": "standard_detail_panel_memory_optanememory_optane-memory"
    },
    {
      "tr_specTitle": "شاشات OLED من Samsung: متعة بصرية لا تضاهى",
      "targetURL": "assets/lang/[XX]/trending/Samsung_OLED.mp4",
      "iconURL": "",
      "videoName": "Samsung_OLED"
    },
    {
      "tr_specTitle": "سرعة وزمن انتقال وموثوقية معززين من خلال تحسين الشبكات القائم على الذكاء الاصطناعي",
      "targetURL": "assets/videos/trending/standard__wifi_killer_7.mp4",
      "iconURL": "",
      "videoName": "standard__wifi_7_killer"
    },
    {
      "tr_specTitle": "شبكة كمبيوتر شخصي تضاهي الشبكات السلكية",
      "targetURL": "assets/videos/trending/standard_wifi_7.mp4",
      "iconURL": "",
      "videoName": "standard_wifi_7"
    },
    {
      "tr_specTitle": "شبكة كمبيوتر شخصي تضاهي الشبكات السلكية",
      "targetURL": "assets/videos/trending/wifi_7_desktop_video.mp4",
      "iconURL": "",
      "videoName": "wifi_7_desktop_video"
    },
    {
      "tr_specTitle": "سرعات 3 مرات أكبر تقريبًا بفضل تقنية Intel®‎ Wi-Fi 6 (Gig+)",
      "targetURL": "assets/lang/[XX]/trending/nongaming__wifi_6e.mp4",
      "iconURL": "",
      "videoName": "wifi_6e"
    },
    {
      "tr_specTitle": "اتصال بدون المنافسة",
      "targetURL": "assets/videos/trending/standard_tile_wifi_intel_panel2_video.mp4",
      "iconURL": "",
      "videoName": "standard_tile_wifi_intel_panel2_video"
    },
    {
      "tr_specTitle": "إمكانية اتصال بكابل عام فعلًا",
      "targetURL": "assets/videos/trending/standard_facttag_details_thunderbolt_version3.mp4",
      "iconURL": "",
      "videoName": "standard_facttag_details_thunderbolt_version3"
    },
    {
      "tr_specTitle": "العب كالمحترفين: شاهد كيف تدعم Intel الألعاب واللاعبين",
      "targetURL": "assets/videos/trending/gaming_graphics_detail.mp4",
      "iconURL": "",
      "videoName": "gaming_graphics_detail"
    },
    {
      "tr_specTitle": "العب كالمحترفين: تصبح الانتصارات حقيقة مع Intel",
      "targetURL": "assets/videos/trending/gaming_detail_panel_influencer_video.mp4",
      "iconURL": "",
      "videoName": "gaming_detail_panel_influencer_video"
    }
  ],
  "uiText": {
    "tr_welcomePageTitle": "مرحبًا",
    "tr_welcomePagetrSubtitle": "تحكم في هذا الكمبيوتر عن بُعد باستخدام هاتفك الذكي",
    "tr_welcomePagembSubtitle": "مرحبًا، استكشف مواصفات هذا الكمبيوتر على هاتفك الذكي",
    "tr_welcomePageBtnText": "ابدأ",
    "tr_welcomePageText": "استكشف وقارن تفاصيل هذا الكمبيوتر على هاتفك الذكي",
    "tr_scrollText": "تصفح الجهاز الموجود أمامك",
    "tr_toolTipTextc1": "استخدم هذه الأزرار للانتقال إلى صفحات مختلفة على الجهاز الموجود أمامك.",
    "tr_toolTipTextc2": "سيؤدي الضغط على البطاقات أدناه إلى الانتقال إلى صفحة تفصيلية لمواصفات كل جهاز.",
    "tr_toolTipTextc3": "استخدم هذه الأزرار للتحرك لأعلى ولأسفل على الشاشة الموجودة أمامك.",
    "tr_toolTipTextc4": "أوقف تشغيل وضع التحكم عن بُعد لعرض مواصفات الجهاز على هاتفك الذكي.",
    "tr_toolTipTextmb1": "اضغط على البطاقات لعرض صفحات المحتوى التفصيلية.",
    "tr_toolTipTextmb2": "اضغط لعرض موجز عن كل مواصفات الجهاز",
    "tr_toolTipTextmb3": "اضغط الزر لمسح رمز QR ومقارنة ما يصل إلى 4 أجهزة",
    "tr_nextButton": "التالي",
    "tr_prevButton": "السابق",
    "tr_gotItButton": "فهمت",
    "tr_skipButton": "تخطي",
    "tr_placeholderText": "*عنصر نائب",
    "tr_processorHeading": "المعالج",
    "tr_processorSubheading": "معالج Intel®‎ Core™‎ i7 من الجيل العاشر",
    "tr_memorySubheading": "[XX] غيغابايت",
    "tr_storageSubheading": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت + محرك أقراص ذات حالة صلبة سعة [YY] غيغابايت",
    "tr_coachmarkProcessor": "معالج XX",
    "tr_coachmarkGraphics": "رسوميات [XX]",
    "tr_coachmarkMemory": "قيمة المواصفات",
    "tr_coachmarkOS": "[XX]",
    "tr_deviceName": "HP Envy 17T",
    "tr_price": "999.95 دولارًا",
    "tr_compare": "المقارنة",
    "tr_viewallspecs": "عرض كل المواصفات",
    "tr_operatingSystem": "نظام التشغيل",
    "tr_AmdProcessorNonIntel": "معالج AMD*",
    "tr_QualcommProcessorNonIntel": "معالج Qualcomm*",
    "tr_GBText": "غيغابايت",
    "tr_remoteText": "المواصفات المعروضة على شاشة الكمبيوتر المحمول",
    "tr_scanErrorText": "يمكنك إجراء مسح ضوئي لما يصل إلى 3 أجهزة في وقت واحد فقط. يرجى حذف جهاز أو أكثر.",
    "tr_scanErrorText2": "لقد قمت بالفعل بمسح هذا الجهاز ضوئيًا، يرجى مسح جهاز آخر ضوئيًا.",
    "tr_scanMsg": "إجراء مسح ضوئي لإضافة جهاز",
    "tr_backToScan": "العودة إلى المقارنة",
    "tr_scanToCompare": "إجراء مسح ضوئي للمقارنة",
    "tr_compareDevice": "مقارنة الأجهزة",
    "tr_processorTitle": "معالج",
    "tr_graphicTitle": "الرسوميات",
    "tr_storageTitle": "التخزين",
    "tr_displayTitle": "شاشة العرض",
    "tr_batteryTitle": "البطارية",
    "tr_memoryTitle": "الذاكرة",
    "tr_wifiTitle": "Wi‑Fi",
    "tr_connectivityTitle": "الاتصال",
    "tr_priceTitle": "السعر",
    "tr_operatingSystemTitle": "نظام التشغيل",
    "tr_batteryHoursText": "[XX] ساعات",
    "tr_hrsText": "ساعات",
    "tr_touchscreeenText": "شاشة لمس مقاس [screenDiagonal] بوصة",
    "tr_HDText": "جودة عالية",
    "tr_FHDText": "FHD",
    "tr_4KText": "4K",
    "tr_HDTochScreenText": "شاشة لمس، عالية الوضوح",
    "tr_FHDTouchScreenText": "شاشة لمس، FHD",
    "tr_4KTouchscreenText": "شاشة لمس، 4K",
    "tr_wifi_gigText": "(Gig+‎)",
    "tr_save": "حفظ",
    "tr_device_comparison": "مستند مقارنة الجهاز [mm]-[dd]-[yyyy]",
    "tr_Save_As_JPEG": "حفظ بصيغة JPEG",
    "tr_Save_As_PDF": "حفظ بصيغة PDF",
    "tr_Downloading_PDF": "جار تنزيل PDF",
    "tr_pdf_file": "[XXX].pdf",
    "tr_open": "فتح",
    "tr_logo": "شعار",
    "tr_laptop_name": "اسم الكمبيوتر المحمول",
    "tr_TBText": "تيرابايت",
    "tr_optaneMemoryTitle": "ذاكرة Intel®‎ Optane™‎",
    "tr_inchUnit": "بوصة",
    "tr_wifi1": "Wi‑Fi 1",
    "tr_wifi2": "Wi‑Fi 2",
    "tr_wifi3": "Wi‑Fi 3",
    "tr_wifi4": "Wi‑Fi 4",
    "tr_wifi5": "Wi‑Fi 5",
    "tr_wifi6": "Intel®‎ Wi‑Fi 6 (Gig+)‎",
    "tr_wifi6Caps": "INTEL®‎ WI‑FI 6 (GIG+)",
    "tr_wifi6e": "6E",
    "tr_wifi6eValue": "Wi‑Fi 6E",
    "tr_wifiXX": "Wi‑Fi [XX]",
    "tr_wifiXXCaps": "WI‑FI [XX]",
    "tr_wifi6E": "Intel®‎ Wi‑Fi 6E (Gig+)",
    "tr_IntelOptaneMemory": "ذاكرة INTEL® OPTANE™‎",
    "tr_Thunderbolt3": "تقنية Thunderbolt™‎ 3",
    "tr_Thunderbolt4": "تقنية Thunderbolt™‎ 4",
    "tr_Thunderbolt5": "تقنية Thunderbolt™ 5‎",
    "tr_processorGraphicsCaps": "رسوميات المعالج",
    "tr_processorGraphicsSmall": "رسوميات المعالج",
    "tr_graphicsCardCaps": "الرسوميات المخصصة",
    "tr_graphicsCardSmall": "الرسوميات المخصصة",
    "tr_processorTitleCamel": "المعالج",
    "tr_graphicTitleCamel": "الرسوميات",
    "tr_storageTitleCamel": "التخزين",
    "tr_displayTitleCamel": "شاشة العرض",
    "tr_batteryTitleCamel": "البطارية",
    "tr_batteryLifeTitleCamel": "عمر البطارية",
    "tr_exceptionalBattery": "عمر بطارية استثنائي",
    "tr_memoryTitleCamel": "الذاكرة",
    "tr_connectivityTitleCamel": "الاتصال",
    "tr_priceTitleCamel": "السعر",
    "tr_operatingSystemTitleCamel": "نظام التشغيل",
    "tr_viewallspecsCamel": "عرض كل المواصفات",
    "tr_displayText": "[screenDiagonal] بوصة",
    "tr_displayTextResolution": "[screenResolutionType] مقاس [screenDiagonal] بوصة",
    "tr_displayTextResolutionTouchscreen": "شاشة لمس [screenResolutionType] مقاس [screenDiagonal] بوصة",
    "tr_OS": "نظام التشغيل",
    "tr_Chrome_OS": "نظام التشغيل Chrome*‎",
    "tr_PCSpecs_text": "مواصفات الكمبيوتر",
    "tr_explorePC_text": "استكشف كل جوانب هذا الكمبيوتر",
    "tr_mtlPC_text": "استشعر المعنى الحقيقي لعبارة \"صُممت لكل المهام\"",
    "tr_optaneMemory": "ذاكرة Intel®‎&nbsp;Optane™‎",
    "tr_displayText_Display": "شاشة قياس [screenDiagonal] بوصة",
    "tr_displayTextResolution_Display": "شاشة قياس [screenDiagonal] بوصة ودقة [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen_Display": "شاشة تعمل باللمس قياس [screenDiagonal] بوصة ودقة [screenResolutionType]",
    "tr_displayTextTouchscreeenText": "شاشة تعمل باللمس قياس [screenDiagonal] بوصة",
    "tr_learnMoreLabel": "تعرف على المزيد",
    "tr_batteryHoursTextUpperCase": "[XX] من الساعات",
    "tr_processorGraphicsIrisXe": "معالج INTEL® CORE™ [cpu_fam] من الجيل الحادي عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax": "معالج INTEL® CORE™ [cpu_fam] من الجيل الحادي عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_Thunderbolt3UpperCase": "تقنية THUNDERBOLT™‎ 3",
    "tr_Thunderbolt4UpperCase": "تقنية THUNDERBOLT™‎ 4",
    "tr_Thunderbolt5UpperCase": "جرّب مزايا تقنية THUNDERBOLT™ 5",
    "tr_processorWithArcGraphics": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثاني عشر ورسوميات INTEL® ARC™‎",
    "tr_processorGraphicsIrisXe12Gen": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثاني عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>‎",
    "tr_processorGraphicsIrisXeMax12Gen": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثاني عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_samsung_oled": "Samsung OLED",
    "tr_oled": "OLED",
    "tr_processorWithArcGraphics13Gen": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثالث عشر ورسوميات INTEL® ARC™‎",
    "tr_processorGraphicsIrisXe13Gen": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثالث عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>‎",
    "tr_processorGraphicsIrisXeMax13Gen": "معالج INTEL® CORE™ [cpu_fam] من الجيل الثالث عشر مع رسوميات INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_ultra5": "Intel® Core™ Ultra 5",
    "tr_ultra7": "Intel® Core™ Ultra 7",
    "tr_ultra9": "Intel® Core™ Ultra 9",
    "tr_arcGraphicsBadgeToModelNameMapping": {
      "tr_A350M": "رسوميات INTEL®‎ ARC™‎ A350M",
      "tr_A370M": "رسوميات INTEL®‎ ARC™‎ A370M",
      "tr_A730M": "رسوميات INTEL®‎ ARC™‎ A730M",
      "tr_A770M": "رسوميات INTEL®‎ ARC™‎ A770M",
      "tr_A310": "رسوميات INTEL®‎ ARC™‎ A310",
      "tr_A380": "رسوميات INTEL®‎ ARC™‎ A380",
      "tr_A580": "رسوميات INTEL®‎ ARC™‎ A580",
      "tr_A750": "رسوميات INTEL®‎ ARC™‎ A750",
      "tr_A770": "رسوميات INTEL®‎ ARC™‎ A770"
    },
    "tr_memoryValue": "ذاكرة RAM سعة [XX] غيغابايت",
    "tr_memoryWithOptaneDesc": "ذاكرة سعة [Value1] غيغابايت = ذاكرة Intel®‎ Optane™‎ سعة [Value2] غيغابايت + ذاكرة RAM سعة [Value3] غيغابايت",
    "tr_textGBGB": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت",
    "tr_textGBTB": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت",
    "tr_textTBGB": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] غيغابايت",
    "tr_textTBTB": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت + محرك أقراص صلبة سعة [convertedHDD] تيرابايت",
    "tr_textGBSSD": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت",
    "tr_textTBSSD": "محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت",
    "tr_textGBHDD": "محرك أقراص صلبة سعة [convertedHDD] غيغابايت",
    "tr_textTBHDD": "محرك أقراص صلبة سعة [convertedHDD] تيرابايت",
    "tr_textStorageWithOptaneGB": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت + محرك أقراص ذات حالة صلبة سعة [convertedSSD] غيغابايت",
    "tr_textStorageWithOptaneTB": "ذاكرة Intel®‎ Optane™‎ سعة [XX] غيغابايت +‏ محرك أقراص ذات حالة صلبة سعة [convertedSSD] تيرابايت",
    "tr_OSDescriptionMapping": {
      "tr_OS_A": "Windows*‎ 7",
      "tr_OS_B": "Windows*‎ 7 Home Basic",
      "tr_OS_C": "Windows*‎ 7 Home Premium",
      "tr_OS_D": "Windows*‎ 7 Professional",
      "tr_OS_E": "Windows*‎ 7 Enterprise",
      "tr_OS_F": "Windows*‎ 7 Ultimate",
      "tr_OS_G": "Windows* 8",
      "tr_OS_H": "Windows*‎ 8 Pro",
      "tr_OS_I": "Windows*‎ 8 Enterprise",
      "tr_OS_J": "Windows* 8.1",
      "tr_OS_K": "Windows*‎ 8.1 Pro",
      "tr_OS_L": "Windows*‎ 8.1 Enterprise",
      "tr_OS_M": "Windows* 8.1",
      "tr_OS_N": "Windows*‎ 10 Home",
      "tr_OS_O": "Windows*‎ 10 Pro",
      "tr_OS_P": "Windows*‎ 10 Enterprise",
      "tr_OS_Q": "Windows*‎ 11 Home",
      "tr_OS_R": "Windows*‎ 11 Pro",
      "tr_OS_S": "Windows* 11 Enterprise",
      "tr_OS_T": "Windows*‎ 10 Home في وضع S",
      "tr_OS_U": "Windows*‎ 10 Pro في وضع S",
      "tr_OS_V": "Windows*‎ 10 Enterprise في وضع S",
      "tr_OS_W": "Windows*‎ 11 Home في وضع S",
      "tr_OS_X": "Windows*‎ 11 Pro في وضع S",
      "tr_OS_Y": "Windows* 11‎ Enterprise في وضع S"
    },
    "tr_GraphicsDescriptionMapping": {
      "tr_GR1": "AMD* Mobility Radeon* 4100",
      "tr_GR2": "AMD* Mobility Radeon* HD 2400",
      "tr_GR3": "AMD* Mobility Radeon* HD 2400 XT",
      "tr_GR4": "AMD* Mobility Radeon* HD 2600",
      "tr_GR5": "AMD* Mobility Radeon* HD 2600 XT",
      "tr_GR6": "AMD* Mobility Radeon* HD 3400",
      "tr_GR7": "AMD* Mobility Radeon* HD 3430",
      "tr_GR8": "AMD* Mobility Radeon* HD 3650",
      "tr_GR9": "AMD* Mobility Radeon* HD 3670",
      "tr_GR10": "AMD* Mobility Radeon* HD 3850",
      "tr_GR11": "AMD* Mobility Radeon* HD 3850 X2",
      "tr_GR12": "AMD* Mobility Radeon* HD 3870",
      "tr_GR13": "AMD* Mobility Radeon* HD 3870 X2",
      "tr_GR14": "AMD* Mobility Radeon* HD 4200",
      "tr_GR15": "AMD* Mobility Radeon* HD 4300",
      "tr_GR16": "AMD* Mobility Radeon* HD 4330",
      "tr_GR17": "AMD* Mobility Radeon* HD 4500",
      "tr_GR18": "AMD* Mobility Radeon* HD 4650",
      "tr_GR19": "AMD* Mobility Radeon* HD 4670",
      "tr_GR20": "AMD* Mobility Radeon* HD 4830",
      "tr_GR21": "AMD* Mobility Radeon* HD 4850",
      "tr_GR22": "AMD* Mobility Radeon* HD 4860",
      "tr_GR23": "AMD* Mobility Radeon* HD 4870",
      "tr_GR24": "AMD* Mobility Radeon* HD 5000",
      "tr_GR25": "AMD* Mobility Radeon* HD 5570",
      "tr_GR26": "AMD* Mobility Radeon* HD 5800",
      "tr_GR27": "AMD* Mobility Radeon* HD 6000",
      "tr_GR28": "AMD* Radeon* HD 2350",
      "tr_GR29": "AMD* Radeon* HD 2400",
      "tr_GR30": "AMD* Radeon* HD 2400 Pro",
      "tr_GR31": "AMD* Radeon* HD 2400 XT",
      "tr_GR32": "AMD* Radeon* HD 2600",
      "tr_GR33": "AMD* Radeon* HD 2600 Pro",
      "tr_GR34": "AMD* Radeon* HD 2600 XT",
      "tr_GR35": "AMD* Radeon* HD 2900 GT",
      "tr_GR36": "AMD* Radeon* HD 2900 Pro",
      "tr_GR37": "AMD* Radeon* HD 2900 XT",
      "tr_GR38": "AMD* Radeon* HD 3200",
      "tr_GR39": "AMD* Radeon* HD 3300",
      "tr_GR40": "AMD* Radeon* HD 3450",
      "tr_GR41": "AMD* Radeon* HD 3470",
      "tr_GR42": "AMD* Radeon* HD 3600",
      "tr_GR43": "AMD* Radeon* HD 3650",
      "tr_GR44": "AMD* Radeon* HD 3830",
      "tr_GR45": "AMD* Radeon* HD 3850",
      "tr_GR46": "AMD* Radeon* HD 3850 X2",
      "tr_GR47": "AMD* Radeon* HD 3870",
      "tr_GR48": "AMD* Radeon* HD 3870 X2",
      "tr_GR49": "AMD* Radeon* HD 4200",
      "tr_GR50": "AMD* Radeon* HD 4250",
      "tr_GR51": "AMD* Radeon* HD 4290",
      "tr_GR52": "AMD* Radeon* HD 4300",
      "tr_GR53": "AMD* Radeon* HD 4550",
      "tr_GR54": "AMD* Radeon* HD 4600",
      "tr_GR55": "AMD* Radeon* HD 4700",
      "tr_GR56": "AMD* Radeon* HD 4770",
      "tr_GR57": "AMD* Radeon* HD 4800",
      "tr_GR58": "AMD* Radeon* HD 4850 X2",
      "tr_GR59": "AMD* Radeon* HD 4870 X2",
      "tr_GR60": "AMD* Radeon* HD 5000",
      "tr_GR61": "AMD* Radeon* HD 5400",
      "tr_GR62": "AMD* Radeon* HD 5450",
      "tr_GR63": "AMD* Radeon* HD 5470",
      "tr_GR64": "AMD* Radeon* HD 5490",
      "tr_GR65": "AMD* Radeon* HD 5500",
      "tr_GR66": "AMD* Radeon* HD 5530",
      "tr_GR67": "AMD* Radeon* HD 5570",
      "tr_GR68": "AMD* Radeon* HD 5600",
      "tr_GR69": "AMD* Radeon* HD 5630",
      "tr_GR70": "AMD* Mobility Radeon* 4100",
      "tr_GR71": "AMD* Radeon* HD 5690",
      "tr_GR72": "AMD* Radeon* HD 5700",
      "tr_GR73": "AMD* Radeon* HD 5730",
      "tr_GR74": "AMD* Radeon* HD 5800",
      "tr_GR75": "AMD* Radeon* HD 5850X2",
      "tr_GR76": "AMD* Radeon* HD 5900",
      "tr_GR77": "AMD* Radeon* HD 6230",
      "tr_GR78": "AMD* Radeon* HD 6250",
      "tr_GR79": "AMD* Radeon* HD 6290",
      "tr_GR80": "AMD* Radeon* HD 6300M",
      "tr_GR81": "AMD* Radeon* HD 6350",
      "tr_GR82": "AMD* Radeon* HD 6350A",
      "tr_GR83": "AMD* Radeon* HD 6390",
      "tr_GR84": "AMD* Radeon* HD 6400",
      "tr_GR85": "AMD* Radeon* HD 6430M",
      "tr_GR86": "AMD* Radeon* HD 6450",
      "tr_GR87": "AMD* Radeon* HD 6490",
      "tr_GR88": "AMD* Radeon* HD 6500",
      "tr_GR89": "AMD* Radeon* HD 6510",
      "tr_GR90": "AMD* Radeon* HD 6530",
      "tr_GR91": "AMD* Radeon* HD 6570",
      "tr_GR92": "AMD* Radeon* HD 6600A",
      "tr_GR93": "AMD* Radeon* HD 6610",
      "tr_GR94": "AMD* Radeon* HD 6670",
      "tr_GR95": "AMD* Radeon* HD 6700",
      "tr_GR96": "AMD* Radeon* HD 6700M",
      "tr_GR97": "AMD* Radeon* HD 6750",
      "tr_GR98": "AMD* Radeon* HD 6800",
      "tr_GR99": "AMD* Radeon* HD 6800M",
      "tr_GR100": "AMD* Radeon* HD 6850",
      "tr_GR101": "AMD* Radeon* HD 6850 X2",
      "tr_GR102": "AMD* Radeon* HD 6870",
      "tr_GR103": "AMD* Radeon* HD 6870 X2",
      "tr_GR104": "AMD* Radeon* HD 6900",
      "tr_GR105": "AMD* Radeon* HD 6900M",
      "tr_GR106": "AMD* Radeon* HD 7000",
      "tr_GR107": "AMD* Radeon* HD 7000M",
      "tr_GR108": "AMD* Radeon* HD 7300",
      "tr_GR109": "AMD* Radeon* HD 7350",
      "tr_GR110": "AMD* Radeon* HD 7400",
      "tr_GR111": "AMD* Radeon* HD 7400A",
      "tr_GR112": "AMD* Radeon* HD 7400G",
      "tr_GR113": "AMD* Radeon* HD 7400M",
      "tr_GR114": "AMD* Radeon* HD 7420G",
      "tr_GR115": "AMD* Radeon* HD 7450",
      "tr_GR116": "AMD* Radeon* HD 7450A",
      "tr_GR117": "AMD* Radeon* HD 7470",
      "tr_GR118": "AMD* Radeon* HD 7480D",
      "tr_GR119": "AMD* Radeon* HD 7500",
      "tr_GR120": "AMD* Radeon* HD 7500G",
      "tr_GR121": "AMD* Radeon* HD 7500M",
      "tr_GR122": "AMD* Radeon* HD 7510",
      "tr_GR123": "AMD* Radeon* HD 7520G",
      "tr_GR124": "AMD* Radeon* HD 7540D",
      "tr_GR125": "AMD* Radeon* HD 7560D",
      "tr_GR126": "AMD* Radeon* HD 7570",
      "tr_GR127": "AMD* Radeon* HD 7600",
      "tr_GR128": "AMD* Radeon* HD 7600A",
      "tr_GR129": "AMD* Radeon* HD 7600G",
      "tr_GR130": "AMD* Radeon* HD 7600M",
      "tr_GR131": "AMD* Radeon* HD 7620G",
      "tr_GR132": "AMD* Radeon* HD 7640G",
      "tr_GR133": "AMD* Radeon* HD 7660D",
      "tr_GR134": "AMD* Radeon* HD 7660G",
      "tr_GR135": "AMD* Radeon* HD 7670",
      "tr_GR136": "AMD* Radeon* HD 7670M",
      "tr_GR137": "AMD* Radeon* HD 7700",
      "tr_GR138": "AMD* Radeon* HD 7700M",
      "tr_GR139": "AMD* Radeon* HD 7720",
      "tr_GR140": "AMD* Radeon* HD 7800",
      "tr_GR141": "AMD* Radeon* HD 7800M",
      "tr_GR142": "AMD* Radeon* HD 7900",
      "tr_GR143": "AMD* Radeon* HD 7970M",
      "tr_GR144": "AMD* Radeon* HD 8180",
      "tr_GR145": "AMD* Radeon* HD 8200",
      "tr_GR146": "AMD* Radeon* HD 8210",
      "tr_GR147": "AMD* Radeon* HD 8210E",
      "tr_GR148": "AMD* Radeon* HD 8250",
      "tr_GR149": "AMD* Radeon* HD 8280E",
      "tr_GR150": "AMD* Radeon* HD 8310G",
      "tr_GR151": "AMD* Radeon* HD 8330",
      "tr_GR152": "AMD* Radeon* HD 8330E",
      "tr_GR153": "AMD* Radeon* HD 8350",
      "tr_GR154": "AMD* Radeon* HD 8350G",
      "tr_GR155": "AMD* Radeon* HD 8370D",
      "tr_GR156": "AMD* Radeon* HD 8400",
      "tr_GR157": "AMD* Radeon* HD 8400E",
      "tr_GR158": "AMD* Radeon* HD 8410G",
      "tr_GR159": "AMD* Radeon* HD 8450",
      "tr_GR160": "AMD* Radeon* HD 8450G",
      "tr_GR161": "AMD* Radeon* HD 8470",
      "tr_GR162": "AMD* Radeon* HD 8470D",
      "tr_GR163": "AMD* Radeon* HD 8490",
      "tr_GR164": "AMD* Radeon* HD 8500M",
      "tr_GR165": "AMD* Radeon* HD 8510",
      "tr_GR166": "AMD* Radeon* HD 8510G",
      "tr_GR167": "AMD* Radeon* HD 8550",
      "tr_GR168": "AMD* Radeon* HD 8550D",
      "tr_GR169": "AMD* Radeon* HD 8550G",
      "tr_GR170": "AMD* Radeon* HD 8570",
      "tr_GR171": "AMD* Radeon* HD 8570D",
      "tr_GR172": "AMD* Radeon* HD 8600",
      "tr_GR173": "AMD* Radeon* HD 8600M",
      "tr_GR174": "AMD* Radeon* HD 8610G",
      "tr_GR175": "AMD* Radeon* HD 8650D",
      "tr_GR176": "AMD* Radeon* HD 8650G",
      "tr_GR177": "AMD* Radeon* HD 8670D",
      "tr_GR178": "AMD* Radeon* HD 8730",
      "tr_GR179": "AMD* Radeon* HD 8760",
      "tr_GR180": "AMD* Radeon* HD 8770",
      "tr_GR181": "AMD* Radeon* HD 8790M",
      "tr_GR182": "AMD* Radeon* HD 8800M",
      "tr_GR183": "AMD* Radeon* HD 8870",
      "tr_GR184": "AMD* Radeon* HD 8950",
      "tr_GR185": "AMD* Radeon* HD 8970",
      "tr_GR186": "AMD* Radeon* HD 8970M",
      "tr_GR187": "AMD* Radeon* HD 8990",
      "tr_GR188": "AMD* Radeon* HD 9000",
      "tr_GR189": "AMD* Radeon* Pro 450",
      "tr_GR190": "AMD* Radeon* Pro 455",
      "tr_GR191": "AMD* Radeon* Pro 460",
      "tr_GR192": "AMD* Radeon* Pro 465",
      "tr_GR193": "AMD* Radeon* Pro Duo",
      "tr_GR194": "AMD* Radeon* Pro SSG",
      "tr_GR195": "AMD* Radeon* Pro V340",
      "tr_GR196": "AMD* Radeon* Pro V5300X",
      "tr_GR197": "AMD* Radeon* Pro V7300X",
      "tr_GR198": "AMD* Radeon* Pro V7350x2",
      "tr_GR199": "AMD* Radeon* Pro Vega 56",
      "tr_GR200": "AMD* Radeon* Pro VII",
      "tr_GR201": "AMD* Radeon* Pro W5500",
      "tr_GR202": "AMD* Radeon* Pro W5500M",
      "tr_GR203": "AMD* Radeon* Pro W5700",
      "tr_GR204": "AMD* Radeon* Pro W6300",
      "tr_GR205": "AMD* Radeon* Pro W6300M",
      "tr_GR206": "AMD* Radeon* Pro W6400",
      "tr_GR207": "AMD* Radeon* Pro W6500M",
      "tr_GR208": "AMD* Radeon* Pro W6600",
      "tr_GR209": "AMD* Radeon* Pro W6600M",
      "tr_GR210": "AMD* Radeon* Pro W6800",
      "tr_GR211": "AMD* Radeon* Pro W7500",
      "tr_GR212": "AMD* Radeon* Pro W7600",
      "tr_GR213": "AMD* Radeon* Pro W7700",
      "tr_GR214": "AMD* Radeon* Pro W7800",
      "tr_GR215": "AMD* Radeon* Pro W7900",
      "tr_GR216": "AMD* Radeon* Pro WX 2100",
      "tr_GR217": "AMD* Radeon* Pro WX 3100",
      "tr_GR218": "AMD* Radeon* Pro WX 3200",
      "tr_GR219": "AMD* Radeon* Pro WX 4100",
      "tr_GR220": "AMD* Radeon* Pro WX 4150",
      "tr_GR221": "AMD* Radeon* Pro WX 4170",
      "tr_GR222": "AMD* Radeon* Pro WX 5100",
      "tr_GR223": "AMD* Radeon* Pro WX 7100",
      "tr_GR224": "AMD* Radeon* Pro WX 8200",
      "tr_GR225": "AMD* Radeon* Pro WX 9100",
      "tr_GR226": "AMD* Radeon* R5 200",
      "tr_GR227": "AMD* Radeon* R5 220",
      "tr_GR228": "AMD* Radeon* R5 230",
      "tr_GR229": "AMD* Radeon* R5 235",
      "tr_GR230": "AMD* Radeon* R5 240",
      "tr_GR231": "AMD* Radeon* R5 340",
      "tr_GR232": "AMD* Radeon* R5 340X",
      "tr_GR233": "AMD* Radeon* R5 420",
      "tr_GR234": "AMD* Radeon* R5 430",
      "tr_GR235": "AMD* Radeon* R5 430M",
      "tr_GR236": "AMD* Radeon* R5 M200",
      "tr_GR237": "AMD* Radeon* R5 M230",
      "tr_GR238": "AMD* Radeon* R5 M240",
      "tr_GR239": "AMD* Radeon* R5 M255",
      "tr_GR240": "AMD* Radeon* R5 M315",
      "tr_GR241": "AMD* Radeon* R5 M320",
      "tr_GR242": "AMD* Radeon* R5 M330",
      "tr_GR243": "AMD* Radeon* R5 M335",
      "tr_GR244": "AMD* Radeon* R5 M430",
      "tr_GR245": "AMD* Radeon* R5 M435",
      "tr_GR246": "AMD* Radeon* R6 M255DX",
      "tr_GR247": "AMD* Radeon* R6 M335DX",
      "tr_GR248": "AMD* Radeon* R6 M340DX",
      "tr_GR249": "AMD* Radeon* R6 M435DX",
      "tr_GR250": "AMD* Radeon* R7 200",
      "tr_GR251": "AMD* Radeon* R7 240",
      "tr_GR252": "AMD* Radeon* R7 250",
      "tr_GR253": "AMD* Radeon* R7 250X",
      "tr_GR254": "AMD* Radeon* R7 265",
      "tr_GR255": "AMD* Radeon* R7 300",
      "tr_GR256": "AMD* Radeon* R7 340",
      "tr_GR257": "AMD* Radeon* R7 350",
      "tr_GR258": "AMD* Radeon* R7 350X",
      "tr_GR259": "AMD* Radeon* R7 360",
      "tr_GR260": "AMD* Radeon* R7 370",
      "tr_GR261": "AMD* Radeon* R7 430",
      "tr_GR262": "AMD* Radeon* R7 450",
      "tr_GR263": "AMD* Radeon* R7 M260",
      "tr_GR264": "AMD* Radeon* R7 M260DX",
      "tr_GR265": "AMD* Radeon* R7 M265",
      "tr_GR266": "AMD* Radeon* R7 M265DX",
      "tr_GR267": "AMD* Radeon* R7 M340",
      "tr_GR268": "AMD* Radeon* R7 M350",
      "tr_GR269": "AMD* Radeon* R7 M360",
      "tr_GR270": "AMD* Radeon* R7 M370",
      "tr_GR271": "AMD* Radeon* R7 M380",
      "tr_GR272": "AMD* Radeon* R7 M440",
      "tr_GR273": "AMD* Radeon* R7 M460",
      "tr_GR274": "AMD* Radeon* R7 M465",
      "tr_GR275": "AMD* Radeon* R7 M465X",
      "tr_GR276": "AMD* Radeon* R8 M350DX",
      "tr_GR277": "AMD* Radeon* R8 M435DX",
      "tr_GR278": "AMD* Radeon* R8 M535DX",
      "tr_GR279": "AMD* Radeon* R9 200",
      "tr_GR280": "AMD* Radeon* R9 255",
      "tr_GR281": "AMD* Radeon* R9 260",
      "tr_GR282": "AMD* Radeon* R9 270",
      "tr_GR283": "AMD* Radeon* R9 280",
      "tr_GR284": "AMD* Radeon* R9 290",
      "tr_GR285": "AMD* Radeon* R9 290X",
      "tr_GR286": "AMD* Radeon* R9 295X2",
      "tr_GR287": "AMD* Radeon* R9 360",
      "tr_GR288": "AMD* Radeon* R9 370",
      "tr_GR289": "AMD* Radeon* R9 370X",
      "tr_GR290": "AMD* Radeon* R9 380",
      "tr_GR291": "AMD* Radeon* R9 390",
      "tr_GR292": "AMD* Radeon* R9 390X",
      "tr_GR293": "AMD* Radeon* R9 Fury",
      "tr_GR294": "AMD* Radeon* R9 Fury X",
      "tr_GR295": "AMD* Radeon* R9 M200X",
      "tr_GR296": "AMD* Radeon* R9 M275X",
      "tr_GR297": "AMD* Radeon* R9 M280X",
      "tr_GR298": "AMD* Radeon* R9 M360",
      "tr_GR299": "AMD* Radeon* R9 M365X",
      "tr_GR300": "AMD* Radeon* R9 M370X",
      "tr_GR301": "AMD* Radeon* R9 M375",
      "tr_GR302": "AMD* Radeon* R9 M375X",
      "tr_GR303": "AMD* Radeon* R9 M380",
      "tr_GR304": "AMD* Radeon* R9 M385",
      "tr_GR305": "AMD* Radeon* R9 M385X",
      "tr_GR306": "AMD* Radeon* R9 M390X",
      "tr_GR307": "AMD* Radeon* R9 M395X",
      "tr_GR308": "AMD* Radeon* R9 M470X",
      "tr_GR309": "AMD* Radeon* RX 455",
      "tr_GR310": "AMD* Radeon* RX 460",
      "tr_GR311": "AMD* Radeon* RX 470",
      "tr_GR312": "AMD* Radeon* RX 480",
      "tr_GR313": "AMD* Radeon* RX 5300",
      "tr_GR314": "AMD* Radeon* RX 5300M",
      "tr_GR315": "AMD* Radeon* RX 540",
      "tr_GR316": "AMD* Radeon* RX 540X",
      "tr_GR317": "AMD* Radeon* RX 550",
      "tr_GR318": "AMD* Radeon* RX 5500",
      "tr_GR319": "AMD* Radeon* RX 5500 XT",
      "tr_GR320": "AMD* Radeon* RX 5500M",
      "tr_GR321": "AMD* Radeon* RX 550X",
      "tr_GR322": "AMD* Radeon* RX 560",
      "tr_GR323": "AMD* Radeon* RX 560 XT",
      "tr_GR324": "AMD* Radeon* RX 5600",
      "tr_GR325": "AMD*‎ Radeon*‎ RX 5600 OEM",
      "tr_GR326": "AMD* Radeon* RX 5600 XT",
      "tr_GR327": "AMD* Radeon* RX 5600M",
      "tr_GR328": "AMD* Radeon* RX 560X",
      "tr_GR329": "AMD* Radeon* RX 570",
      "tr_GR330": "AMD* Radeon* RX 5700",
      "tr_GR331": "AMD* Radeon* RX 5700 XT",
      "tr_GR332": "AMD* Radeon* RX 5700M",
      "tr_GR333": "AMD* Radeon* RX 570X",
      "tr_GR334": "AMD* Radeon* RX 580",
      "tr_GR335": "AMD* Radeon* RX 580X",
      "tr_GR336": "AMD* Radeon* RX 590",
      "tr_GR337": "AMD* Radeon* RX 590 GME",
      "tr_GR338": "AMD* Radeon* RX 6300",
      "tr_GR339": "AMD* Radeon* RX 6300M",
      "tr_GR340": "AMD* Radeon* RX 640",
      "tr_GR341": "AMD* Radeon* RX 6400",
      "tr_GR342": "AMD* Radeon* RX 6450M",
      "tr_GR343": "AMD* Radeon* RX 6500",
      "tr_GR344": "AMD* Radeon* RX 6500 XT",
      "tr_GR345": "AMD* Radeon* RX 6500M",
      "tr_GR346": "AMD* Radeon* RX 6550M",
      "tr_GR347": "AMD* Radeon* RX 6600",
      "tr_GR348": "AMD* Radeon* RX 6600 LE",
      "tr_GR349": "AMD* Radeon* RX 6600 XT",
      "tr_GR350": "AMD* Radeon* RX 6600M",
      "tr_GR351": "AMD* Radeon* RX 6600S",
      "tr_GR352": "AMD* Radeon* RX 6650 XT",
      "tr_GR353": "AMD* Radeon* RX 6650M",
      "tr_GR354": "AMD* Radeon* RX 6650M XT",
      "tr_GR355": "AMD* Radeon* RX 6700",
      "tr_GR356": "AMD* Radeon* RX 6700 XT",
      "tr_GR357": "AMD* Radeon* RX 6700M",
      "tr_GR358": "AMD* Radeon* RX 6700S",
      "tr_GR359": "AMD* Radeon* RX 6750 GRE",
      "tr_GR360": "AMD* Radeon* RX 6750 XT",
      "tr_GR361": "AMD* Radeon* RX 6800",
      "tr_GR362": "AMD* Radeon* RX 6800 XT",
      "tr_GR363": "AMD* Radeon* RX 6800M",
      "tr_GR364": "AMD* Radeon* RX 6800S",
      "tr_GR365": "AMD* Radeon* RX 6850M XT",
      "tr_GR366": "AMD* Radeon* RX 6900 XT",
      "tr_GR367": "AMD* Radeon* RX 6950 XT",
      "tr_GR368": "AMD* Radeon* RX 7600",
      "tr_GR369": "AMD* Radeon* RX 7600 XT",
      "tr_GR370": "AMD* Radeon* RX 7600M",
      "tr_GR371": "AMD* Radeon* RX 7600M XT",
      "tr_GR372": "AMD* Radeon* RX 7600S",
      "tr_GR373": "AMD* Radeon* RX 7700 XT",
      "tr_GR374": "AMD* Radeon* RX 7700S",
      "tr_GR375": "AMD* Radeon* RX 7800 XT",
      "tr_GR376": "AMD* Radeon* RX 7900 GRE",
      "tr_GR377": "AMD* Radeon* RX 7900 XT",
      "tr_GR378": "AMD* Radeon* RX 7900 XTX",
      "tr_GR379": "AMD* Radeon* RX 7900M",
      "tr_GR380": "AMD* Radeon* RX Vega",
      "tr_GR381": "AMD* Radeon* RX Vega 10",
      "tr_GR382": "AMD* Radeon* RX Vega 11",
      "tr_GR383": "AMD* Radeon* RX Vega 64",
      "tr_GR384": "AMD* Radeon* RX Vega M GH",
      "tr_GR385": "AMD* Radeon* RX Vega M GL",
      "tr_GR386": "رسوميات Intel® Arc™ A310",
      "tr_GR387": "رسوميات Intel® Arc™ A350M",
      "tr_GR388": "رسوميات Intel® Arc™ A370M",
      "tr_GR389": "رسوميات Intel® Arc™ A380",
      "tr_GR390": "رسوميات Intel® Arc™ A530M",
      "tr_GR391": "رسوميات Intel® Arc™ A550M",
      "tr_GR392": "رسوميات Intel® Arc™ A570M",
      "tr_GR393": "رسوميات Intel® Arc™ A580",
      "tr_GR394": "رسوميات Intel® Arc™ A730M",
      "tr_GR395": "رسوميات Intel® Arc™ A750",
      "tr_GR396": "رسوميات Intel® Arc™ A770",
      "tr_GR397": "رسوميات Intel® Arc™ A770M",
      "tr_GR398": "رسوميات Intel®‎ Arc™‎",
      "tr_GR399": "رسوميات Intel® Arc™ Pro A30M",
      "tr_GR400": "رسوميات Intel® Arc™ Pro A40/A50",
      "tr_GR401": "رسوميات Intel® Arc™ Pro A60",
      "tr_GR402": "رسوميات Intel® Arc™ Pro A60M",
      "tr_GR403": "رسوميات Intel®‎",
      "tr_GR404": "رسوميات Intel®‎ HD 2000",
      "tr_GR405": "رسوميات Intel®‎ HD 2500",
      "tr_GR406": "رسوميات Intel®‎ HD 3000",
      "tr_GR407": "رسوميات Intel®‎ HD 400",
      "tr_GR408": "رسوميات Intel®‎ HD 4000",
      "tr_GR409": "رسوميات Intel®‎ HD 405",
      "tr_GR410": "رسوميات Intel®‎ HD 4200",
      "tr_GR411": "رسوميات Intel®‎ HD 4400",
      "tr_GR412": "رسوميات Intel®‎ HD 4600",
      "tr_GR413": "رسوميات Intel®‎ HD 500",
      "tr_GR414": "رسوميات Intel®‎ HD 5000",
      "tr_GR415": "رسوميات Intel®‎ HD 505",
      "tr_GR416": "رسوميات Intel®‎ HD 510",
      "tr_GR417": "رسوميات Intel®‎ HD 515",
      "tr_GR418": "رسوميات Intel®‎ HD 520",
      "tr_GR419": "رسوميات Intel®‎ HD 530",
      "tr_GR420": "رسوميات Intel®‎ HD 5300",
      "tr_GR421": "رسوميات Intel®‎ HD 5500",
      "tr_GR422": "رسوميات Intel®‎ HD 5600",
      "tr_GR423": "رسوميات Intel®‎ HD 6000",
      "tr_GR424": "رسوميات Intel®‎ HD 610",
      "tr_GR425": "رسوميات Intel®‎ HD 615",
      "tr_GR426": "رسوميات Intel®‎ HD 620",
      "tr_GR427": "رسوميات Intel®‎ HD 630",
      "tr_GR428": "رسوميات Intel®‎ HD",
      "tr_GR429": "رسوميات Intel®‎ Iris®‎ 5100",
      "tr_GR430": "رسوميات Intel®‎ Iris®‎ 540",
      "tr_GR431": "رسوميات Intel®‎ Iris®‎ 550",
      "tr_GR432": "رسوميات Intel®‎ Iris®‎ 6100",
      "tr_GR433": "رسوميات Intel®‎ Iris®‎ Plus 640",
      "tr_GR434": "رسوميات Intel®‎ Iris®‎ Plus 645",
      "tr_GR435": "رسوميات Intel®‎ Iris®‎ Plus 650",
      "tr_GR436": "رسوميات Intel®‎ Iris®‎ Plus 655",
      "tr_GR437": "رسوميات Intel®‎ Iris®‎ Plus",
      "tr_GR438": "رسوميات Intel®‎ Iris®‎ Pro 5200",
      "tr_GR439": "رسوميات Intel®‎ Iris®‎ Pro 580",
      "tr_GR440": "رسوميات Intel®‎ Iris®‎ Pro 6200",
      "tr_GR441": "رسوميات Intel®‎ Iris®‎ X<sup>e</sup>",
      "tr_GR442": "رسوميات Intel® Iris® X<sup>e</sup> MAX الفئة A220M",
      "tr_GR443": "رسوميات Intel® Iris® X<sup>e</sup> MAX",
      "tr_GR444": "رسوميات Intel®‎ مضمّنة",
      "tr_GR445": "رسوميات Intel®‎ UHD 600",
      "tr_GR446": "رسوميات Intel®‎ UHD 605",
      "tr_GR447": "رسوميات Intel®‎ UHD 610",
      "tr_GR448": "رسوميات Intel®‎ UHD 615",
      "tr_GR449": "رسوميات Intel®‎ UHD 617",
      "tr_GR450": "رسوميات Intel®‎ UHD 620",
      "tr_GR451": "رسوميات Intel®‎ UHD 630",
      "tr_GR452": "رسوميات Intel®‎ UHD 710",
      "tr_GR453": "رسوميات Intel®‎ UHD 730",
      "tr_GR454": "رسوميات Intel®‎ UHD 770",
      "tr_GR455": "رسوميات Intel®‎ UHD",
      "tr_GR456": "رسوميات Intel®‎ UHD",
      "tr_GR457": "رسوميات Intel®‎ UHD",
      "tr_GR458": "NVIDIA* GeForce* MX110",
      "tr_GR459": "NVIDIA* GeForce* MX130",
      "tr_GR460": "NVIDIA* GeForce* MX150",
      "tr_GR461": "NVIDIA* GeForce* MX230",
      "tr_GR462": "NVIDIA* GeForce* MX250",
      "tr_GR463": "NVIDIA* GeForce* MX330",
      "tr_GR464": "NVIDIA* GeForce* MX350",
      "tr_GR465": "NVIDIA* GeForce* 410M",
      "tr_GR466": "NVIDIA* GeForce* MX450",
      "tr_GR467": "NVIDIA* GeForce* 510",
      "tr_GR468": "NVIDIA* GeForce* MX550",
      "tr_GR469": "NVIDIA* GeForce* MX570",
      "tr_GR470": "NVIDIA* GeForce* MX570 A",
      "tr_GR471": "NVIDIA* GeForce* 605",
      "tr_GR472": "NVIDIA* GeForce* 610",
      "tr_GR473": "NVIDIA* GeForce* 610M",
      "tr_GR474": "NVIDIA* GeForce* 615",
      "tr_GR475": "NVIDIA* GeForce* 620M",
      "tr_GR476": "NVIDIA* GeForce* 705A",
      "tr_GR477": "NVIDIA* GeForce* 705M",
      "tr_GR478": "NVIDIA* GeForce* 710A",
      "tr_GR479": "NVIDIA* GeForce* 710M",
      "tr_GR480": "NVIDIA* GeForce* 720A",
      "tr_GR481": "NVIDIA* GeForce* 720M",
      "tr_GR482": "NVIDIA* GeForce* 730A",
      "tr_GR483": "NVIDIA* GeForce* 800A",
      "tr_GR484": "NVIDIA* GeForce* 800M",
      "tr_GR485": "NVIDIA* GeForce* 805A",
      "tr_GR486": "NVIDIA* GeForce* 810A",
      "tr_GR487": "NVIDIA* GeForce* 810M",
      "tr_GR488": "NVIDIA* GeForce* 820A",
      "tr_GR489": "NVIDIA* GeForce* 820M",
      "tr_GR490": "NVIDIA* GeForce* 825M",
      "tr_GR491": "NVIDIA* GeForce* 830A",
      "tr_GR492": "NVIDIA* GeForce* 830M",
      "tr_GR493": "NVIDIA* GeForce* 840A",
      "tr_GR494": "NVIDIA* GeForce* 840M",
      "tr_GR495": "NVIDIA* GeForce* 845M",
      "tr_GR496": "NVIDIA* GeForce* 910M",
      "tr_GR497": "NVIDIA* GeForce* 920A",
      "tr_GR498": "NVIDIA* GeForce* 920M",
      "tr_GR499": "NVIDIA* GeForce* 920MX",
      "tr_GR500": "NVIDIA* GeForce* 930A",
      "tr_GR501": "NVIDIA* GeForce* 930M",
      "tr_GR502": "NVIDIA* GeForce* 930MX",
      "tr_GR503": "NVIDIA* GeForce* 940A",
      "tr_GR504": "NVIDIA* GeForce* 940M",
      "tr_GR505": "NVIDIA* GeForce* 940MX",
      "tr_GR506": "NVIDIA* GeForce* 945A",
      "tr_GR507": "NVIDIA* GeForce* 945M",
      "tr_GR508": "NVIDIA* GeForce* GT 1010",
      "tr_GR509": "NVIDIA* GeForce* GT 1030",
      "tr_GR510": "NVIDIA* GeForce* GT 415M",
      "tr_GR511": "NVIDIA* GeForce* GT 420",
      "tr_GR512": "NVIDIA* GeForce* GT 420M",
      "tr_GR513": "NVIDIA* GeForce* GT 425M",
      "tr_GR514": "NVIDIA* GeForce* GT 430",
      "tr_GR515": "NVIDIA* GeForce* GT 435M",
      "tr_GR516": "NVIDIA* GeForce* GT 440",
      "tr_GR517": "NVIDIA* GeForce* GT 445M",
      "tr_GR518": "NVIDIA* GeForce* GT 520",
      "tr_GR519": "NVIDIA* GeForce* GT 520M",
      "tr_GR520": "NVIDIA* GeForce* GT 520MX",
      "tr_GR521": "NVIDIA* GeForce* GT 525M",
      "tr_GR522": "NVIDIA* GeForce* GT 530",
      "tr_GR523": "NVIDIA* GeForce* GT 540M",
      "tr_GR524": "NVIDIA* GeForce* GT 545",
      "tr_GR525": "NVIDIA* GeForce* GT 550M",
      "tr_GR526": "NVIDIA* GeForce* GT 555M",
      "tr_GR527": "NVIDIA* GeForce* GT 610",
      "tr_GR528": "NVIDIA* GeForce* GT 620",
      "tr_GR529": "NVIDIA* GeForce* GT 620M",
      "tr_GR530": "NVIDIA* GeForce* GT 625",
      "tr_GR531": "NVIDIA* GeForce* GT 625M",
      "tr_GR532": "NVIDIA* GeForce* GT 630",
      "tr_GR533": "NVIDIA* GeForce* GT 630M",
      "tr_GR534": "NVIDIA* GeForce* GT 635",
      "tr_GR535": "NVIDIA* GeForce* GT 635M",
      "tr_GR536": "NVIDIA* GeForce* GT 640",
      "tr_GR537": "NVIDIA* GeForce* GT 640M",
      "tr_GR538": "NVIDIA* GeForce* GT 640M LE",
      "tr_GR539": "NVIDIA* GeForce* GT 645",
      "tr_GR540": "NVIDIA* GeForce* GT 645M",
      "tr_GR541": "NVIDIA* GeForce* GT 650M",
      "tr_GR542": "NVIDIA* GeForce* GT 705",
      "tr_GR543": "NVIDIA* GeForce* GT 710",
      "tr_GR544": "NVIDIA* GeForce* GT 710M",
      "tr_GR545": "NVIDIA* GeForce* GT 720",
      "tr_GR546": "NVIDIA* GeForce* GT 720A",
      "tr_GR547": "NVIDIA* GeForce* GT 720M",
      "tr_GR548": "NVIDIA* GeForce* GT 730",
      "tr_GR549": "NVIDIA* GeForce* GT 730M",
      "tr_GR550": "NVIDIA* GeForce* GT 735M",
      "tr_GR551": "NVIDIA* GeForce* GT 740",
      "tr_GR552": "NVIDIA* GeForce* GT 740A",
      "tr_GR553": "NVIDIA* GeForce* GT 740M",
      "tr_GR554": "NVIDIA* GeForce* GT 745A",
      "tr_GR555": "NVIDIA* GeForce* GT 745M",
      "tr_GR556": "NVIDIA* GeForce* GT 750M",
      "tr_GR557": "NVIDIA* GeForce* GT 755M",
      "tr_GR558": "NVIDIA* GeForce* GT 820M",
      "tr_GR559": "NVIDIA* GeForce* GTS 450",
      "tr_GR560": "NVIDIA* GeForce* GTX 1050",
      "tr_GR561": "NVIDIA* GeForce* GTX 1050 بتصميم Max-Q",
      "tr_GR562": "NVIDIA* GeForce* GTX 1050 Ti",
      "tr_GR563": "NVIDIA* GeForce* GTX 1050 Ti بتصميم Max-Q",
      "tr_GR564": "NVIDIA* GeForce* GTX 1060",
      "tr_GR565": "NVIDIA* GeForce* GTX 1060 بتصميم Max-Q",
      "tr_GR566": "NVIDIA* GeForce* GTX 1070",
      "tr_GR567": "NVIDIA* GeForce* GTX 1070 بتصميم Max-Q",
      "tr_GR568": "NVIDIA* GeForce* GTX 1070 Ti",
      "tr_GR569": "NVIDIA* GeForce* GTX 1080",
      "tr_GR570": "NVIDIA* GeForce* GTX 1080 بتصميم Max-Q",
      "tr_GR571": "NVIDIA* GeForce* GTX 1080 Ti",
      "tr_GR572": "NVIDIA* GeForce* GTX 1630",
      "tr_GR573": "NVIDIA* GeForce* GTX 1650",
      "tr_GR574": "NVIDIA* GeForce* GTX 1650 بتصميم Max-Q",
      "tr_GR575": "NVIDIA* GeForce* GTX 1650 SUPER",
      "tr_GR576": "NVIDIA* GeForce* GTX 1650 Ti",
      "tr_GR577": "NVIDIA* GeForce* GTX 1650 Ti بتصميم Max-Q",
      "tr_GR578": "NVIDIA* GeForce* GTX 1660",
      "tr_GR579": "NVIDIA* GeForce* GTX 1660 SUPER",
      "tr_GR580": "NVIDIA* GeForce* GTX 1660 Ti",
      "tr_GR581": "NVIDIA* GeForce* GTX 1660 Ti بتصميم Max-Q",
      "tr_GR582": "NVIDIA* GeForce* GTX 460",
      "tr_GR583": "NVIDIA* GeForce* GTX 460 SE",
      "tr_GR584": "NVIDIA* GeForce* GTX 460 v2",
      "tr_GR585": "NVIDIA* GeForce* GTX 460M",
      "tr_GR586": "NVIDIA* GeForce* GTX 465",
      "tr_GR587": "NVIDIA* GeForce* GTX 470",
      "tr_GR588": "NVIDIA* GeForce* GTX 470M",
      "tr_GR589": "NVIDIA* GeForce* GTX 480",
      "tr_GR590": "NVIDIA* GeForce* GTX 480M",
      "tr_GR591": "NVIDIA* GeForce* GTX 485M",
      "tr_GR592": "NVIDIA* GeForce* GTX 550 Ti",
      "tr_GR593": "NVIDIA* GeForce* GTX 555",
      "tr_GR594": "NVIDIA* GeForce* GTX 560",
      "tr_GR595": "NVIDIA* GeForce* GTX 560 SE",
      "tr_GR596": "NVIDIA* GeForce* GTX 560 Ti",
      "tr_GR597": "NVIDIA* GeForce* GTX 560M",
      "tr_GR598": "NVIDIA* GeForce* GTX 570",
      "tr_GR599": "NVIDIA* GeForce* GTX 570M",
      "tr_GR600": "NVIDIA* GeForce* GTX 580",
      "tr_GR601": "NVIDIA* GeForce* GTX 580M",
      "tr_GR602": "NVIDIA* GeForce* GTX 590",
      "tr_GR603": "NVIDIA* GeForce* GTX 645",
      "tr_GR604": "NVIDIA* GeForce* GTX 650",
      "tr_GR605": "NVIDIA* GeForce* GTX 650 Ti",
      "tr_GR606": "NVIDIA* GeForce* GTX 660",
      "tr_GR607": "NVIDIA* GeForce* GTX 660 Ti",
      "tr_GR608": "NVIDIA* GeForce* GTX 660M",
      "tr_GR609": "NVIDIA* GeForce* GTX 670",
      "tr_GR610": "NVIDIA* GeForce* GTX 670M",
      "tr_GR611": "NVIDIA* GeForce* GTX 670MX",
      "tr_GR612": "NVIDIA* GeForce* GTX 675M",
      "tr_GR613": "NVIDIA* GeForce* GTX 675MX",
      "tr_GR614": "NVIDIA* GeForce* GTX 680",
      "tr_GR615": "NVIDIA* GeForce* GTX 680M",
      "tr_GR616": "NVIDIA* GeForce* GTX 680MX",
      "tr_GR617": "NVIDIA* GeForce* GTX 690",
      "tr_GR618": "NVIDIA* GeForce* GTX 745",
      "tr_GR619": "NVIDIA* GeForce* GTX 750",
      "tr_GR620": "NVIDIA* GeForce* GTX 750 Ti",
      "tr_GR621": "NVIDIA* GeForce* GTX 760",
      "tr_GR622": "NVIDIA* GeForce* GTX 760 Ti",
      "tr_GR623": "NVIDIA* GeForce* GTX 760A",
      "tr_GR624": "NVIDIA* GeForce* GTX 760M",
      "tr_GR625": "NVIDIA* GeForce* GTX 765M",
      "tr_GR626": "NVIDIA* GeForce* GTX 770",
      "tr_GR627": "NVIDIA* GeForce* GTX 770M",
      "tr_GR628": "NVIDIA* GeForce* GTX 775M",
      "tr_GR629": "NVIDIA* GeForce* GTX 780",
      "tr_GR630": "NVIDIA* GeForce* GTX 780 Ti",
      "tr_GR631": "NVIDIA* GeForce* GTX 780M",
      "tr_GR632": "NVIDIA* GeForce* GTX 850A",
      "tr_GR633": "NVIDIA* GeForce* GTX 850M",
      "tr_GR634": "NVIDIA* GeForce* GTX 860M",
      "tr_GR635": "NVIDIA* GeForce* GTX 870M",
      "tr_GR636": "NVIDIA* GeForce* GTX 880M",
      "tr_GR637": "NVIDIA* GeForce* GTX 950",
      "tr_GR638": "NVIDIA* GeForce* GTX 950A",
      "tr_GR639": "NVIDIA* GeForce* GTX 950M",
      "tr_GR640": "NVIDIA* GeForce* GTX 960",
      "tr_GR641": "NVIDIA* GeForce* GTX 960A",
      "tr_GR642": "NVIDIA* GeForce* GTX 960M",
      "tr_GR643": "NVIDIA* GeForce* GTX 965M",
      "tr_GR644": "NVIDIA* GeForce* GTX 970",
      "tr_GR645": "NVIDIA* GeForce* GTX 970M",
      "tr_GR646": "NVIDIA* GeForce* GTX 980",
      "tr_GR647": "NVIDIA* GeForce* GTX 980 Ti",
      "tr_GR648": "NVIDIA* GeForce* GTX 980M",
      "tr_GR649": "NVIDIA* GeForce* GTX TITAN",
      "tr_GR650": "NVIDIA* GeForce* GTX TITAN بلون أسود",
      "tr_GR651": "NVIDIA* GeForce* GTX TITAN X",
      "tr_GR652": "NVIDIA* GeForce* GTX TITAN Z",
      "tr_GR653": "NVIDIA* GeForce* RTX 2050",
      "tr_GR654": "NVIDIA* GeForce* RTX 2060",
      "tr_GR655": "NVIDIA* GeForce* RTX 2060 بتصميم Max-Q",
      "tr_GR656": "NVIDIA* GeForce* RTX 2060 SUPER",
      "tr_GR657": "NVIDIA* GeForce* RTX 2070",
      "tr_GR658": "NVIDIA* GeForce* RTX 2070 بتصميم Max-Q",
      "tr_GR659": "NVIDIA* GeForce* RTX 2070 SUPER",
      "tr_GR660": "NVIDIA* GeForce* RTX 2070 Super بتصميم Max-Q",
      "tr_GR661": "NVIDIA* GeForce* RTX 2080",
      "tr_GR662": "NVIDIA* GeForce* RTX 2080 بتصميم Max-Q",
      "tr_GR663": "NVIDIA* GeForce* RTX 2080 SUPER",
      "tr_GR664": "NVIDIA* GeForce* RTX 2080 Super بتصميم Max-Q",
      "tr_GR665": "NVIDIA* GeForce* RTX 2080 Ti",
      "tr_GR666": "NVIDIA* GeForce* RTX 3050",
      "tr_GR667": "NVIDIA* GeForce* RTX 3050 Ti",
      "tr_GR668": "NVIDIA* GeForce* RTX 3060",
      "tr_GR669": "NVIDIA* GeForce* RTX 3060 Ti",
      "tr_GR670": "NVIDIA* GeForce* RTX 3070",
      "tr_GR671": "NVIDIA* GeForce* RTX 3070 Ti",
      "tr_GR672": "NVIDIA* GeForce* RTX 3080",
      "tr_GR673": "NVIDIA* GeForce* RTX 3080 Ti",
      "tr_GR674": "NVIDIA* GeForce* RTX 3090",
      "tr_GR675": "NVIDIA* GeForce* RTX 3090 Ti",
      "tr_GR676": "NVIDIA* GeForce* RTX 4050",
      "tr_GR677": "NVIDIA* GeForce* RTX 4060",
      "tr_GR678": "NVIDIA* GeForce* RTX 4060 Ti",
      "tr_GR679": "NVIDIA* GeForce* RTX 4070",
      "tr_GR680": "NVIDIA* GeForce* RTX 4070 SUPER",
      "tr_GR681": "NVIDIA* GeForce* RTX 4070 Ti",
      "tr_GR682": "NVIDIA* GeForce* RTX 4070 Ti SUPER",
      "tr_GR683": "NVIDIA* GeForce* RTX 4080",
      "tr_GR684": "NVIDIA* GeForce* RTX 4090",
      "tr_GR685": "NVIDIA* GeForce* RTX 4090 D",
      "tr_GR686": "NVIDIA* NVS* 310",
      "tr_GR687": "NVIDIA* NVS* 315",
      "tr_GR688": "NVIDIA* NVS* 4200M",
      "tr_GR689": "NVIDIA* NVS* 510",
      "tr_GR690": "NVIDIA* NVS* 5200M",
      "tr_GR691": "NVIDIA* NVS* 5400M",
      "tr_GR692": "NVIDIA* NVS* 810",
      "tr_GR693": "NVIDIA* Quadro* 410",
      "tr_GR694": "NVIDIA* Quadro* GP100",
      "tr_GR695": "NVIDIA* Quadro* GV100",
      "tr_GR696": "NVIDIA* Quadro* K1000M",
      "tr_GR697": "NVIDIA* Quadro* K1100M",
      "tr_GR698": "NVIDIA* Quadro* K1200",
      "tr_GR699": "NVIDIA* Quadro* K2000",
      "tr_GR700": "NVIDIA* Quadro* K2000D",
      "tr_GR701": "NVIDIA* Quadro* K2000M",
      "tr_GR702": "NVIDIA* Quadro* K2100M",
      "tr_GR703": "NVIDIA* Quadro* K2200",
      "tr_GR704": "NVIDIA* Quadro* K2200M",
      "tr_GR705": "NVIDIA* Quadro* K3000M",
      "tr_GR706": "NVIDIA* Quadro* K3100M",
      "tr_GR707": "NVIDIA* Quadro* K4000",
      "tr_GR708": "NVIDIA* Quadro* K4000M",
      "tr_GR709": "NVIDIA* Quadro* K4100M",
      "tr_GR710": "NVIDIA* Quadro* K420",
      "tr_GR711": "NVIDIA* Quadro* K4200",
      "tr_GR712": "NVIDIA* Quadro* K5000",
      "tr_GR713": "NVIDIA* Quadro* K5000M",
      "tr_GR714": "NVIDIA* Quadro* K500M",
      "tr_GR715": "NVIDIA* Quadro* K5100M",
      "tr_GR716": "NVIDIA* Quadro* K510M",
      "tr_GR717": "NVIDIA* Quadro* K5200",
      "tr_GR718": "NVIDIA* Quadro* K600",
      "tr_GR719": "NVIDIA* Quadro* K6000",
      "tr_GR720": "NVIDIA* Quadro* K610M",
      "tr_GR721": "NVIDIA* Quadro* K620",
      "tr_GR722": "NVIDIA* Quadro* K620M",
      "tr_GR723": "NVIDIA* Quadro* M1000M",
      "tr_GR724": "NVIDIA* Quadro* M1200",
      "tr_GR725": "NVIDIA* Quadro* M2000",
      "tr_GR726": "NVIDIA* Quadro* M2000M",
      "tr_GR727": "NVIDIA* Quadro* M2200",
      "tr_GR728": "NVIDIA* Quadro* M3000M",
      "tr_GR729": "NVIDIA* Quadro* M4000",
      "tr_GR730": "NVIDIA* Quadro* M4000M",
      "tr_GR731": "NVIDIA* Quadro* M5000",
      "tr_GR732": "NVIDIA* Quadro* M5000M",
      "tr_GR733": "NVIDIA* Quadro* M500M",
      "tr_GR734": "NVIDIA* Quadro* M520",
      "tr_GR735": "NVIDIA* Quadro* M5500",
      "tr_GR736": "NVIDIA* Quadro* M6000",
      "tr_GR737": "NVIDIA* Quadro* M600M",
      "tr_GR738": "NVIDIA* Quadro* M620",
      "tr_GR739": "NVIDIA* Quadro* P1000",
      "tr_GR740": "NVIDIA* Quadro* P2000",
      "tr_GR741": "NVIDIA* Quadro* P2000 بتصميم Max-Q",
      "tr_GR742": "NVIDIA* Quadro* P2200",
      "tr_GR743": "NVIDIA* Quadro* P3000",
      "tr_GR744": "NVIDIA* Quadro* P3200",
      "tr_GR745": "NVIDIA* Quadro* P3200 بتصميم Max-Q",
      "tr_GR746": "NVIDIA* Quadro* P400",
      "tr_GR747": "NVIDIA* Quadro* P4000",
      "tr_GR748": "NVIDIA* Quadro* P4000 بتصميم Max-Q",
      "tr_GR749": "NVIDIA* Quadro* P4200",
      "tr_GR750": "NVIDIA* Quadro* P4200 بتصميم Max-Q",
      "tr_GR751": "NVIDIA* Quadro* P500",
      "tr_GR752": "NVIDIA* Quadro* P5000",
      "tr_GR753": "NVIDIA* Quadro* P520",
      "tr_GR754": "NVIDIA* Quadro* P5200",
      "tr_GR755": "NVIDIA* Quadro* P5200 بتصميم Max-Q",
      "tr_GR756": "NVIDIA* Quadro* P600",
      "tr_GR757": "NVIDIA* Quadro* P6000",
      "tr_GR758": "NVIDIA* Quadro* P620",
      "tr_GR759": "NVIDIA* Quadro* RTX 3000",
      "tr_GR760": "NVIDIA* Quadro* RTX 3000 بتصميم Max-Q",
      "tr_GR761": "NVIDIA* Quadro* RTX 4000",
      "tr_GR762": "NVIDIA* Quadro* RTX 4000 بتصميم Max-Q",
      "tr_GR763": "NVIDIA* Quadro* RTX 5000",
      "tr_GR764": "NVIDIA* Quadro* RTX 5000 بتصميم Max-Q",
      "tr_GR765": "NVIDIA* Quadro* RTX 6000",
      "tr_GR766": "NVIDIA* Quadro* RTX 8000",
      "tr_GR767": "NVIDIA* Quadro* T1000",
      "tr_GR768": "NVIDIA* Quadro* T1000 بتصميم Max-Q",
      "tr_GR769": "NVIDIA* Quadro* T2000",
      "tr_GR770": "NVIDIA* Quadro* T2000 بتصميم Max-Q",
      "tr_GR771": "NVIDIA* T500",
      "tr_GR772": "NVIDIA* RTX 2000 جيل Ada",
      "tr_GR773": "NVIDIA* RTX 3000 جيل Ada",
      "tr_GR774": "NVIDIA* RTX 3500 جيل Ada",
      "tr_GR775": "NVIDIA* RTX 4000 جيل Ada",
      "tr_GR776": "NVIDIA* RTX 4000 SFF جيل Ada",
      "tr_GR777": "NVIDIA* RTX 4500 جيل Ada",
      "tr_GR778": "NVIDIA* RTX 5000 جيل Ada",
      "tr_GR779": "NVIDIA* RTX 5880 جيل Ada",
      "tr_GR780": "NVIDIA* Tesla* C2050 / C2070",
      "tr_GR781": "NVIDIA* Tesla* C2070",
      "tr_GR782": "NVIDIA* Tesla* C2075",
      "tr_GR783": "NVIDIA* Tesla* K10",
      "tr_GR784": "NVIDIA* Tesla* K20c",
      "tr_GR785": "NVIDIA* Tesla* K20m",
      "tr_GR786": "NVIDIA* Tesla* K20s",
      "tr_GR787": "NVIDIA* Tesla* K20Xm",
      "tr_GR788": "NVIDIA* Tesla* K40c",
      "tr_GR789": "NVIDIA* Tesla* K40m",
      "tr_GR790": "NVIDIA* Tesla* K40s",
      "tr_GR791": "NVIDIA* Tesla* K40st",
      "tr_GR792": "NVIDIA* Tesla* K40t",
      "tr_GR793": "NVIDIA* Tesla* K8",
      "tr_GR794": "NVIDIA* Tesla* K80",
      "tr_GR795": "NVIDIA* Tesla* M2050",
      "tr_GR796": "NVIDIA* Tesla* M2070",
      "tr_GR797": "NVIDIA* Tesla* M2070-Q",
      "tr_GR798": "NVIDIA* Tesla* M2075",
      "tr_GR799": "NVIDIA* Tesla* M2090",
      "tr_GR800": "NVIDIA* Tesla* S2050",
      "tr_GR801": "NVIDIA* Tesla* T20",
      "tr_GR802": "NVIDIA* Tesla* T4",
      "tr_GR803": "NVIDIA* Tesla* X2070",
      "tr_GR804": "NVIDIA* Tesla* X2090",
      "tr_GR805": "NVIDIA* TITAN RTX",
      "tr_GR806": "NVIDIA* TITAN V",
      "tr_GR807": "NVIDIA* TITAN X",
      "tr_GR808": "NVIDIA* TITAN Xp",
      "tr_GR809": "NVIDIA* GeForce* RTX 4080 SUPER",
      "tr_GR810": "NVIDIA* RTX 500 جيل Ada",
      "tr_GR811": "NVIDIA* RTX 1000 جيل Ada",
      "tr_GR812": "رسوميات Intel®‎ Arc™‎",
      "tr_GR813": "NVIDIA* GeForce* RTX 3050 A",
      "tr_GR814": "NVIDIA RTX* 2000E جيل Ada",
      "tr_GR815": "AMD Radeon* Pro W7900 ذو الفتحة المزدوجة",
      "tr_GR816": "AMD Radeon* RX 7800M",
      "tr_GR817": "رسوميات Intel® Arc™ B570",
      "tr_GR818": "رسوميات Intel® Arc™ B580",
      "tr_GR819": "رسوميات Intel® Arc™ A310E",
      "tr_GR820": "رسوميات Intel® Arc™ A350E",
      "tr_GR821": "رسوميات Intel® Arc™ A370E",
      "tr_GR822": "رسوميات Intel® Arc™ A380E",
      "tr_GR823": "رسوميات Intel® Arc™ A580E",
      "tr_GR824": "رسوميات Intel® Arc™ A750E",
      "tr_GR825": "رسوميات Intel® Iris® X<sup>e</sup> MAX 101",
      "tr_GR826": "رسوميات Intel® UHD 750",
      "tr_GR827": "NVIDIA* GeForce* RTX 5080",
      "tr_GR828": "NVIDIA* GeForce* RTX 5090",
      "tr_GR829": "NVIDIA* GeForce* RTX 5090 D",
      "tr_GR830": "AMD Radeon* RX 7650 GRE",
      "tr_GR831": "AMD Radeon* RX 9070",
      "tr_GR832": "AMD Radeon* RX 9070 XT",
      "tr_GR833": "NVIDIA* GeForce* RTX 5070",
      "tr_GR834": "NVIDIA* GeForce* RTX 5070 Ti",
      "tr_GR835": "رسوميات Intel® Arc™ B390"
    },
    "tr_ProcessorDescriptionMapping": {
      "tr_Proc1": "معالج Intel® Core™ Ultra 5 225",
      "tr_Proc2": "معالج Intel® Core™ Ultra 5 225F",
      "tr_Proc3": "معالج Intel® Core™ Ultra 5 225H",
      "tr_Proc4": "معالج Intel® Core™ Ultra 5 225T",
      "tr_Proc5": "معالج Intel® Core™ Ultra 5 225U",
      "tr_Proc6": "معالج Intel® Core™ Ultra 5 235",
      "tr_Proc7": "معالج Intel® Core™ Ultra 5 235H",
      "tr_Proc8": "معالج Intel® Core™ Ultra 5 235HX",
      "tr_Proc9": "معالج Intel®‎ Core™ Ultra 5 235T",
      "tr_Proc10": "معالج Intel® Core™ Ultra 5 235U",
      "tr_Proc11": "معالج Intel® Core™ Ultra 5 245",
      "tr_Proc12": "معالج Intel® Core™ Ultra 5 245HX",
      "tr_Proc13": "معالج Intel®‎ Core™ Ultra 5 245T",
      "tr_Proc14": "معالج Intel®‎ Core™‎ Ultra 7 255H",
      "tr_Proc15": "معالج Intel® Core™ Ultra 7 255HX",
      "tr_Proc16": "معالج Intel® Core™ Ultra 7 255U",
      "tr_Proc17": "معالج Intel®‎ Core™‎ Ultra 7 265",
      "tr_Proc18": "معالج Intel®‎ Core™ Ultra 7 265F",
      "tr_Proc19": "معالج Intel®‎ Core™‎ Ultra 7 265H",
      "tr_Proc20": "معالج Intel® Core™ Ultra 7 265HX",
      "tr_Proc21": "معالج Intel®‎ Core™ Ultra 7 265T",
      "tr_Proc22": "معالج Intel® Core™ Ultra 7 265U",
      "tr_Proc23": "معالج Intel®‎ Core™‎ Ultra 9 275HX",
      "tr_Proc24": "معالج Intel® Core™ Ultra 9 285",
      "tr_Proc25": "معالج Intel®‎ Core™‎ Ultra 9 285H",
      "tr_Proc26": "معالج Intel®‎ Core™‎ Ultra 9 285HX",
      "tr_Proc27": "معالج Intel®‎ Core™ Ultra 9 285T",
      "tr_Proc28": "معالج Intel® Core™ Ultra 5 245K",
      "tr_Proc29": "معالج Intel® Core™ Ultra 5 245KF",
      "tr_Proc30": "معالج Intel® Core™ Ultra 7 265K",
      "tr_Proc31": "معالج Intel® Core™ Ultra 7 265KF",
      "tr_Proc32": "معالج Intel®‎ Core™‎ Ultra 9 285K",
      "tr_Proc33": "معالج Intel® Core™ Ultra 5 226V",
      "tr_Proc34": "معالج Intel® Core™ Ultra 5 228V",
      "tr_Proc35": "معالج Intel® Core™ Ultra 5 236V",
      "tr_Proc36": "معالج Intel® Core™ Ultra 5 238V",
      "tr_Proc37": "معالج Intel®‎ Core™ Ultra 7 256V",
      "tr_Proc38": "معالج Intel®‎ Core™ Ultra 7 258V",
      "tr_Proc39": "معالج Intel®‎ Core™ Ultra 7 266V",
      "tr_Proc40": "معالج Intel® Core™ Ultra 7 268V",
      "tr_Proc41": "معالج Intel® Core™ Ultra 9 288V",
      "tr_Proc42": "معالج Intel® Core™ Ultra 7 105UL",
      "tr_Proc43": "معالج Intel®‎ Core™ Ultra 5 125HL",
      "tr_Proc44": "معالج Intel®‎ Core™ Ultra 5 125UL",
      "tr_Proc45": "معالج Intel®‎ Core™ Ultra 5 135HL",
      "tr_Proc46": "معالج Intel®‎ Core™ Ultra 5 135UL",
      "tr_Proc47": "معالج Intel®‎ Core™ Ultra 7 155HL",
      "tr_Proc48": "معالج Intel®‎ Core™ Ultra 7 155UL",
      "tr_Proc49": "معالج Intel®‎ Core™ Ultra 7 165HL",
      "tr_Proc50": "معالج Intel®‎ Core™ Ultra 7 165UL",
      "tr_Proc51": "معالج Intel®‎ Core™ Ultra 5 125H",
      "tr_Proc52": "معالج Intel® Core™ Ultra 5 125U",
      "tr_Proc53": "معالج Intel®‎ Core™ Ultra 5 134U",
      "tr_Proc54": "معالج Intel®‎ Core™ Ultra 5 135H",
      "tr_Proc55": "معالج Intel® Core™ Ultra 5 135U",
      "tr_Proc56": "معالج Intel®‎ Core™‎ Ultra 7 155H",
      "tr_Proc57": "معالج Intel®‎ Core™ Ultra 7 155U",
      "tr_Proc58": "معالج Intel®‎ Core™ Ultra 7 164U",
      "tr_Proc59": "معالج Intel®‎ Core™‎ Ultra 7 165H",
      "tr_Proc60": "معالج Intel®‎ Core™ Ultra 7 165U",
      "tr_Proc61": "معالج Intel®‎ Core™ Ultra 9 185H",
      "tr_Proc62": "معالج Intel® Core™ Ultra 5 250K",
      "tr_Proc63": "معالج Intel® Core™ Ultra 5 250KF",
      "tr_Proc64": "معالج Intel® Core™ Ultra 7 270K",
      "tr_Proc65": "معالج Intel®‎ Core™ Ultra 9 290K",
      "tr_Proc66": "معالج Intel® Core™ Ultra 5 322",
      "tr_Proc67": "معالج Intel® Core™ Ultra 5 325",
      "tr_Proc68": "معالج Intel® Core™ Ultra 5 332",
      "tr_Proc69": "معالج Intel® Core™ Ultra 5 335",
      "tr_Proc70": "معالج Intel® Core™ Ultra 5 336H",
      "tr_Proc71": "معالج Intel® Core™ Ultra 5 338H",
      "tr_Proc72": "معالج Intel® Core™ Ultra 7 355",
      "tr_Proc73": "معالج Intel® Core™ Ultra 7 356H",
      "tr_Proc74": "معالج Intel® Core™ Ultra 7 365",
      "tr_Proc75": "معالج Intel® Core™ Ultra 7 366H",
      "tr_Proc76": "معالج Intel®‎ Core™ Ultra 9 386H",
      "tr_Proc77": "معالج Intel® Core™ Ultra X7 358H",
      "tr_Proc78": "معالج Intel® Core™ Ultra X7 368H",
      "tr_Proc79": "معالج Intel®‎ Core™ Ultra X9 388H"
    },
    "tr_WifiDescMapping": {
      "tr_Wifi1": "Intel® Centrino® Advanced-N 6200 ABG",
      "tr_Wifi2": "Intel® Centrino® Advanced-N 6200 AGN",
      "tr_Wifi3": "Intel® Centrino® Advanced-N 6200 BG",
      "tr_Wifi4": "Intel® Centrino® Advanced-N 6205",
      "tr_Wifi5": "Intel® Centrino® Advanced-N 6230",
      "tr_Wifi6": "Intel® Centrino® Advanced-N 6235",
      "tr_Wifi7": "Intel® Centrino® Advanced-N 6250 ABG",
      "tr_Wifi8": "Intel® Centrino® Advanced-N 6250 AGN",
      "tr_Wifi9": "Intel® Centrino® Ultimate-N 6300 AGN",
      "tr_Wifi10": "Intel® Centrino® Wireless-N 100",
      "tr_Wifi11": "Intel® Centrino® Wireless-N 1000",
      "tr_Wifi12": "Intel® Centrino® Wireless-N 1030",
      "tr_Wifi13": "Intel® Centrino® Wireless-N 105",
      "tr_Wifi14": "Intel® Centrino® Wireless-N 135",
      "tr_Wifi15": "Intel® Centrino® Wireless-N 2200",
      "tr_Wifi16": "Intel® Centrino® Wireless-N 2230",
      "tr_Wifi17": "Intel® Centrino® Wireless-N WiMAX 6150",
      "tr_Wifi18": "Intel® Dual Band Wireless-AC 3160",
      "tr_Wifi19": "Intel® Dual Band Wireless-AC 3165",
      "tr_Wifi20": "Intel® Dual Band Wireless-AC 7260",
      "tr_Wifi21": "Intel® Dual Band Wireless-AC 7265",
      "tr_Wifi22": "Intel® Dual Band Wireless-N 3160",
      "tr_Wifi23": "Intel® Dual Band Wireless-N 7260",
      "tr_Wifi24": "Intel® Dual Band Wireless-N 7265",
      "tr_Wifi25": "Intel® Tri-Band Wireless-AC 17261",
      "tr_Wifi26": "Intel® Wi-Fi 6 AX101",
      "tr_Wifi27": "Intel® Wi-Fi 6 AX200",
      "tr_Wifi28": "Intel® Wi-Fi 6 AX201",
      "tr_Wifi29": "Intel® Wi-Fi 6 AX203",
      "tr_Wifi30": "Intel® Wi-Fi 6E AX210",
      "tr_Wifi31": "Intel® Wi-Fi 6E AX211",
      "tr_Wifi32": "Intel® Wi-Fi 6E AX411",
      "tr_Wifi33": "Intel® Wi-Fi 7 BE200",
      "tr_Wifi34": "Intel® Wi-Fi 7 BE202",
      "tr_Wifi35": "Intel® Wireless-AC 3165",
      "tr_Wifi36": "Intel® Wireless-AC 3168",
      "tr_Wifi37": "Intel® Wireless-AC 8265",
      "tr_Wifi38": "Intel® Wireless-AC 9260",
      "tr_Wifi39": "Intel® Wireless-AC 9461",
      "tr_Wifi40": "Intel® Wireless-AC 9462",
      "tr_Wifi41": "Intel® Wireless-AC 9560",
      "tr_Wifi42": "Intel® Wireless-N 3160",
      "tr_Wifi43": "Intel® Wireless-N 7260",
      "tr_Wifi44": "Intel® Wireless-N 7265",
      "tr_Wifi45": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi46": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi47": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi48": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi49": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi50": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi51": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi52": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi53": "Intel® Killer™ Wi-Fi 6E AX1690",
      "tr_Wifi54": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi55": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi56": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi57": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi58": "Intel® Wi-Fi 7 BE201",
      "tr_Wifi59": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi60": "Intel® Killer™ Wi-Fi 7 BE1750"
    },
    "tr_textBuyNow": "الشراء الآن",
    "tr_textTryagain": "المحاولة من جديد",
    "tr_textBuynowErr": "بسبب انقطاع الاتصال، لا يتوافر خيار \"الشراء الآن\"",
    "tr_chatbotPlaceholder_text": "اسألني أي شيء عن الجهاز",
    "tr_chatbotPlaceholder_gaming_text": "اسأل عن أي شيء عن الجهاز بمساعدة الذكاء الاصطناعي",
    "tr_deviceSpecs_text": "مواصفات الجهاز",
    "tr_laptop": "أجهزة الكمبيوتر المحمول",
    "tr_desktop": "أجهزة سطح المكتب",
    "tr_back": "رجوع",
    "tr_HomePageNavigation": {
      "tr_overview": "لمحة عامة",
      "tr_specs": "المواصفات",
      "tr_virtualAssistant": "المساعد الافتراضي",
      "tr_promos": "العروض الترويجية",
      "tr_compareDevices": "مقارنة الأجهزة"
    },
    "tr_compareText": "مقارنة هذا الجهاز",
    "tr_PTLHomePageText": "انطلاقتك القادمة تبدأ من هنا",
    "tr_PTL12XEHomePageText": "تصميم فائق النحافة وعالي الأداء",
    "tr_OnboardingText": {
      "tr_welcome": "مرحبًا",
      "tr_start_text": "من أين تود أن تبدأ؟",
      "tr_tabs": [
        {
          "tr_tab_heading": "لمحة عامة",
          "tr_tab_subheading": "اكتشف ما يمكن لهذا الجهاز القيام به."
        },
        {
          "tr_tab_heading": "المواصفات",
          "tr_tab_subheading": "استكشف الميزات والمكونات."
        },
        {
          "tr_tab_heading": "العروض الموسمية والترويجية",
          "tr_tab_subheading": "اعثر على أحدث الصفقات والعروض."
        },
        {
          "tr_tab_heading": "المقارنة",
          "tr_tab_subheading": "قارن الأجهزة جنبًا إلى جنب."
        },
        {
          "tr_tab_heading": "المساعد الافتراضي",
          "tr_tab_subheading": "احصل على إجابات بمساعدة الذكاء الاصطناعي."
        }
      ],
      "ptl_right_arrow_icon": "assets/images/ptl_right_chevron.svg",
      "ptl_12xe_right_arrow_icon": "assets/images/ptl_12xe_right_chevron.svg",
      "ptl_intel_logo": "assets/images/ptl_intel_logo.svg",
      "ptl_12xe_intel_logo": "assets/images/ptl_12xe_intel_logo.svg"
    },
    "tr_VAHomepageText": {
      "tr_VAHeading": "أهلًا بك!",
      "tr_VASubHeading": "دردشة مع مساعد الذكاء الاصطناعي لدينا",
      "tr_VAInputboxQuestion": "اسألني عن هذا الجهاز",
      "ptl_VASearchSendIcon": "assets/images/ptl_va_search_send.png",
      "ptl12xe_VASearchSendIcon": "assets/images/ptl12xe_va_search_send.png",
      "ptl_homePage_icon": "assets/images/ptl_homepage_icon.gif",
      "ptl_12xe_homePage_icon": "assets/images/ptl12xe_homepage_icon.gif"
    }
  },
  "backgroundMedia": [
    {
      "uiType": "S11",
      "backgroundURL": "url(../assets/images/11th_gen_background.png)"
    },
    {
      "uiType": "G11",
      "backgroundURL": "url(../assets/images/gaming_background.png)"
    },
    {
      "uiType": "evo",
      "backgroundURL": "url(../assets/images/evo_background.png)"
    },
    {
      "uiType": "athena",
      "backgroundURL": "url(../assets/images/mobile-tiles-athena-background.jpg)"
    },
    {
      "uiType": "NI",
      "backgroundURL": "url(../assets/images/ni_background.png)"
    },
    {
      "uiType": "S10",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S8_9",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S7",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "G12",
      "backgroundURL": "url(../assets/images/12th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "default",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S12",
      "backgroundURL": "url(../assets/images/12th_gen_bg.svg)"
    },
    {
      "uiType": "G13",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "INTEL_INSIDE",
      "backgroundURL": "url(../assets/images/intel_inside/intel_inside_bg.png)"
    },
    {
      "uiType": "G14",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "S14_AI_IPOS",
      "backgroundURL": "url(../assets/images/standard/std_mtl_background.svg)"
    },
    {
      "uiType": "EVO_AI_IPOS",
      "backgroundURL": "url(../assets/images/evo/evo_mtl_background.svg)"
    },
    {
      "uiType": "GAMING_AI_IPOS",
      "backgroundURL": "url(../assets/images/gaming_ai_ipos_background.svg)"
    }
  ],
  "hybridDetails": [
    {
      "badgeTitle": "I3_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I3_HYBRID.svg",
      "tr_gen_core_title": "معالج Intel®‎ Core™‎ i3 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
    },
    {
      "badgeTitle": "I5_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I5_HYBRID.svg",
      "tr_gen_core_title": "معالج Intel®‎ Core™‎ i5 مزود بتقنية Intel®‎&nbsp;Hybrid Technology"
    },
    {
      "badgeTitle": "I7_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I7_HYBRID.svg"
    }
  ],
  "tiles": [
    {
      "tilesType": "GAMING",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Marvel's Avengers",
              "tileUrlName": "avengers",
              "tileBadgeUrl": "assets/images/gaming/avengers-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "جهّز عتادك مع Intel®‎ لتجربة ألعاب أقوى",
                "tr_subtitle": "جعل Marvel’s Avengers*‎ تنبض بالحياة من خلال تحسينات أجهزة الكمبيوتر داخل اللعبة، والمدعومة من Intel®‎.",
                "videoUrl": "assets/lang/[XX]/gaming/videos/avengers_[XX].mp4",
                "videoPosterUrl": "assets/images/gaming/avengers-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "استمتع بتجربة Intel® Extreme Masters",
              "tileUrlName": "esl",
              "tileBadgeUrl": "assets/images/gaming/esl-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "حيث يأتي أفضل اللاعبين في العالم للمنافسة",
                "tr_subtitle": "لأنها أطول سلسلة أحداث في تاريخ ألعاب الفيديو، تضع Intel®‎ Extreme Masters معايير الرياضات الإلكترونية e-sports.",
                "videoUrl": "assets/videos/gaming/esl_video.mp4",
                "videoPosterUrl": "assets/images/gaming/esl-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "العب كالمحترفين",
              "tileUrlName": "influencer",
              "tileBadgeUrl": "assets/images/gaming/influencer-tile-new-content.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "إنتل تصنع الأبطال.",
                "tr_subtitle": "بعد الفوز ببطولة دوري 2021 Rainbow Six Siege*‎ لأمريكا الشمالية، يراجع فريق \"Soniqs\" تاريخه في تشغيل الألعاب ومستقبل الرياضات الإلكترونية وشراكته مع إنتل.",
                "tr_pretitle": "مع \"Soniqs\"",
                "videoUrl": "assets/videos/gaming/influencer-new-video.mp4",
                "videoPosterUrl": "assets/images/gaming/influencer-new-vdo-thumbnail.svg",
                "subtitleUrl": "assets/subtitles/gaming/intel_soniq_influencer/Intel_Soniq_Influencer_022822.[XX].vtt"
              }
            },
            {
              "tr_tileTitle": "جاهز لاستخدام الواقع الافتراضي",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "حيث يصبح الواقع الافتراضي حقيقة",
                "tr_subtitle": "يقدم الكمبيوتر تجارب الواقع الافتراضي الأروع والأكثر وضوحاً واستثنائية. بفضل أحدث معالجات Intel®‎ Core™‎، أصبح بإمكانك أن تكون الشخصية التي تريدها وتتوجه إلى أي مكان تختاره وتخوض تجربة تشغيل الألعاب في البُعد التالي.",
                "videoUrl": "assets/videos/gaming/vr_video.mp4",
                "videoPosterUrl": "assets/images/gaming/vr-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "خدمة Xbox* Game Pass Ultimate",
              "tileUrlName": "xboxcontent",
              "tileBadgeUrl": "assets/images/gaming/xboxTile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "xbox-content-tile-panel",
                "tr_title": "خدمة Xbox* Game Pass Ultimate",
                "tr_subtitle": "يمكنك تشغيل ما يزيد عن 100 لعبة من ألعاب المنصات عالية الجودة، مثل Sea of Thieves*‎ وPsychonauts* 2 على الكمبيوتر الشخصي الذي يعمل بنظام Windows*‎ والهاتف المحمول والكمبيوتر اللوحي باستخدام خدمة Xbox* Game Pass Ultimate ووحدة تحكم متوافقة.",
                "titleArray": [
                  {
                    "tr_title": "اللعب معًا عبر الأجهزة",
                    "tr_subtitle": "ادخل إلى قلب ألعاب Xbox*‎ مع مجتمع من ملايين اللاعبين المستعدين والمنتظرين للّعب معًا. تواصل مع آخرين والعب معهم من مكتبة ألعاب مشتركة سواء كانوا في الجانب الآخر من العالم أو بجوارك مباشرة."
                  },
                  {
                    "tr_title": "تشغيل الألعاب على الكمبيوتر الشخصي الذي يعمل بنظام Windows*‎",
                    "tr_subtitle": "قم بتشغيل كتالوج ألعاب المنصات من الخدمة السحابية باستخدام تطبيق Xbox*‎ على نظام Windows*‎ ووحدة تحكم متوافقة."
                  },
                  {
                    "tr_title": "اختر والعب",
                    "tr_subtitle": "استمتع بتشغيل ألعاب Xbox*‎ الرائعة في أماكن أكثر مما سبق. يمكنك لعب ما يزيد عن 100 لعبة على الكمبيوتر الشخصي والهاتف المحمول والكمبيوتر اللوحي لديك سواء كنت بالمنزل أثناء استخدام جهاز التلفزيون أو في المقهى أو أي مكان آخر مزود باتصال إنترنت عالي السرعة."
                  },
                  {
                    "tr_title": "متعة خالية من وحدة التحكم",
                    "tr_subtitle": "تشغيل ألعاب Xbox*‎ بالتحكم اللمسي يترتب عليه خلق طرق جديدة للقفز واللعب من شأنها توفير تجربة مألوفة ودعم مستوى من اللعب اعتدت عليه باستخدام وحدة تحكم فعلية."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD",
      "tilesDeviceTypes": [
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "الإضاءة",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أكثر من 100 تجربة ذكاء اصطناعي",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience.mp4"
                  },
                  {
                    "tr_title": "تحكم أكبر مع لمس أقل",
                    "preTitle": "",
                    "detailPageName": "controlmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/controlmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/controlmore.mp4"
                  },
                  {
                    "tr_title": "ابقَ داخل إطار الصورة، على أي وضع كنت",
                    "preTitle": "",
                    "detailPageName": "stayinframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/stayinframe-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/stayinframe.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإبداع",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "صحح إضاءتك كالمحترفين",
                    "preTitle": "",
                    "detailPageName": "lighting",
                    "tileBadgeUrl": "assets/images/standard/redesign/lighting-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/lighting.mp4"
                  },
                  {
                    "tr_title": "أضف تأثيرات مذهلة بمنتهى السهولة",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/effects-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/effects.mp4"
                  },
                  {
                    "tr_title": "أعد مزج الأغاني بقوة الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "remix",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإنتاجية",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "عزز إنتاجيتك وخصوصيتك",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "اقضِ مزيدًا من الوقت دون التوصيل بمقبس الطاقة",
                    "preTitle": "",
                    "detailPageName": "spentmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spentmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/spentmore.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الترفيه",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "تدفق سلس، حتى عند عدم التوصيل بمقبس الطاقة",
                    "preTitle": "",
                    "detailPageName": "smoothstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smooth-streaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smooth-streaming.mp4"
                  },
                  {
                    "tr_title": "استمتع بتجربة لعب سريعة تأسر حواسك",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_7_9",
          "tilesDetails": [
            {
              "tr_tileTitle": "الإضاءة",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أكثر من 100 تجربة ذكاء اصطناعي",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile7.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience7.mp4"
                  },
                  {
                    "tr_title": "اجعل أغانيك المفضلة وكأنها من إنشائك حقًا",
                    "preTitle": "",
                    "detailPageName": "favouritesongs",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  },
                  {
                    "tr_title": "حوّل رؤيتك إلى واقع ملموس في الحال",
                    "preTitle": "",
                    "detailPageName": "realtime",
                    "tileBadgeUrl": "assets/images/standard/redesign/real-time-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/realtime.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإبداع",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أسرع طريقة لتحصل على نسختك النهائية",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastestway.mp4"
                  },
                  {
                    "tr_title": "اجعل كل صورة مثالية",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/pictureperfect-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/pictureperfect.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإنتاجية",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "عزز إنتاجيتك وخصوصيتك",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "كفاءة أعلى. حرية أكبر.",
                    "preTitle": "",
                    "detailPageName": "morefreedom",
                    "tileBadgeUrl": "assets/images/standard/redesign/morefreedom-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/morefreedom.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الترفيه",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "تدفق سلس وعالي الدقة، حتى عند عدم التوصيل بمقبس الطاقة",
                    "preTitle": "",
                    "detailPageName": "smoothHDstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smoothHDstreaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smoothHDstreaming.mp4"
                  },
                  {
                    "tr_title": "استمتع بتجربة لعب تأسر حواسك في مزيد من الأماكن",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "إبداع أكثر",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أصبح تحرير الصور أمرًا سهلًا",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "أنشئ صورًا مذهلةً في ثوانٍ معدودة",
                    "preTitle": "",
                    "detailPageName": "createframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/create_frame_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/create_frame.mp4"
                  },
                  {
                    "tr_title": "أنت تكتب. والذكاء الاصطناعي ينفذ.",
                    "preTitle": "",
                    "detailPageName": "youtypeit",
                    "tileBadgeUrl": "assets/images/standard/redesign/you_type_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/you_type.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "مستوى أعلى من الأداء",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "مستويات جديدة من الأداء لتجربة ألعاب أكثر سلاسة",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "اقضِ مزيدًا من الوقت دون التوصيل بمقبس الطاقة",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "انغماس فائق",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "إنتاجية أكثر",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "رفيقك الدائم لإمكانات الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "مكالمات فيديو مثالية",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "أمان أكثر",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أدوات حماية مدمجة تساعدك على حفظ بياناتك بمزيد من الأمان والخصوصية",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "إبداع أكثر",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أصبح تحرير الصور أمرًا سهلًا",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "الذكاء الاصطناعي. طريقك المختصر للوصول إلى المونتاج النهائي.",
                    "preTitle": "",
                    "detailPageName": "aishortcut",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_shortcut_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_shortcut.mp4"
                  },
                  {
                    "tr_title": "عرض سريع لكلمات أغنياتك المفضلة",
                    "preTitle": "",
                    "detailPageName": "favouritesong",
                    "tileBadgeUrl": "assets/images/standard/redesign/favourite_song_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/favourite_song.mp4"
                  },
                  {
                    "tr_title": "وفّر ساعات من المونتاچ باستخدام الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "savehours",
                    "tileBadgeUrl": "assets/images/standard/redesign/save_hours_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/save_hours.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "مستوى أعلى من الأداء",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "مستويات جديدة من الأداء لتجربة ألعاب أكثر سلاسة",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "اقضِ مزيدًا من الوقت دون التوصيل بمقبس الطاقة",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "انغماس فائق",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "إنتاجية أكثر",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "رفيقك الدائم لإمكانات الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "مكالمات فيديو مثالية",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "أمان أكثر",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "أدوات حماية مدمجة تساعدك على حفظ بياناتك بمزيد من الأمان والخصوصية",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "كل وسائل الترفيه الخاصة بك. كمبيوتر واحد.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "لكمبيوتر يعمل أيضًا كمركز ترفيه، أنت بحاجة إلى مساحة تخزين كافية لكل الأغاني ومقاطع الفيديو والألعاب المفضلة لديك والمزيج المناسب بين المعالج والشاشة لإنشاء مرئيات غامرة. إن هذا الكمبيوتر مزود بالمكونات الثلاثة.",
                "titleArray": [
                  {
                    "tr_title": "جاهز للجيل التالي من المرئيات",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "سلاسة في تشغيل الألعاب والبث التدفقي",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ارفع مستوى إنتاجيتك. من أي مكان.",
              "tr_tileTitle1": "أنجز المزيد من المهام. بسرعة.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءاً من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر أيضاً نوع تقنية Wi&#8209;Fi الذي يسمح لك بالبقاء متصلاً بالإنترنت بالإضافة إلى بطارية مناسبة لإبقائك منفصلاً عن التيار الكهربائي.",
                "tr_subtitle1": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة والأداء ليساعدك في إنجاز المزيد من المهام في وقت أقل. فبفضل تقنية Wi-Fi الفائقة السرعة والمعالج القوي ذي السرعة المعززة بتوافر ذاكرة واسعة، ستصبح مهامك اليومية بغاية البساطة.",
                "tr_subtitle2": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءًا من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر نوع تقنية Wi‑Fi الذي يسمح لك بالبقاء متصلًا بالإنترنت بالإضافة إلى ذاكرة مناسبة لإنجاز المهام المتعددة.",
                "titleArray": [
                  {
                    "tr_title": "مصممة لإنجاز المزيد",
                    "tr_title1": "أداء ذكي مهم",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "أفضل اتصالات في فئتها",
                    "tr_title1": "اتصل بالأمور المهمة",
                    "tr_title2": "تحسّن كبير في Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "فترة أطول من دون التوصيل بالكهرباء",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "تنقل بين البرامج كالمحترفين",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "حرية الإنشاء",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يُعدّ إنشاء المحتوى أكثر المهام تطلباً على كمبيوترك. ولحسن الحظ، تتمتع هذه المكونات بالقوة الكافية لتبسيط عملية الإنشاء.",
                "titleArray": [
                  {
                    "tr_title": "طريقة أذكى للإنشاء",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "لتنبض صورك بالحياة",
                    "tr_title1": "هيا ننشئ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "ذاكرة لتعددية المهام",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ألقِ نظرة عن كثب على هذا الكمبيوتر",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "هذه هي المكونات الثلاثة التي ينبغي عليك البحث عنها عند اختيار كمبيوتر جديد. ومن خلال اتخاذ قرار بشأن طريقة استخدام الكمبيوتر الجديد، تكون قد قطعت شوطاً كبيراً نحو اتخاذ قرار بشأن أي من هذه المكونات الثلاثة الأساسية ستحتاج إليها. وهي كما يلي:",
                "titleArray": [
                  {
                    "tr_title": "أداء مخصص لشغيل الألعاب والمشاهدة مباشرة عبر الإنترنت",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "التخزين",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "الذاكرة",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "UWP",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/standard/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "كل وسائل الترفيه الخاصة بك. كمبيوتر واحد.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "لكمبيوتر يعمل أيضًا كمركز ترفيه، أنت بحاجة إلى مساحة تخزين كافية لكل الأغاني ومقاطع الفيديو والألعاب المفضلة لديك والمزيج المناسب بين المعالج والشاشة لإنشاء مرئيات غامرة. إن هذا الكمبيوتر مزود بالمكونات الثلاثة.",
                "titleArray": [
                  {
                    "tr_title": "جاهز للجيل التالي من المرئيات",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "سلاسة في تشغيل الألعاب والبث التدفقي",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الذاكرة",
              "tileUrlName": "memory",
              "tileBadgeUrl": "assets/images/standard/memory-tile.svg"
            },
            {
              "tr_tileTitle": "شاشة العرض",
              "tileUrlName": "display",
              "tileBadgeUrl": "assets/images/standard/display-tile.svg"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "تعددية المهام عالية السرعة",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تعددية المهام عالية السرعة",
                "tr_subtitle": "المزيد من العمل دون إبطاء",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتعددية المهام:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه نقل عدة برامج في آن واحد."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "ذاكرة تُبدل بين التطبيقات بسلاسة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "المحادثة عبر الفيديو",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "المحادثة عبر الفيديو",
                "tr_subtitle": "اتصالات واضحة تمامًا",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للمحادثة عبر الفيديو:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه تسجيل الصور ومشاركتها في الوقت ذاته."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "كاميرا ويب تساعدك على الوصول إلى رؤية واضحة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "جاهز لاستخدام الواقع الافتراضي",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "حيث يصبح الواقع الافتراضي حقيقة",
                "tr_subtitle": "ما هي الميزات المطلوبة لإنشاء عالم افتراضي بالكامل؟ في أجهزة الكمبيوتر، ستحتاج إلى التنسيق ما بين المعالج وبطاقة الرسوميات والذاكرة.",
                "titleArray": [
                  {
                    "tr_title": "القوة المحركة للعوالم الافتراضية",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "تتجلّى الحقيقة في التفاصيل",
                    "tr_title1": "انخرط فيما تفعله",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "تحرير مقاطع الفيديو",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تحرير مقاطع الفيديو",
                "tr_subtitle": "تمتع بسحر الأفلام",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتحرير مقاطع الفيديو:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه التعامل مع الملفات الكبيرة."
                  },
                  {
                    "tr_title": "ذاكرة تزيد من سرعة برامج التحرير واستجابتها."
                  },
                  {
                    "tr_title": "رسوميات تخفض من أوقات العرض."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تعددية المهام عالية السرعة",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تعددية المهام عالية السرعة",
                "tr_subtitle": "المزيد من العمل دون إبطاء",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتعددية المهام:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه نقل عدة برامج في آن واحد."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "ذاكرة تُبدل بين التطبيقات بسلاسة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "جاهز لاستخدام الواقع الافتراضي",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "حيث يصبح الواقع الافتراضي حقيقة",
                "tr_subtitle": "ما هي الميزات المطلوبة لإنشاء عالم افتراضي بالكامل؟ في أجهزة الكمبيوتر، ستحتاج إلى التنسيق ما بين المعالج وبطاقة الرسوميات والذاكرة.",
                "titleArray": [
                  {
                    "tr_title": "القوة المحركة للعوالم الافتراضية",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "تتجلّى الحقيقة في التفاصيل",
                    "tr_title1": "انخرط فيما تفعله",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "تصميم نماذج 3D",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تصميم نماذج 3D",
                "tr_subtitle": "المستوى التالي من الإبداعات",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتصميم نماذج 3D:",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه التعامل مع البرامج الإبداعية المتقدمة."
                  },
                  {
                    "tr_title": "ذاكرة يمكنها فتح الملفات الكبيرة بسرعة."
                  },
                  {
                    "tr_title": "رسوميات من أجل إنشاء الصور وتحريرها بقوة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "التعاون في الوقت الفعلي",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "التعاون في الوقت الفعلي",
                "tr_subtitle": "العمل من أي مكان",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للتعاون عبر الإنترنت:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "معالج يشغل برامج سطح المكتب."
                  },
                  {
                    "tr_title": "Wi‑Fi يمكنك الاعتماد عليه."
                  },
                  {
                    "tr_title": "كاميرا ويب تسجّل بجودة عالية رائعة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "جاهز لاستخدام الواقع الافتراضي",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "حيث يصبح الواقع الافتراضي حقيقة",
                "tr_subtitle": "ما هي الميزات المطلوبة لإنشاء عالم افتراضي بالكامل؟ في أجهزة الكمبيوتر، ستحتاج إلى التنسيق ما بين المعالج وبطاقة الرسوميات والذاكرة.",
                "titleArray": [
                  {
                    "tr_title": "القوة المحركة للعوالم الافتراضية",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "تتجلّى الحقيقة في التفاصيل",
                    "tr_title1": "انخرط فيما تفعله",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "EVO",
      "tilesDeviceTypes": [
        {
          "deviceType": "11GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "ليس من المفترض أن تكون أجهزة الكمبيوتر المحمولة الرفيعة خفيفة الوزن بهذا الشكل قوية على هذا النحو",
                "tr_subtitle": "تتمتع أجهزة الكمبيوتر المحمولة Intel® Evo™‎، التي صممت من أجل الأداء على الأجهزة المحمولة، بكل السرعة والرسوميات وعمر البطارية التي تحتاج إليها، وذلك كله في أروع التصاميم الرفيعة خفيفة الوزن.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "إنجاز المهام بسرعة",
                    "tr_subtitle": "استمتع بالأداء الفائق السرعة لمعالجات Intel®‎ Core™‎ من الجيل الحادي عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel®‎ Wi‑Fi 6 (Gig+)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "كل ما تحتاج إليه وأكثر في كمبيوتر محمول رفيع خفيف الوزن.",
                "tr_subtitle": "صُممت أجهزة الكمبيوتر المحمولة Intel® Evo™‎ من أجل الأداء على الأجهزة المحمولة ولمنحك أفضل تجربة<sup>2</sup>، بغض النظر عما تقوم به.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "أداء ثوري",
                    "tr_subtitle": "احصل على طاقة معززة عند أمس الحاجة إليها مع الأداء الذكي لمعالجات Intel® Core™‎ من الجيل الثاني عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel® Wi-Fi 6E (Gig +)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "11GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "ليس من المفترض أن تكون أجهزة الكمبيوتر المحمولة الرفيعة خفيفة الوزن بهذا الشكل قوية على هذا النحو",
                "tr_subtitle": "تتمتع أجهزة الكمبيوتر المحمولة Intel® Evo™‎، التي صممت من أجل الأداء على الأجهزة المحمولة، بكل السرعة والرسوميات وعمر البطارية التي تحتاج إليها، وذلك كله في أروع التصاميم الرفيعة خفيفة الوزن.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "إنجاز المهام بسرعة",
                    "tr_subtitle": "استمتع بالأداء الفائق السرعة لمعالجات Intel®‎ Core™‎ من الجيل الحادي عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel®‎ Wi‑Fi 6 (Gig+)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "كل ما تحتاج إليه وأكثر في كمبيوتر محمول رفيع خفيف الوزن.",
                "tr_subtitle": "صُممت أجهزة الكمبيوتر المحمولة Intel® Evo™‎ من أجل الأداء على الأجهزة المحمولة ولمنحك أفضل تجربة<sup>2</sup>، بغض النظر عما تقوم به.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "أداء ثوري",
                    "tr_subtitle": "احصل على طاقة معززة عند أمس الحاجة إليها مع الأداء الذكي لمعالجات Intel® Core™‎ من الجيل الثاني عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel® Wi-Fi 6E (Gig +)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "كل ما تحتاج إليه وأكثر في كمبيوتر محمول رفيع خفيف الوزن.",
                "tr_subtitle": "صُممت أجهزة الكمبيوتر المحمولة Intel® Evo™‎ من أجل الأداء على الأجهزة المحمولة ولمنحك أفضل تجربة<sup>2</sup>، بغض النظر عما تقوم به.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "أداء ثوري",
                    "tr_subtitle": "احصل على طاقة معززة عند أمس الحاجة إليها مع الأداء الذكي لمعالجات Intel® Core™‎ من الجيل الثالث عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel® Wi-Fi 6E (Gig +)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "أجهزة الكمبيوتر المحمولة Intel® Evo™‎",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "كل ما تحتاج إليه وأكثر في كمبيوتر محمول رفيع خفيف الوزن.",
                "tr_subtitle": "صُممت أجهزة الكمبيوتر المحمولة Intel® Evo™‎ من أجل الأداء على الأجهزة المحمولة ولمنحك أفضل تجربة<sup>2</sup>، بغض النظر عما تقوم به.",
                "titleArray": [
                  {
                    "tr_title": "الآن، أكثر من أي وقت مضى، أصبح للكمبيوتر المحمول أهمية كبرى، لذا حرصنا على أن تكون قدراته أكبر من أي وقت مضى.",
                    "tr_subtitle": "استخدم الشاشة باللمس للاستكشاف والدوران والتكبير/التصغير."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "بدء تشغيل بلمح البصر",
                    "tr_subtitle": "مع ميزة بدء التشغيل الفوري، يمكن للكمبيوتر الانتقال من وضع السكون إلى الاستعداد في أقل من ثانية."
                  },
                  {
                    "tr_title": "مشاهدة غامرة",
                    "tr_subtitle": "شاشة رائعة تضفي الحياة على المرئيات بفضل الدقة المذهلة والألوان الزاهية."
                  },
                  {
                    "tr_title": "أداء ثوري",
                    "tr_subtitle": "احصل على طاقة معززة عند أمس الحاجة إليها مع الأداء الذكي لمعالجات Intel® Core™‎ من الجيل الثالث عشر."
                  },
                  {
                    "tr_title": "فصل الطاقة لوقت تشغيل أطول",
                    "tr_subtitle": "تابع عملك بفضل كمبيوتر يطيل عمر البطارية ويعيد الشحن بلمح البصر."
                  },
                  {
                    "tr_title": "إمكانية الاتصال بكابل عام",
                    "tr_subtitle": "بات توصيل أجهزة أخرى بالكمبيوتر أمرًا بسيطًا وسريعًا وآمنًا بفضل تقنية Thunderbolt™‎ 4.‏<sup>10</sup>"
                  },
                  {
                    "tr_title": "اتصالات سريعة جديرة بالثقة",
                    "tr_subtitle": "تمكن من إجراء محادثة عبر الفيديو أو مشاركة الملفات باتصال يمكنك الاعتماد عليه مع Intel® Wi-Fi 6E (Gig +)‎.‏<sup>1</sup>"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "الإضاءة",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ما إصدار Intel® Evo™‎؟",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "ما سبب اختيار إصدار Intel® Evo™‎؟",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإبداع",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "كن أكثر إبداعًا في مزيد من الأماكن",
                    "preTitle": "",
                    "detailPageName": "morecreative",
                    "tileBadgeUrl": "assets/images/evo/redesign/morecreative-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/morecreative.mp4"
                  },
                  {
                    "tr_title": "حرر الصور بسرعة مطلقة",
                    "preTitle": "",
                    "detailPageName": "photoeditng",
                    "tileBadgeUrl": "assets/images/evo/redesign/photoeditng-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/photoeditng.mp4"
                  },
                  {
                    "tr_title": "أنشئ أعمالك الفنية الأصلية على الفور",
                    "preTitle": "",
                    "detailPageName": "originalArt",
                    "tileBadgeUrl": "assets/images/evo/redesign/originalArt-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/originalArt.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإنتاجية",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "حقق أقصى إنتاجية مع Rewind AI",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "اكتشف عمليات التزييف الاحترافي قبل المشاركة، باستخدام الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "إمكانية التنقل",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "لوِّح بيدك للتحكم في الإيماءات",
                    "preTitle": "gesturecontrol",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/gesturecontrol-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/gesturecontrol.mp4"
                  },
                  {
                    "tr_title": "عمر بطارية لن يؤخر عملك",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "حافظ تلقائيًا على اتصالك",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "الإضاءة",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "ما إصدار Intel® Evo™‎؟",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "ما سبب اختيار إصدار Intel® Evo™‎؟",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo7.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإبداع",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "تشغيل سريع وسلس للفيديو",
                    "preTitle": "",
                    "detailPageName": "videoplayback",
                    "tileBadgeUrl": "assets/images/evo/redesign/videoplayback-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/videoplayback.mp4"
                  },
                  {
                    "tr_title": "أنشئ أنجح الأغاني باستخدام قوة الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "powerAI",
                    "tileBadgeUrl": "assets/images/evo/redesign/power-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/power-ai.mp4"
                  },
                  {
                    "tr_title": "الطريقة الأسرع للحصول على النسخة النهائية المُعدلة",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/evo/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/fastestway.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "الإنتاجية",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "حقق أقصى إنتاجية مع Rewind AI",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "اكتشف عمليات التزييف الاحترافي قبل المشاركة، باستخدام الذكاء الاصطناعي",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "إمكانية التنقل",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "تعاون من أي مكان تقريبًا",
                    "preTitle": "",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/virtuallyanywhere7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/virtuallyanywhere7.mp4"
                  },
                  {
                    "tr_title": "عمر بطارية لن يؤخر عملك",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "حافظ تلقائيًا على اتصالك",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_11",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "كل وسائل الترفيه الخاصة بك. كمبيوتر واحد.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "لكمبيوتر يعمل أيضًا كمركز ترفيه، أنت بحاجة إلى مساحة تخزين كافية لكل الأغاني ومقاطع الفيديو والألعاب المفضلة لديك والمزيج المناسب بين المعالج والشاشة لإنشاء مرئيات غامرة. إن هذا الكمبيوتر مزود بالمكونات الثلاثة.",
                "titleArray": [
                  {
                    "tr_title": "تشغيل مبهر للألعاب ومشاهدة مذهلة مباشرة عبر الإنترنت",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "سلاسة في تشغيل الألعاب والبث التدفقي",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ابنِ مكتبتك الرقمية",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "نافذتك إلى عالم الترفيه",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ارفع مستوى إنتاجيتك. من أي مكان.",
              "tr_tileTitle1": "أنجز المزيد من المهام. بسرعة.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءاً من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر أيضاً نوع تقنية Wi&#8209;Fi الذي يسمح لك بالبقاء متصلاً بالإنترنت بالإضافة إلى بطارية مناسبة لإبقائك منفصلاً عن التيار الكهربائي.",
                "tr_subtitle1": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة والأداء ليساعدك في إنجاز المزيد من المهام في وقت أقل. فبفضل تقنية Wi-Fi الفائقة السرعة والمعالج القوي ذي السرعة المعززة بتوافر ذاكرة واسعة، ستصبح مهامك اليومية بغاية البساطة.",
                "tr_subtitle2": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءًا من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر نوع تقنية Wi‑Fi الذي يسمح لك بالبقاء متصلًا بالإنترنت بالإضافة إلى ذاكرة مناسبة لإنجاز المهام المتعددة.",
                "titleArray": [
                  {
                    "tr_title": "أداء ذكي مهم",
                    "tr_title1": "انطلق بسرعة مع الأداء الذكي",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "أفضل اتصالات في فئتها",
                    "tr_title1": "اتصل بالأمور المهمة",
                    "tr_title2": "تحسّن كبير في Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "فترة أطول من دون التوصيل بالكهرباء",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "تنقل بين البرامج كالمحترفين",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "حرية الإنشاء",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يُعدّ إنشاء المحتوى أكثر المهام تطلباً على كمبيوترك. ولحسن الحظ، تتمتع هذه المكونات بالقوة الكافية لتبسيط عملية الإنشاء.",
                "titleArray": [
                  {
                    "tr_title": "ابتكار مع نفحة من السرعة",
                    "tr_title1": "انسياب تام في المشاريع الإبداعية",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "ارتقِ إلى عالم جديد من الإنشاء",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "ذاكرة لتعددية المهام",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ألقِ نظرة عن كثب على هذا الكمبيوتر",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "هذه هي المكونات الثلاثة التي ينبغي عليك البحث عنها عند اختيار كمبيوتر جديد. ومن خلال اتخاذ قرار بشأن طريقة استخدام الكمبيوتر الجديد، تكون قد قطعت شوطاً كبيراً نحو اتخاذ قرار بشأن أي من هذه المكونات الثلاثة الأساسية ستحتاج إليها. وهي كما يلي:",
                "titleArray": [
                  {
                    "tr_title": "المعالج",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "التخزين",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "الذاكرة",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_12",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "حرية الإنشاء",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/creator/freedom_new.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يُعدّ إنشاء المحتوى أكثر المهام تطلباً على كمبيوترك. ولحسن الحظ، تتمتع هذه المكونات بالقوة الكافية لتبسيط عملية الإنشاء.",
                "titleArray": [
                  {
                    "tr_title": "طريقة أذكى للإنشاء",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "لتنبض صورك بالحياة",
                    "tr_title1": "هيا ننشئ",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "ذاكرة لتعددية المهام",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ارفع مستوى إنتاجيتك. من أي مكان.",
              "tr_tileTitle1": "أنجز المزيد من المهام. بسرعة.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءاً من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر أيضاً نوع تقنية Wi&#8209;Fi الذي يسمح لك بالبقاء متصلاً بالإنترنت بالإضافة إلى بطارية مناسبة لإبقائك منفصلاً عن التيار الكهربائي.",
                "tr_subtitle1": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة والأداء ليساعدك في إنجاز المزيد من المهام في وقت أقل. فبفضل تقنية Wi-Fi الفائقة السرعة والمعالج القوي ذي السرعة المعززة بتوافر ذاكرة واسعة، ستصبح مهامك اليومية بغاية البساطة.",
                "tr_subtitle2": "يتمتع هذا الكمبيوتر بالتوازن المثالي بين القوة وإمكانية الحمل. بدءًا من معالج مخصص للتصاميم الرفيعة خفيفة الوزن، يتضمن هذا الكمبيوتر نوع تقنية Wi‑Fi الذي يسمح لك بالبقاء متصلًا بالإنترنت بالإضافة إلى ذاكرة مناسبة لإنجاز المهام المتعددة.",
                "titleArray": [
                  {
                    "tr_title": "مصممة لإنجاز المزيد",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "أفضل اتصالات في فئتها",
                    "tr_title1": "اتصل بالأمور المهمة",
                    "tr_title2": "تحسّن كبير في Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "فترة أطول من دون التوصيل بالكهرباء",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "تنقل بين البرامج كالمحترفين",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "جاهز لاستخدام الواقع الافتراضي",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/creator/new_vr_gen12_creator.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "حيث يصبح الواقع الافتراضي حقيقة",
                "tr_subtitle": "ما هي الميزات المطلوبة لإنشاء عالم افتراضي بالكامل؟ في أجهزة الكمبيوتر، ستحتاج إلى التنسيق ما بين المعالج وبطاقة الرسوميات والذاكرة.",
                "titleArray": [
                  {
                    "tr_title": "القوة المحركة للعوالم الافتراضية",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "تتجلّى الحقيقة في التفاصيل",
                    "tr_title1": "انخرط فيما تفعله",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "بطارية مع طاقة تضاهي طاقتك.",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أبدع والعب وأنجز المهام، بشحنة واحدة.",
                "tr_subtitle": "مهما طالت قائمة مهامك، سيبقى جهازك في قمة أدائه. أنجز جميع مهامك دون الحاجة إلى التوصيل بالطاقة أو إبطاء السرعة أو البحث عن منفذ.",
                "detailBGUrl": "assets/images/battery_ptl_bg.png",
                "titleArray": [
                  {
                    "tr_title": "حافظ على الإنتاجية، حتى عند عدم الاتصال بالطاقة."
                  },
                  {
                    "tr_title": "احصل على أداء يواكب تنقلك."
                  },
                  {
                    "tr_title": "شغّل التطبيقات والألعاب التي يعجز الآخرون عن تشغيلها."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "أداء يواكب سرعتك.",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أداء يواكب سرعتك.",
                "tr_subtitle": "47 علامة تبويب مفتوحة، وثلاثة تطبيقات عرض، واجتماع يبدأ في غضون 30 ثانية. في أوقات كهذه، تحتاج إلى أداء أكثر برودة وأسرع استجابة وتحت سيطرتك بالكامل.",
                "detailBGUrl": "assets/images/performance_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "ألعاب فائقة الوضوح وأداء فائق السرعة",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ألعاب فائقة الوضوح وأداء فائق السرعة",
                "tr_subtitle": "العب الآلاف من ألعاب AAA والألعاب المستقلة باستخدام كمبيوتر محمول سريع الاستجابة ومصمم خصيصًا لطريقة اللعب الخاصة بك. دون تأخير أو تقطيع أو فقدان أي ميزة.",
                "detailBGUrl": "assets/images/gaming_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/images/aiExperience_ptl_bg.png",
                "tr_title": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
                "tr_subtitle": "بدءًا من تلخيص المستندات وتنظيم جدول أعمالك إلى تعزيز مكالمات الفيديو في الوقت الفعلي، ستحصل على المزيد من أدوات الذكاء الاصطناعي المخصصة لتسهيل المهام الصعبة وتوفير وقتك.",
                "titleArray": [
                  {
                    "tr_title": "احصل على تجارب Copilot+‎."
                  },
                  {
                    "tr_title": "متوافق مع معظم أدوات الذكاء الاصطناعي وتطبيقاته."
                  },
                  {
                    "tr_title": "جاهز لتجارب الذكاء الاصطناعي المستقبلية."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "رسوميات تجسد رؤيتك على أرض الواقع.",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "رسوميات تجسد رؤيتك على أرض الواقع.",
                "tr_subtitle": "أنشئ وحرر واعرض رسوميات عالية الدقة بسرعة باستخدام رسوميات مدمجة تبرز كل التفاصيل. تضمن التفاصيل الأدق والألوان الأعمق والأداء الأكثر سلاسة أن يظهر كل إبداع كما رسمته في خيالك.",
                "detailBGUrl": "assets/images/graphics_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
                "tr_subtitle": "تطبيقاتك المخصصة؟ تعمل ببساطة. ألعابك المفضلة؟ سلسة وجاهزة للعب. نتعاون مع كبار المطورين لضمان تشغيل عالمك الرقمي بشكل أفضل وأسرع وذكاء. <span class='ptl_compatibility_subtitle_text'>سواء كنت تقوم بتصميم لعبة جديدة أو تحريرها أو الغوص فيها، ستحصل على أداء سلس عبر الأدوات التي تعتمد عليها. بدون تأخير أو أعطال أو تخمين.</span>",
                "detailBGUrl": "assets/images/compatibility_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "تصميمات تعكس أسلوبك.",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "تصميمات تعكس أسلوبك.",
                "tr_subtitle": "ينبغي أن يعمل جهازك ويبدو بالشكل الذي تفضله. ستشعر أن جهازك يعبّر عنك تمامًا منذ اليوم الأول، وذلك بفضل مجموعة كبيرة من الألوان والأحجام والشاشات التي تعمل باللمس أو تصميمات 2 في 1 للاختيار من بينها.",
                "detailBGUrl": "assets/images/design_ptl_bg.png"
              }
            },
            {
              "tr_tileTitle": "أفضل تجربة متكاملة لأجهزة الكمبيوتر المحمولة.<sup>1</sup>",
              "tileUrlName": "ptl-evo",
              "tileBadgeUrl": "assets/images/evo_ptl_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أفضل تجربة متكاملة لأجهزة الكمبيوتر المحمولة.<sup>1</sup>",
                "tr_subtitle": "تم التحقق من كفاءة كل كمبيوتر محمول Intel® Evo™‎ Edition نحيف وخفيف لتقديم تجربة استثنائية تتميز بجاهزية تامة وسرعة فائقة في كل وقت ومصممة لتناسب المستقبل.",
                "detailBGUrl": "assets/images/evo_ptl_bg.svg",
                "titleArray": [
                  {
                    "tr_title": "أداء أثناء التنقل."
                  },
                  {
                    "tr_title": "عمر بطارية واقعي."
                  },
                  {
                    "tr_title": "شحن سريع."
                  },
                  {
                    "tr_title": "بدء تشغيل فوري من وضع السكون."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "نسخة منك، أسرع وأقوى.",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE_12XE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "لم يعد حجم الكمبيوتر عائقًا أمام أفكارك الكبيرة.",
              "tileUrlName": "ptl-performance",
              "tileBadgeUrl": "assets/images/performance_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أداء رسوميات استثنائي لن تصدقه إلا عندما تجرّبه.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/performance_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "رسوميات تضاهي جودة الأستوديو في تصميمات فائقة الأناقة."
                  },
                  {
                    "tr_title": "أسرع وأهدأ وجاهز عندما يجيئك الإلهام."
                  },
                  {
                    "tr_title": "عمر بطارية بقوّة أفكارك وطموحاتك."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "أخيرًا، بطارية لن تعوق إبداعك.",
              "tileUrlName": "ptl-battery",
              "tileBadgeUrl": "assets/images/battery_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أخيرًا، بطارية لن تعوق إبداعك.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/battery_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "رسوميات بجودة الأستوديو ترافقك أينما ذهبت."
                  },
                  {
                    "tr_title": "مصمم للإبداع وتشغيل الألعاب طوال اليوم."
                  },
                  {
                    "tr_title": "تصميمات رفيعة خفيفة الوزن دون التضحية بأي ميزة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "استمتع بألعاب Battlefield*‎ 6 وEverwind*‎ وغيرها",
              "tileUrlName": "ptl-softwarebundle",
              "tileBadgeUrl": "assets/images/software_bundle_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "ptl-tile1-panel",
                "tr_title": "أنشئ المحتوى نهارًا<br/>والعب ليلًا.",
                "tr_title1": "<span class='processor_bold'>معالج Intel® Core™ Ultra [XX] </span>مع رسوميات <span class='processor_bold'>Intel® Arc™‎ مدمجة</span>",
                "tr_subtitle": "احصل على إمكانية الوصول إلى Battlefield*‎ 6 وأيضًا Everwind*‎ وكذلك Adobe*‎ من خلال شراء أجهزة مؤهلة مستندة إلى معالج Intel®‎ Core™‎ Ultra [XX].",
                "detailBGUrl": "assets/images/software_bundle_ptl12xe_bg.png",
                "badgeUrl1": "assets/images/arc-badge.svg",
                "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                "tr_subtitle1": "اختر اشتراكًا لمدة 6 أشهر:",
                "titleArray": [
                  {
                    "tr_title": "خطة Adobe Creative Cloud Photography",
                    "imgUrl": "assets/images/ptl_adobe_cloud.svg"
                  },
                  {
                    "tr_title": "Adobe Premiere Pro",
                    "imgUrl": "assets/images/ptl_adobe_premiere.svg"
                  }
                ],
                "tr_subtitle2": "©‎ 2025 Electronic Arts Inc. Battlefield هي علامة تجارية لشركة Electronic Arts Inc. ©‎ 2025 BOHEMIA INTERACTIVE a.s. ©‎ 2025 Adobe. جميع الحقوق محفوظة. ©‎ Intel Corporation. يمكن الاسترداد بحلول 15 يوليو 2026. تطبق الشروط."
              }
            },
            {
              "tr_tileTitle": "أنشئ المحتوى نهارًا والعب ليلًا.",
              "tileUrlName": "ptl-gaming",
              "tileBadgeUrl": "assets/images/gaming_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "أنشئ المحتوى نهارًا والعب ليلًا.",
                "tr_subtitle": "",
                "detailBGUrl": "assets/images/gaming_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "رسوميات جاهزة للألعاب، وتصميمات فائقة الأناقة."
                  },
                  {
                    "tr_title": "شغّل ألعابك وتطبيقاتك المفضلة."
                  },
                  {
                    "tr_title": "استمتع باللعب أينما أردت."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
              "tileUrlName": "ptl-aiexperience",
              "tileBadgeUrl": "assets/images/ai_experience_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ذكاء اصطناعي مصمَّم لأسلوب عملك.",
                "tr_subtitle": "بدءًا من تلخيص المستندات وتنظيم جدول أعمالك إلى تعزيز مكالمات الفيديو في الوقت الفعلي، ستحصل على المزيد من أدوات الذكاء الاصطناعي المخصصة لتسهيل المهام الصعبة وتوفير وقتك.",
                "detailBGUrl": "assets/images/aiExperience_ptl12xe_bg.png",
                "titleArray": [
                  {
                    "tr_title": "نظام يمكنك الاعتماد عليه."
                  },
                  {
                    "tr_title": "جاهز للعمل فورًا، دون عناء الإعداد."
                  },
                  {
                    "tr_title": "حماية متكاملة تمنحك راحة البال."
                  },
                  {
                    "tr_title": "أمان استباقي يسبق التهديدات بخطوة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "رسومات مدمجة تقدّم أداءً يفوق التوقعات.",
              "tileUrlName": "ptl-graphics",
              "tileBadgeUrl": "assets/images/graphics_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "رسومات مدمجة تقدّم أداءً يفوق التوقعات.",
                "tr_subtitle": "لا تستهن بقوة الرسوميات المدمجة. ستحصل على السرعة اللازمة لتشغيل الألعاب والتحرير والعرض والبث التدفقي دون تكلفة أو وزن أو استنزاف البطارية الذي تسببه وحدة معالجة الرسوميات المخصصة، وذلك بفضل زيادة قدرها 50% في أساسات Intel® Arc™ X<sup>e</sup>. بالنسبة إلى العديد من منشئي المحتوى ومشغلي الألعاب، فإن الرسوميات المدمجة توفر كل الطاقة التي تحتاج إليها.",
                "detailBGUrl": "assets/images/graphics_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
              "tileUrlName": "ptl-compatibility",
              "tileBadgeUrl": "assets/images/compatibility_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "شغّل التطبيقات والألعاب التي لا يستطيع الآخرون تشغليها.",
                "tr_subtitle": "تطبيقاتك المخصصة؟ تعمل ببساطة. ألعابك المفضلة؟ سلسة وجاهزة للعب. نتعاون مع كبار المطورين لضمان تشغيل عالمك الرقمي بشكل أفضل وأسرع وذكاء. <span class='ptl_compatibility_subtitle_text'>سواء كنت تقوم بتصميم لعبة جديدة أو تحريرها أو الغوص فيها، ستحصل على أداء سلس عبر الأدوات التي تعتمد عليها. بدون تأخير أو أعطال أو تخمين.</span>",
                "detailBGUrl": "assets/images/compatibility_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "تصميمات تعكس أسلوبك.",
              "tileUrlName": "ptl-design",
              "tileBadgeUrl": "assets/images/design_ptl12xe_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "تصميمات تعكس أسلوبك.",
                "tr_subtitle": "ينبغي أن يعمل جهازك ويبدو بالشكل الذي تفضله. ستشعر أن جهازك يعبّر عنك تمامًا منذ اليوم الأول، وذلك بفضل مجموعة كبيرة من الألوان والأحجام والشاشات التي تعمل باللمس أو تصميمات 2 في 1 للاختيار من بينها.",
                "detailBGUrl": "assets/images/design_ptl12xe_bg.png"
              }
            },
            {
              "tr_tileTitle": "لم يعد حجم الكمبيوتر عائقًا أمام أفكارك الكبيرة.",
              "tileUrlName": "ptl-processor",
              "tileBadgeUrl": "assets/images/processor_ptl12xe_tile.png"
            }
          ]
        }
      ]
    }
  ],
  "samsungOled": [
    {
      "panelType": "oled_first_panel",
      "badgeUrl": "assets/images/oled/OLED_logo.svg"
    },
    {
      "panelType": "oled_second_panel",
      "tr_header": "شاشات OLED من Samsung:<br/>متعة النظر",
      "tr_sub_header": "قد يتسبب الضوء الأزرق في إزعاج بصري ويؤرق دورة النوم. تقدم شاشات OLED من Samsung، التي اختبرتها SGS لدعم الشاشات بميزة راحة العين، المساعدة، لا عن طريق تغيير الألوان، بل بتقليل الطول الموجي للضوء الأزرق المتوقع ضرره، وهذا يُريح العين ويقلل من إرهاقها.",
      "badgeUrl": "assets/images/oled/oled-graph.svg",
      "tr_title1": "انخفاض الضوء الأزرق الضار"
    },
    {
      "panelType": "oled_third_panel",
      "tr_header": "فائقة من كل الجوانب",
      "tr_sub_header": "تزيد شاشات OLED الخفيفة الوزن ذات التصميم النحيف للغاية من جودة الصور إلى أقصى حد مع تقليل الوزن."
    },
    {
      "panelType": "oled_fourth_panel",
      "tr_header": "أسود قاتم",
      "tr_sub_header": "0.0005 نيت"
    },
    {
      "panelType": "oled_fifth_panel",
      "tr_header": "<span class='conventional_text'>الشاشات التقليدية تعادل</span><br/>74%",
      "tr_sub_header": "<span class='samsungoled_text'>شاشات OLED من Samsung تعادل </span><br/>120%"
    }
  ],
  "rebuildUsageModel": [
    {
      "tilesType": "STANDARD_REBUILD_I3",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "البث",
              "tileUrlName": "streaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/streaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_streaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "البث التدفقي",
                "tr_subtitle": "ترفيه لا مثيل له",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للبث التدفقي:",
                "tileBG": "#794584",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه البث بجودة عالية."
                  },
                  {
                    "tr_title": "شاشة لعرض صور جميلة ومشرقة."
                  },
                  {
                    "tr_title": "Wi‑Fi يقلل من أوقات التخزين المؤقت والتحميل."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "استعراض الويب",
              "tileUrlName": "webbrowsing",
              "tileBadgeUrl": "assets/images/standard/rebuild/webbrowsing.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_webbrowsing.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "استعراض الويب",
                "tr_subtitle": "أصبح الإنترنت أمرًا سهلًا",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لاستعراض الويب:",
                "tileBG": "#87A944",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه تحميل الصفحات الذاخرة بالوسائط بسرعة."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والموثوقية."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "المحادثة عبر الفيديو",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "المحادثة عبر الفيديو",
                "tr_subtitle": "اتصالات واضحة تمامًا",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للمحادثة عبر الفيديو:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه تسجيل الصور ومشاركتها في الوقت ذاته."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "كاميرا ويب تساعدك على الوصول إلى رؤية واضحة."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "تعددية المهام عالية السرعة",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تعددية المهام عالية السرعة",
                "tr_subtitle": "المزيد من العمل دون إبطاء",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتعددية المهام:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه نقل عدة برامج في آن واحد."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "ذاكرة تُبدل بين التطبيقات بسلاسة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "المحادثة عبر الفيديو",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "المحادثة عبر الفيديو",
                "tr_subtitle": "اتصالات واضحة تمامًا",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للمحادثة عبر الفيديو:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه تسجيل الصور ومشاركتها في الوقت ذاته."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "كاميرا ويب تساعدك على الوصول إلى رؤية واضحة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تشغيل الألعاب العادية",
              "tileUrlName": "casualgaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/casualgaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_casualgaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تشغيل الألعاب العادية",
                "tr_subtitle": "حان وقت اللعب",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتشغيل الألعاب الخفيفة:",
                "tileBG": "#000000",
                "titleArray": [
                  {
                    "tr_title": "معالج يوفر تجربة تشغيل ألعاب سلسلة."
                  },
                  {
                    "tr_title": "ذاكرة تتحمل الدردشة الصوتية والبث في الوقت ذاته."
                  },
                  {
                    "tr_title": "رسوميات تشغّل صورًا رائعةً."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تحرير الصور",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تحرير الصور",
                "tr_subtitle": "صور بجودة مثالية",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتحرير الصور:",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "معالج يتمتع بالقدرة على تحرير مجموعات كبيرة من الصور."
                  },
                  {
                    "tr_title": "ذاكرة تسرّع برنامج التحرير لديك."
                  },
                  {
                    "tr_title": "تمكّنك تقنية Thunderbolt™‎ 4‎ من نقل الملفات بسرعة."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "تعددية المهام عالية السرعة",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تعددية المهام عالية السرعة",
                "tr_subtitle": "المزيد من العمل دون إبطاء",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتعددية المهام:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه نقل عدة برامج في آن واحد."
                  },
                  {
                    "tr_title": "Wi‑Fi يتسم بالسرعة والقوة والموثوقية."
                  },
                  {
                    "tr_title": "ذاكرة تُبدل بين التطبيقات بسلاسة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "التعاون في الوقت الفعلي",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "التعاون في الوقت الفعلي",
                "tr_subtitle": "العمل من أي مكان",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للتعاون عبر الإنترنت:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "معالج يشغل برامج سطح المكتب."
                  },
                  {
                    "tr_title": "Wi‑Fi يمكنك الاعتماد عليه."
                  },
                  {
                    "tr_title": "كاميرا ويب تسجّل بجودة عالية رائعة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تحرير مقاطع الفيديو",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تحرير مقاطع الفيديو",
                "tr_subtitle": "تمتع بسحر الأفلام",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتحرير مقاطع الفيديو:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه التعامل مع الملفات الكبيرة."
                  },
                  {
                    "tr_title": "ذاكرة تزيد من سرعة برامج التحرير واستجابتها."
                  },
                  {
                    "tr_title": "رسوميات تخفض من أوقات العرض."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تحرير الصور",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تحرير الصور",
                "tr_subtitle": "صور بجودة مثالية",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتحرير الصور:",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "معالج يتمتع بالقدرة على تحرير مجموعات كبيرة من الصور."
                  },
                  {
                    "tr_title": "ذاكرة تسرّع برنامج التحرير لديك."
                  },
                  {
                    "tr_title": "تمكّنك تقنية Thunderbolt™‎ 4‎ من نقل الملفات بسرعة."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "تحرير مقاطع الفيديو",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تحرير مقاطع الفيديو",
                "tr_subtitle": "تمتع بسحر الأفلام",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتحرير مقاطع الفيديو:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه التعامل مع الملفات الكبيرة."
                  },
                  {
                    "tr_title": "ذاكرة تزيد من سرعة برامج التحرير واستجابتها."
                  },
                  {
                    "tr_title": "رسوميات تخفض من أوقات العرض."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "تصميم نماذج 3D",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "تصميم نماذج 3D",
                "tr_subtitle": "المستوى التالي من الإبداعات",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع لتصميم نماذج 3D:",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "معالج يمكنه التعامل مع البرامج الإبداعية المتقدمة."
                  },
                  {
                    "tr_title": "ذاكرة يمكنها فتح الملفات الكبيرة بسرعة."
                  },
                  {
                    "tr_title": "رسوميات من أجل إنشاء الصور وتحريرها بقوة."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "التعاون في الوقت الفعلي",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "التعاون في الوقت الفعلي",
                "tr_subtitle": "العمل من أي مكان",
                "tr_subtitle1": "إليك ما وجدناه في هذا الكمبيوتر الشخصي الرائع للتعاون عبر الإنترنت:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "معالج يشغل برامج سطح المكتب."
                  },
                  {
                    "tr_title": "Wi‑Fi يمكنك الاعتماد عليه."
                  },
                  {
                    "tr_title": "كاميرا ويب تسجّل بجودة عالية رائعة."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "unison": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "unison-panel",
    "tr_tileTitle": "تطبيق Intel®‎ Unison™‎",
    "tr_title": "أطلق العنان لخيالك عبر الإنترنت",
    "tr_subtitle": "قم بنقل الملفات والصور بسلاسة دون التوقف عن متابعة إشعارات الهاتف والمكالمات والرسائل من جهاز الكمبيوتر الخاص بك.<sup>18</sup>",
    "detailBGUrl": "assets/images/unison/unison_panel1_img.png",
    "tileBG": "assets/images/unison/unison_hometile_img.png",
    "titleArray": [
      {
        "tr_title": "نقل الملفات والصور",
        "imgUrl": "assets/images/unison/unison_img1.png"
      },
      {
        "tr_title": "إجراء المكالمات وتلقيها",
        "imgUrl": "assets/images/unison/unison_img2.png"
      },
      {
        "tr_title": "إرسال الرسائل النصية وتلقيها",
        "imgUrl": "assets/images/unison/unison_img3.png"
      },
      {
        "tr_title": "إدارة إشعارات الهاتف",
        "imgUrl": "assets/images/unison/unison_img4.png"
      },
      {
        "tr_title": "أطلق العنان لخيالك عبر الإنترنت",
        "imgUrl": "assets/images/unison/unison_img5.png"
      }
    ]
  },
  "copilot": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "copilot-panel",
    "tr_tileTitle": "أنجز المزيد باستخدام Copilot+‎",
    "tr_title": "<strong><span class ='copilot_highlight'>احصل على المزيد</span> من أجهزة الكمبيوتر الشخصية Copilot+‎</strong> مع معالج [cpu_display] [cpuModel]",
    "badgeUrl": "assets/images/copilot_badge.png",
    "tileBG": "assets/images/copilot_hometile_img.png",
    "videoUrl": "assets/lang/[XX]/redesign/copilot_panel4.mp4",
    "detailBGUrl": "",
    "tr_pretitle": "Copilot+‎",
    "badgeIcons": [
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
        "tr_badgeIconTile": "معالج Intel®&nbsp;Core™ Ultra&nbsp;5 (السلسلة&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
        "tr_badgeIconTile": "معالج Intel®&nbsp;Core™ Ultra&nbsp;7 (السلسلة&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
        "tr_badgeIconTile": "معالج Intel® Core™ Ultra 9 (السلسلة 2)",
        "tr_badgeSubTitle": ""
      }
    ],
    "titleArray": [
      {
        "tr_title": "التسميات التوضيحية المباشرة",
        "tr_subtitle": "ترجمة 44 لغة إلى الإنجليزية. <span class ='copilot_subhighlight'>بكل سهولة.</span>",
        "imgUrl": "assets/images/copilot_panel1.png"
      },
      {
        "tr_title": "Cocreator",
        "tr_subtitle": "ارسم الفكرة، وسيحققها الذكاء الاصطناعي بإتقان. <span class ='copilot_subhighlight'>بشكل أسرع.</span>",
        "imgUrl": "assets/images/copilot_panel2.png"
      },
      {
        "tr_title": "Windows* Studio Effects",
        "tr_subtitle": "أظهر أفضل ما لديك. <span class ='copilot_subhighlight'>دون جهد.</span>",
        "imgUrl": "assets/images/copilot_panel3.png"
      }
    ]
  },
  "deviceReview": {
    "panelType1": "evo-mtl-video-panel",
    "tr_tileTitle": "شاهد مراجعة [XX]",
    "tileBG": "assets/images/device_review_hometile.svg",
    "videoUrl": "assets/lang/[XX]/redesign/device_review_video.mp4"
  }
}